webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1004),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1014),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1010),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(889)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1006),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kort topspacing",
    staticStyle: {
      "margin-top": "55.4px"
    }
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "height": "55.4px"
    }
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 240.823 240.823",
      "vertical-align": "-3px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 240.823 240.823",
      "xml:space": "preserve",
      "width": "18px",
      "height": "18px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "id": "Chevron_Right",
      "d": "M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179   l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816   C52.942,116.507,52.942,124.327,57.633,129.007z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v(" "), _c('h1', [_vm._v("Kort")]), _vm._v(" "), _c('div', {
    staticClass: "right selected-date"
  }, [(_vm.selectedDate != null || _vm.selectedDate != undefined) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.selectedDate)))]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.today)))])])]), _vm._v(" "), _c('mapcomponent')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1005:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.overlay),
      expression: "overlay"
    }],
    staticClass: "overlay",
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.syncOverlay),
      expression: "syncOverlay"
    }],
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "counter text-center"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Trin " + _vm._s(_vm.activeStep) + " ud af " + _vm._s(_vm.totalSteps))]), _vm._v(" "), (_vm.errorMessage.length > 0) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])]), _vm._v(" "), _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.showMenu
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")]), _vm._v(" "), (_vm.notification > 0) ? _c('p', {
    staticClass: "small-icon notification"
  }, [_vm._v("!")]) : _vm._e()]), _vm._v(" "), _c('h1', [_vm._v("Opgaver")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": _vm.gotoMap
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 533.333 533.333"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 533.333 533.333",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M455.229,78.105c50.367,50.367,78.104,117.333,78.104,188.563c0,71.229-27.739,138.194-78.104,188.561   c-50.368,50.366-117.333,78.104-188.562,78.104c-71.229,0-138.195-27.738-188.562-78.104C27.738,404.862,0,337.896,0,266.668   c0-71.229,27.736-138.196,78.104-188.563S195.438,0,266.667,0C337.896,0,404.861,27.738,455.229,78.105z M431.658,431.659   c32.843-32.843,54.681-73.754,63.686-118.262c-7.019,10.331-13.732,14.165-17.888-8.961c-4.281-37.703-38.911-13.618-60.688-27.011   c-22.919,15.447-74.43-30.032-65.676,21.263c13.507,23.137,72.921-30.964,43.307,17.99   c-18.893,34.176-69.085,109.86-62.555,149.093c0.823,57.158-58.404,11.919-78.81-7.041   c-13.727-37.979-4.678-104.362-40.572-122.962c-38.959-1.691-72.398-5.232-87.497-48.786c-9.086-31.161,9.669-77.549,43.062-84.71   c48.88-30.711,66.341,35.965,112.183,37.205c14.233-14.893,53.029-19.628,56.246-36.328c-30.078-5.308,38.16-25.291-2.879-36.657   c-22.642,2.663-37.229,23.476-25.193,41.124c-43.874,10.23-45.279-63.492-87.454-40.238c-1.072,36.765-68.865,11.919-23.456,4.464   c15.602-6.816-25.448-26.57-3.271-22.98c10.894-0.592,47.569-13.444,37.644-22.084c20.421-12.677,37.583,30.359,57.572-0.98   c14.431-24.097-6.052-28.546-24.141-16.332c-10.198-11.418,18.006-36.081,42.882-46.738c8.29-3.552,16.208-5.487,22.263-4.939   c12.531,14.475,35.703,16.982,36.916-1.741c-31.031-14.861-65.247-22.712-100.672-22.712c-50.845,0-99.203,16.158-139.223,46.036   c10.755,4.927,16.86,11.062,6.499,18.904c-8.05,23.987-40.713,56.186-69.387,51.627c-14.889,25.674-24.694,53.961-28.885,83.608   c24.016,7.946,29.554,23.672,24.394,28.932c-12.237,10.671-19.759,25.797-23.633,42.355c7.817,47.832,30.298,91.914,65.245,126.862   C145.746,475.729,204.34,500,266.667,500C328.992,500,387.587,475.729,431.658,431.659z",
      "fill": "#FFFFFF"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidemenu fast",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "sidemenu",
      "data-toggler": "",
      "data-animate": "slide-in-left slide-out-left"
    }
  }, [_c('div', {
    staticClass: "close-button",
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "active",
    attrs: {
      "id": "projekter"
    }
  }, [_c('a', {
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.gotoProjects
    }
  }, [_vm._m(2), _vm._v("\n          Opgaver\n        ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "kort"
    }
  }, [_c('a', {
    staticClass: "map-item",
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.gotoMap
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 533.333 533.333"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 533.333 533.333",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M455.229,78.105c50.367,50.367,78.104,117.333,78.104,188.563c0,71.229-27.739,138.194-78.104,188.561   c-50.368,50.366-117.333,78.104-188.562,78.104c-71.229,0-138.195-27.738-188.562-78.104C27.738,404.862,0,337.896,0,266.668   c0-71.229,27.736-138.196,78.104-188.563S195.438,0,266.667,0C337.896,0,404.861,27.738,455.229,78.105z M431.658,431.659   c32.843-32.843,54.681-73.754,63.686-118.262c-7.019,10.331-13.732,14.165-17.888-8.961c-4.281-37.703-38.911-13.618-60.688-27.011   c-22.919,15.447-74.43-30.032-65.676,21.263c13.507,23.137,72.921-30.964,43.307,17.99   c-18.893,34.176-69.085,109.86-62.555,149.093c0.823,57.158-58.404,11.919-78.81-7.041   c-13.727-37.979-4.678-104.362-40.572-122.962c-38.959-1.691-72.398-5.232-87.497-48.786c-9.086-31.161,9.669-77.549,43.062-84.71   c48.88-30.711,66.341,35.965,112.183,37.205c14.233-14.893,53.029-19.628,56.246-36.328c-30.078-5.308,38.16-25.291-2.879-36.657   c-22.642,2.663-37.229,23.476-25.193,41.124c-43.874,10.23-45.279-63.492-87.454-40.238c-1.072,36.765-68.865,11.919-23.456,4.464   c15.602-6.816-25.448-26.57-3.271-22.98c10.894-0.592,47.569-13.444,37.644-22.084c20.421-12.677,37.583,30.359,57.572-0.98   c14.431-24.097-6.052-28.546-24.141-16.332c-10.198-11.418,18.006-36.081,42.882-46.738c8.29-3.552,16.208-5.487,22.263-4.939   c12.531,14.475,35.703,16.982,36.916-1.741c-31.031-14.861-65.247-22.712-100.672-22.712c-50.845,0-99.203,16.158-139.223,46.036   c10.755,4.927,16.86,11.062,6.499,18.904c-8.05,23.987-40.713,56.186-69.387,51.627c-14.889,25.674-24.694,53.961-28.885,83.608   c24.016,7.946,29.554,23.672,24.394,28.932c-12.237,10.671-19.759,25.797-23.633,42.355c7.817,47.832,30.298,91.914,65.245,126.862   C145.746,475.729,204.34,500,266.667,500C328.992,500,387.587,475.729,431.658,431.659z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v("\n          Kort\n        ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.syncData
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sync")]), _vm._v(" "), (_vm.notification > 0) ? _c('p', {
    staticClass: "notification"
  }, [_vm._v("!")]) : _vm._e()]), _vm._v("\n          Synkronisér\n        ")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-open": "aboutModal",
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.gotoAbout
    }
  }, [_vm._m(4), _vm._v("\n          Om MålerTjek\n        ")])])])]), _vm._v(" "), (_vm.showModal) ? _c('help-modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reveal",
    attrs: {
      "id": "aboutModal",
      "data-reveal": ""
    }
  }, [_c('div', {
    staticClass: "reveal-header special-text"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(234),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("V. " + _vm._s(_vm.version) + ", udgivet " + _vm._s(_vm.date))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('img', {
    staticClass: "niras-logo",
    attrs: {
      "src": __webpack_require__(989),
      "alt": "Niras logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reveal-footer"
  }, [_vm._m(6), _vm._v(" "), _c('img', {
    staticClass: "firm-logo",
    attrs: {
      "src": _vm.image
    }
  })]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('main', {
    attrs: {
      "role": "main"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Synkroniserer data"), _c('span', {
    staticClass: "loading-overview"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-menu"
  }, [_c('h2', [_c('b', [_vm._v("Måler")]), _vm._v("tjek")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("assignment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "./files/MålertjekVejledning.pdf",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("help")])]), _vm._v("\n          Hjælp\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reveal-body"
  }, [_c('h5', [_vm._v("MålerTjek™ - programmet, der rationaliserer kontrol og udskiftning af forbrugsmålere.")]), _vm._v(" "), _c('p', [_vm._v("NIRAS har udviklet et system, der rationaliserer arbejdsopgaver vedrørende kontrol og udskiftning af forbrugsmålere i forsyningssektoren. Programmet hedder MålerTjek, og med det fjerner du tidsrøvere og gør samtidig livet lettere for både forsyningernes montører og deres administration samt for borgerne. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Har du brug for support til MålerTjek, kan du ringe på support-telefonen "), _c('b', [_vm._v("2857 5859")]), _vm._v(" eller sende en e-mail til "), _c('a', {
    attrs: {
      "href": "mailto:infosupport@niras.dk?Subject=MålerTjek",
      "target": "_top"
    }
  }, [_vm._v("infosupport@niras.dk")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "velkommen topspacing"
  }, [(_vm.showLoader) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "counter"
  }, [(_vm.errorMessage.length == 0) ? _c('div', [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Trin " + _vm._s(_vm.activeStep) + " af " + _vm._s(_vm.totalSteps))])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage.length > 0) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm.errorMessage) + "\n                    "), _c('a', {
    staticClass: "button error-button",
    on: {
      "click": _vm.closeError
    }
  }, [_vm._v("Okay")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid-x grid-padding-x"
  }, [_c('div', {
    staticClass: "large-12 cell"
  }, [_c('section', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content text-center"
  }, [_c('p', [_vm._v("\n                            NIRAS har udviklet et system, der rationaliserer arbejdsopgaver vedrørende kontrol og udskiftning af forbrugsmålere i forsyningssektoren. Programmet hedder MålerTjek, og med det fjerner du tidsrøvere og gør samtidig livet lettere for både forsyningernes montører og deres administration samt for borgerne. \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center download-container"
  }, [_c('a', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.getServerData
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")]), _vm._v("Hent app")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Installerer MålerTjek app'en "), _c('span', {
    staticClass: "loading-overview"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    staticStyle: {
      "height": "55.4px"
    }
  }, [_c('h1', [_vm._v("Hent indstillinger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-welcome"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(234),
      "alt": "logo"
    }
  })])
}]}

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_vm._m(0), _vm._v(" "), (_vm.step1) ? _c('div', [_c('div', {
    staticClass: "top-image step1"
  }), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h3', [_vm._v("Indtast din nøgle")]), _vm._v(" "), _c('p', [_vm._v("For at kunne finde ud af hvilken forsyning, som du hører til, skal vi bruge en nøgle. Tryk på knappen nedenfor for at validere nøglen.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key),
      expression: "key"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Nøgle"
    },
    domProps: {
      "value": (_vm.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button",
    staticStyle: {
      "max-height": "38px",
      "height": "38px"
    },
    on: {
      "click": _vm.validateKey
    }
  }, [(!_vm.downloading) ? _c('span', [_vm._v("Validér nøgle")]) : _vm._e(), _vm._v(" "), (_vm.downloading) ? _c('span', [_c('div', {
    staticClass: "loading-spinner"
  }), _vm._v("   Validerer...")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])]) : _vm._e(), _vm._v(" "), (_vm.step2) ? _c('div', [_c('div', {
    staticClass: "top-image step2"
  }), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h3', [_vm._v("Vælg montør")]), _vm._v(" "), _c('p', [_vm._v("For at optimere din brugeroplevelse og sikre korrekt data, skal du fortælle os, hvem du er. Dette gøres i dropdown-feltet nedenfor.")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "selected"
    }
  }, [_vm._v("Vælg en montør")]), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                        " + _vm._s(option.navn) + "\n                    ")])
  })], 2), _vm._v(" "), _c('a', {
    staticClass: "button",
    class: {
      disabled: _vm.empty
    },
    on: {
      "click": _vm.chooseUser
    }
  }, [_vm._v("Næste")]), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('p', {
    staticClass: "goback",
    on: {
      "click": _vm.gotoStep1
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")]), _vm._v(" \n                Tilbage\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.step3) ? _c('div', [_c('div', {
    staticClass: "top-image step3"
  }), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h3', [_vm._v("Hent app'en og kom i gang")]), _vm._v(" "), _c('p', [_vm._v("Du er nu klar til at komme i gang. Tryk på knappen nedenfor for at hente nødvendige data ned på din enhed, så det fungerer uden internet og sikrer en bedre brugeroplevelse")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.getServerData
    }
  }, [_vm._v("Hent app")]), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('p', {
    staticClass: "goback",
    on: {
      "click": _vm.gotoStep2
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")]), _vm._v(" \n                Tilbage\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.showLoader) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "counter"
  }, [(_vm.errorMessage.length == 0) ? _c('div', [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "small-text-loading"
  }, [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage.length > 0) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm.errorMessage) + "\n                    "), _c('a', {
    staticClass: "button error-button",
    on: {
      "click": _vm.closeError
    }
  }, [_vm._v("Okay")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "steps"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.step1
    }
  }), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step2
    }
  }), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step3
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-top"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(234),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Installerer MålerTjek-app'en "), _c('span', {
    staticClass: "loading-overview"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])])
}]}

/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.doneLoading) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-map', {
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('v-tilelayer', {
    attrs: {
      "url": _vm.url,
      "attribution": _vm.attribution
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(item) {
    return _c('div', [_c('v-marker', {
      attrs: {
        "lat-lng": item.coordinates,
        "icon": item.icon
      }
    }, [_c('v-popup', {
      attrs: {
        "content": item.popup
      }
    }), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "content": item.tooltip,
        "options": _vm.options
      }
    })], 1)], 1)
  })], 2)], 1) : _c('div', [_vm._v("\n    Henter kort...\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.overlay),
      expression: "overlay"
    }],
    staticClass: "deleting-overlay"
  }, [_vm._m(0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true",
      "tabindex": "-1"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Hjælp til MålerTjek")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('p', [_vm._v("\n                                Hvis du oplever problemer med at den ikke vil synkronisere dit data, kan en\n                                mulig løsning være, at fjerne dine lokale ændringer. Dette vil resultere i,\n                                at alle ændringer siden sidst du synkroniserede, vil gå tabt. Hvis du ønsker\n                                at slette dine lokale data, klik på knappen nedenfor.\n                            ")]), _vm._v(" "), _c('p', [_vm._v("\n                                Har du brug for support til MålerTjek, kan du ringe på support-telefonen \n                                "), _c('b', [_vm._v("2857 5859")]), _vm._v(" eller sende en e-mail til "), _c('a', {
      attrs: {
        "href": "mailto:infosupport@niras.dk?Subject=MålerTjek",
        "target": "_top"
      }
    }, [_vm._v("infosupport@niras.dk")]), _vm._v(".                                \n                            ")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "grid-x"
    }, [_c('div', {
      staticClass: "small-6 cell",
      staticStyle: {
        "padding-right": "4px"
      }
    }, [_c('a', {
      staticClass: "button",
      on: {
        "click": _vm.closeModal
      }
    }, [_vm._v("Luk")])]), _vm._v(" "), _c('div', {
      staticClass: "small-6 cell",
      staticStyle: {
        "padding-left": "4px"
      }
    }, [_c('a', {
      staticClass: "button call-to-action",
      on: {
        "click": _vm.clearAll
      }
    }, [_vm._v("Slet data")])])])]
  })], 2)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "counter text-center"
  }, [_c('h3', [_vm._v("Sletter lokale data"), _c('span', {
    staticClass: "loading-overview"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])])])
}]}

/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projekter topspacing"
  }, [_c('div', {
    staticClass: "grid-x content"
  }, [_c('div', {
    staticClass: "small-8 cell"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    attrs: {
      "id": "datepicker",
      "name": "Datepicker",
      "language": "da",
      "placeholder": "I dag"
    },
    on: {
      "selected": _vm.getSelectedDate
    },
    model: {
      value: (_vm.state.date),
      callback: function($$v) {
        _vm.$set(_vm.state, "date", $$v)
      },
      expression: "state.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "small-4 cell"
  }, [_c('div', {
    staticClass: "user special-text text-right",
    on: {
      "click": _vm.showUsers
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.selectedUser.navn) + " "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_down")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUserList),
      expression: "showUserList"
    }],
    staticClass: "user-list"
  }, [_c('ul', _vm._l((_vm.users), function(user) {
    return _c('li', {
      key: user.id,
      on: {
        "click": function($event) {
          return _vm.selectUser(user)
        }
      }
    }, [_vm._v("\n              " + _vm._s(user.navn) + "\n            ")])
  }), 0)])])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredResult.length > 0),
      expression: "filteredResult.length > 0"
    }],
    staticClass: "list content",
    class: {
      'hide-list': _vm.createNew
    }
  }, _vm._l((_vm.projectView), function(project, index) {
    return _c('li', {
      key: project.id,
      on: {
        "click": function($event) {
          return _vm.gotoProject(project)
        }
      }
    }, [_c('div', {
      staticClass: "grid-x"
    }, [_c('div', {
      staticClass: "small-1 cell"
    }, [_c('div', {
      staticClass: "status dark-color",
      class: _vm.classObject(project)
    }, [(index < 9) ? _c('span', [_vm._v("0")]) : _vm._e(), _vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "small-6 cell"
    }, [_c('span', [_vm._v(_vm._s(project.bookingTypeNavn))]), _c('br'), _vm._v(" "), (!project.adresse.etage && !project.adresse.doer) ? _c('p', {
      staticClass: "small-text"
    }, [_vm._v(_vm._s(_vm._f("shorten")(project.adresse.vejnavn + ' ' + project.adresse.husnummer + ', ' + project.adresse.postnummer + ' ' + project.adresse.by)))]) : _vm._e(), _vm._v(" "), (project.adresse.etage && !project.adresse.doer) ? _c('p', {
      staticClass: "small-text"
    }, [_vm._v(_vm._s(_vm._f("shorten")(project.adresse.vejnavn + ' ' + project.adresse.husnummer + '. ' + project.adresse.etage + ', ' + project.adresse.postnummer + ' ' + project.adresse.by)))]) : _vm._e(), _vm._v(" "), (!project.adresse.etage && project.adresse.doer) ? _c('p', {
      staticClass: "small-text"
    }, [_vm._v(_vm._s(_vm._f("shorten")(project.adresse.vejnavn + ' ' + project.adresse.husnummer + '. ' + project.adresse.doer + ', ' + project.adresse.postnummer + ' ' + project.adresse.by)))]) : _vm._e(), _vm._v(" "), (project.adresse.etage && project.adresse.doer) ? _c('p', {
      staticClass: "small-text"
    }, [_vm._v(_vm._s(_vm._f("shorten")(project.adresse.vejnavn + ' ' + project.adresse.husnummer + '. ' + project.adresse.etage + ' - ' + project.adresse.doer + ', ' + project.adresse.postnummer + ' ' + project.adresse.by)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "small-4 cell padding-text"
    }, [_vm._v("\n          " + _vm._s(_vm._f("moment")(project.fratid)) + " - " + _vm._s(_vm._f("moment")(project.tiltid)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "small-1 cell icon-center"
    }, [(project.bemaerkning !== '') ? _c('i', {
      staticClass: "material-icons note-icon"
    }, [_vm._v("note")]) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredResult.length == 0 || _vm.projectView == undefined),
      expression: "filteredResult.length == 0 || projectView == undefined"
    }],
    staticClass: "placeholder"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "float-left"
  }, [_c('i', {
    staticClass: "material-icons date-icon"
  }, [_vm._v("date_range")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(987),
      "alt": "projekt-ikon"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Ingen opgaver for den"), _c('br'), _vm._v(" valgte dato eller montør")])
}]}

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-6 cell image-cells"
  }, [_c('a', {
    attrs: {
      "href": _vm.dataSourceFull,
      "data-lightbox": "image-1"
    }
  }, [_c('div', {
    staticClass: "img-container",
    style: ({
      'background': 'url(' + _vm.dataSource + ')'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "remove-image",
    attrs: {
      "aria-hidden": "true",
      "data-open": 'removeImageModal' + _vm.upload.id
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "reveal",
    attrs: {
      "id": 'removeImageModal' + _vm.upload.id,
      "data-reveal": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Du er ved at slette et billede")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-center",
    attrs: {
      "src": _vm.dataSource,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spacing"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "data-close": 'removeImageModal' + _vm.upload.id
    }
  }, [_vm._v("Annuller")])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-left": "4px"
    }
  }, [_c('button', {
    staticClass: "button call-to-action",
    attrs: {
      "data-close": 'removeImageModal' + _vm.upload.id
    },
    on: {
      "click": function($event) {
        return _vm.removeUpload(_vm.upload.id)
      }
    }
  }, [_vm._v("Slet")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_c('b', [_vm._v("Er du sikker?")])])])
}]}

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelCamera
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true",
      "tabindex": "-1"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('p', {
      staticStyle: {
        "margin-bottom": "0px"
      }
    }, [_c('b', [_vm._v("Stregkode:")]), _vm._v(" " + _vm._s(_vm.finalResult))]), _vm._v(" "), _c('p', {
      staticClass: "green-color",
      class: {
        'visibility': !_vm.finalResult
      },
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v("Stregkode på " + _vm._s(_vm.finalResult.length) + " cifre scannet!")]), _vm._v(" "), _c('div', {
      staticClass: "viewport",
      attrs: {
        "id": "interactive"
      }
    }, [_c('video', {
      attrs: {
        "id": "video"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-line"
    }, [_c('hr')])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "grid-x"
    }, [_c('div', {
      staticClass: "small-6 cell",
      staticStyle: {
        "padding-right": "4px"
      }
    }, [_c('a', {
      staticClass: "button",
      attrs: {
        "data-toggle": "barcodeModal",
        "aria-controls": "barcodeModal"
      },
      on: {
        "click": _vm.cancelCamera
      }
    }, [_vm._v("Annuller")])]), _vm._v(" "), _c('div', {
      staticClass: "small-6 cell",
      staticStyle: {
        "padding-left": "4px"
      }
    }, [_c('a', {
      staticClass: "button call-to-action",
      attrs: {
        "data-toggle": "barcodeModal",
        "aria-controls": "barcodeModal"
      },
      on: {
        "click": _vm.stopCamera
      }
    }, [_vm._v("Brug stregkode")])])])]
  })], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default content text-center"
  })
},staticRenderFns: []}

/***/ }),

/***/ 1014:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projekt topspacing-big"
  }, [_c('div', {
    staticClass: "header-big"
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 240.823 240.823"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 240.823 240.823",
      "xml:space": "preserve",
      "width": "18px",
      "height": "18px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "id": "Chevron_Right",
      "d": "M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179   l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816   C52.942,116.507,52.942,124.327,57.633,129.007z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.filteredResult.bookingTypeNavn))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-user"
  }, [(_vm.filteredResult && !_vm.filteredResult.adresse.etage && !_vm.filteredResult.adresse.doer) ? _c('p', {
    staticClass: "small-text"
  }, [_vm._v(_vm._s(_vm._f("shorten")(_vm.filteredResult.adresse.vejnavn + ' ' + _vm.filteredResult.adresse.husnummer + ', ' + _vm.filteredResult.adresse.postnummer + ' ' + _vm.filteredResult.adresse.by)))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult && _vm.filteredResult.adresse.etage && !_vm.filteredResult.adresse.doer) ? _c('p', {
    staticClass: "small-text"
  }, [_vm._v(_vm._s(_vm._f("shorten")(_vm.filteredResult.adresse.vejnavn + ' ' + _vm.filteredResult.adresse.husnummer + '. ' + _vm.filteredResult.adresse.etage + ', ' + _vm.filteredResult.adresse.postnummer + ' ' + _vm.filteredResult.adresse.by)))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult && !_vm.filteredResult.adresse.etage && _vm.filteredResult.adresse.doer) ? _c('p', {
    staticClass: "small-text"
  }, [_vm._v(_vm._s(_vm._f("shorten")(_vm.filteredResult.adresse.vejnavn + ' ' + _vm.filteredResult.adresse.husnummer + '. ' + _vm.filteredResult.adresse.doer + ', ' + _vm.filteredResult.adresse.postnummer + ' ' + _vm.filteredResult.adresse.by)))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult && _vm.filteredResult.adresse.etage && _vm.filteredResult.adresse.doer) ? _c('p', {
    staticClass: "small-text"
  }, [_vm._v(_vm._s(_vm._f("shorten")(_vm.filteredResult.adresse.vejnavn + ' ' + _vm.filteredResult.adresse.husnummer + '. ' + _vm.filteredResult.adresse.etage + ' - ' + _vm.filteredResult.adresse.doer + ', ' + _vm.filteredResult.adresse.postnummer + ' ' + _vm.filteredResult.adresse.by)))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("formattedDate")(_vm.filteredResult.fratid)) + " - " + _vm._s(_vm._f("moment")(_vm.filteredResult.tiltid)))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show == 'booking'),
      expression: "show == 'booking'"
    }],
    staticClass: "content padding-bottom-big"
  }, [_c('h5', [_vm._v("Måler")]), _vm._v(" "), _c('div', {
    staticClass: "special-text under-header"
  }, [_c('p', [_vm._v(_vm._s(_vm.filteredResult.maalerType))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.filteredResult.maalernummer))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-x",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    attrs: {
      "for": "målerplacering"
    }
  }, [_vm._v("Målerplacering\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.målerplacering),
      expression: "data.målerplacering"
    }],
    attrs: {
      "type": "text",
      "id": "målerplacering",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.data.målerplacering)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "målerplacering", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('label', {
    attrs: {
      "for": "tidligerestand"
    }
  }, [_vm._v("Tidligere stand\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tidligerestand),
      expression: "data.tidligerestand"
    }],
    attrs: {
      "type": "number",
      "disabled": "disabled",
      "id": "tidligerestand"
    },
    domProps: {
      "value": (_vm.data.tidligerestand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "tidligerestand", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-left": "4px"
    }
  }, [_c('label', {
    attrs: {
      "for": "aktuelstand"
    }
  }, [_vm._v("Aktuel stand\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tidligereaktuelstand),
      expression: "data.tidligereaktuelstand"
    }],
    attrs: {
      "type": "number",
      "id": "aktuelstand"
    },
    domProps: {
      "value": (_vm.data.tidligereaktuelstand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "tidligereaktuelstand", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.data.tidligerestand > 0) ? _c('p', {
    staticStyle: {
      "font-size": "0.9rem",
      "margin-top": "-5px",
      "padding-left": "2px",
      "font-style": "italic",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Forventet: " + _vm._s(Math.floor(_vm.beregnForventetForbrugForDato(_vm.filteredResult.aflaesningsdato, _vm.filteredResult.fratid, _vm.filteredResult.aarsforbrug)) + _vm.data.tidligerestand))]) : _vm._e()])]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("Ny måler")]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": _vm.childClicked
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('label', {
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Nummer\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nummer),
      expression: "data.nummer"
    }],
    attrs: {
      "type": "text",
      "id": "number"
    },
    domProps: {
      "value": (_vm.data.nummer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nummer", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-2 cell"
  }, [_c('button', {
    staticClass: "button barcode",
    attrs: {
      "data-open": "barcodeModal"
    },
    on: {
      "click": _vm.scanClick
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 28.046 28.046"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 28.046 28.046",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('rect', {
    attrs: {
      "y": "4.877",
      "width": "3.161",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.631",
      "y": "4.877",
      "width": "3.165",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "5.141",
      "y": "4.877",
      "width": "1.579",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.995",
      "y": "4.877",
      "width": "1.581",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "17.766",
      "y": "4.877",
      "width": "1.576",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24.486",
      "y": "4.877",
      "width": "1.584",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.255",
      "y": "4.877",
      "width": "0.791",
      "height": "18.292",
      "fill": "#292929"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "8.765",
      "y": "4.877",
      "width": "4.746",
      "height": "18.292",
      "fill": "#292929"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "small-4 cell",
    staticStyle: {
      "padding-left": "6px"
    }
  }, [_c('label', {
    attrs: {
      "for": "stand"
    }
  }, [_vm._v("Aktuel stand\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.aktuelstand),
      expression: "data.aktuelstand"
    }],
    attrs: {
      "type": "text",
      "id": "stand"
    },
    domProps: {
      "value": (_vm.data.aktuelstand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "aktuelstand", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Årsag til ny tid\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nytidselect),
      expression: "data.nytidselect"
    }],
    attrs: {
      "id": "select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "nytidselect", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ingen valgt")]), _vm._v(" "), _vm._l((_vm.timetypes), function(timetype) {
    return _c('option', {
      key: timetype.id,
      domProps: {
        "selected": _vm.selected,
        "value": timetype.id
      }
    }, [_vm._v("\n                    " + _vm._s(timetype.navn) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-12 cell"
  }, [_c('button', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("Gem")])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show == 'customer'),
      expression: "show == 'customer'"
    }],
    staticClass: "content padding-bottom-big"
  }, [_vm._m(1), _vm._v(" "), (_vm.filteredResult.kunde) ? _c('div', {
    staticClass: "customer-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.filteredResult.kunde.navn))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.filteredResult.adresse.vejnavn) + " " + _vm._s(_vm.filteredResult.adresse.husnummer) + ", " + _vm._s(_vm.filteredResult.adresse.postnummer) + " " + _vm._s(_vm.filteredResult.adresse.by))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.filteredResult.by))]), _vm._v(" "), (_vm.filteredResult.kunde.email != null || _vm.filteredResult.kunde.email != undefined) ? _c('p', [_vm._v(_vm._s(_vm.filteredResult.kunde.email))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult.kunde.email == null || _vm.filteredResult.kunde.email == undefined) ? _c('p', [_c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.email),
      expression: "data.email"
    }],
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.data.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "email", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.filteredResult.kunde.mobil != null || _vm.filteredResult.kunde.mobil != undefined) ? _c('p', [_vm._v(_vm._s(_vm.filteredResult.kunde.mobil))]) : _vm._e(), _vm._v(" "), (_vm.filteredResult.kunde.mobil == null || _vm.filteredResult.kunde.mobil == undefined) ? _c('p', [(_vm.filteredResult.kunde.email != null || _vm.filteredResult.kunde.email != undefined) ? _c('br') : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Mobil\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.mobil),
      expression: "data.mobil"
    }],
    attrs: {
      "type": "text",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.data.mobil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "mobil", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.filteredResult.kunde.email == null || _vm.filteredResult.kunde.email == undefined || _vm.filteredResult.kunde.mobil == null || _vm.filteredResult.kunde.mobil == undefined) ? _c('a', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("Gem")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.filteredResult.kunde) ? _c('div', {
    staticClass: "customer-info no-info"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Der findes ingen oplysninger på kunden")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show == 'notes'),
      expression: "show == 'notes'"
    }],
    staticClass: "content padding-bottom-big"
  }, [_c('h5', [_vm._v("Noter")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteselect),
      expression: "noteselect"
    }],
    attrs: {
      "id": "select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.noteselect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1",
      "disabled": "disabled"
    }
  }, [_vm._v("Ingen valgt")]), _vm._v(" "), _vm._l((_vm.notetypes), function(notetype) {
    return _c('option', {
      key: notetype.id,
      domProps: {
        "value": notetype.navn
      }
    }, [_vm._v("\n                " + _vm._s(notetype.navn) + "\n            ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("Gem")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show == 'images'),
      expression: "show == 'images'"
    }],
    staticClass: "content padding-bottom-big"
  }, [_c('div', {
    staticClass: "addFile"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "fileUpload",
      "accept": "image/*",
      "capture": ""
    },
    on: {
      "change": _vm.gotUpload
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('p', [_vm._v("Tilføj billede")])]), _vm._v(" "), _c('div', {
    staticClass: "addScreenshot"
  }, [(_vm.webcam.active) ? _c('div', [_c('web-cam', {
    ref: "webcam",
    attrs: {
      "deviceId": _vm.webcam.selectedCameraId,
      "height": 200
    },
    on: {
      "cameras": _vm.getAvailableCameras
    }
  }), _vm._v(" "), (_vm.webcam.availableCameras) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webcam.selectedCameraId),
      expression: "webcam.selectedCameraId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.webcam, "selectedCameraId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Vælg Kamera")]), _vm._v(" "), _vm._l((_vm.webcam.availableCameras), function(camera) {
    return _c('option', {
      key: camera.deviceId,
      domProps: {
        "value": camera.deviceId
      }
    }, [_vm._v("\n                        " + _vm._s(camera.label) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button call-to-action",
    on: {
      "click": function($event) {
        return _vm.capture_screenshot()
      }
    }
  }, [_vm._v("Tag screenshot")])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.toggleCamera()
      }
    }
  }, [_vm._v(_vm._s(_vm.webcam.text))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-x"
  }, _vm._l((_vm.localImages), function(upload) {
    return _c('FormUpload', {
      key: upload.id || _vm.mongoid,
      attrs: {
        "upload": upload
      },
      on: {
        "removeUpload": function($event) {
          return _vm.doremoveUpload(upload.id)
        }
      }
    })
  }), 1)]), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "auto cell",
    class: {
      'active-item': _vm.show == 'booking'
    },
    on: {
      "click": _vm.goToBooking
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("date_range")]), _vm._v(" "), _c('p', [_vm._v("Booking")])]), _vm._v(" "), _c('div', {
    staticClass: "auto cell",
    class: {
      'active-item': _vm.show == 'customer'
    },
    on: {
      "click": _vm.goToCustomer
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(" "), _c('p', [_vm._v("Kunde")])]), _vm._v(" "), _c('div', {
    staticClass: "auto cell",
    class: {
      'active-item': _vm.show == 'notes'
    },
    on: {
      "click": _vm.goToNotes
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Layer_1",
      "x": "0px",
      "y": "0px",
      "width": "23px",
      "height": "25px",
      "viewBox": "0 0 128 128",
      "enable-background": "new 0 0 128 128",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M8,112V16c0-4.414,3.594-8,8-8h80c4.414,0,8,3.586,8,8v47.031l8-8V16c0-8.836-7.164-16-16-16H16C7.164,0,0,7.164,0,16v96    c0,8.836,7.164,16,16,16h44v-8H16C11.594,120,8,116.414,8,112z M88,24H24v8h64V24z M88,40H24v8h64V40z M88,56H24v8h64V56z M24,80    h32v-8H24V80z M125.656,72L120,66.344c-1.563-1.563-3.609-2.344-5.656-2.344s-4.094,0.781-5.656,2.344l-34.344,34.344    C72.781,102.25,68,108.293,68,110.34L64,128l17.656-4c0,0,8.094-4.781,9.656-6.344l34.344-34.344    C128.781,80.188,128.781,75.121,125.656,72z M88.492,114.82c-0.453,0.43-2.02,1.488-3.934,2.707l-10.363-10.363    c1.063-1.457,2.246-2.922,2.977-3.648l25.859-25.859l11.313,11.313L88.492,114.82z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v(" "), _c('p', [_vm._v("Noter")])]), _vm._v(" "), _c('div', {
    staticClass: "auto cell",
    class: {
      'active-item': _vm.show == 'images'
    },
    on: {
      "click": _vm.goToImages
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("camera_alt")]), _vm._v(" "), _c('p', [_vm._v("Billeder")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.overlay),
      expression: "overlay"
    }],
    staticClass: "overlay",
    attrs: {
      "data-toggle": "bottommenu",
      "aria-controls": "bottommenu"
    },
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), (_vm.deviation === true) ? _c('div', {
    staticClass: "alert-message"
  }, [_c('div', {
    staticClass: "align-alert-item"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("warning")]), _vm._v(" "), _c('h5', [_vm._v("Der er en afvigelse på mere end " + _vm._s(_vm.maxDeviation) + "%")]), _vm._v(" "), _c('button', {
    staticClass: "button call-to-action",
    on: {
      "click": _vm.closeAlert
    }
  }, [_vm._v("Luk")])])]) : _vm._e(), _vm._v(" "), (_vm.popup == true) ? _c('div', {
    staticClass: "popup-message"
  }, [_vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_vm._v("receipt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Kundeoplysninger   "), _c('i', {
    staticClass: "material-icons person-icon"
  }, [_vm._v("person")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-item"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('h5', [_vm._v("Gemt!")])])
}]}

/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_init__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_init___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_init__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_velkommen__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_velkommen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_velkommen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_projekter__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_projekter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_projekter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_projekt__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_projekt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_projekt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_kort__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_kort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_kort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_default__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_default__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'default',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_default___default.a
  }, {
    path: '/init/:key',
    name: 'init',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_init___default.a,
    params: { key: '' }
  }, {
    path: '/velkommen',
    name: 'velkommen',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_velkommen___default.a
  }, {
    path: '/projekter',
    name: 'projekter',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_projekter___default.a
  }, {
    path: '/projekt/:id',
    name: 'projekt',
    params: { id: '' },
    component: __WEBPACK_IMPORTED_MODULE_5__pages_projekt___default.a
  }, {
    path: '/kort',
    name: 'kort',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_kort___default.a
  }]
  // mode: 'history'
}));

/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1019);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        notification: 0
    },
    getters: {
        notification: function notification(state) {
            return state.notification;
        }
    },
    mutations: {
        updateNotification: function updateNotification(state, payload) {
            state.notification = payload;
        }
    },
    actions: {
        updateNotification: function updateNotification(_ref, payload) {
            var commit = _ref.commit;

            commit('updateNotification', payload);
            localStorage.setItem('notification', payload);
        }
    }
});

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(888)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1005),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mongoObjectId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clearQueue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_localforage__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_localforage__);




var mongoObjectId = function mongoObjectId() {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
        return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
};

var framework = {
    createStore: function createStore(name) {
        return __WEBPACK_IMPORTED_MODULE_2_localforage___default.a.createInstance({
            name: name,
            driver: __WEBPACK_IMPORTED_MODULE_2_localforage___default.a.INDEXEDDB
        });
    },
    getItem: function getItem(store, key) {
        return store.getItem(key);
    },
    setItem: function setItem(store, key, value) {
        return store.setItem(key, value);
    },
    clearStore: function clearStore(store) {
        return store.clear();
    },
    iterate: function iterate(store, callback) {
        return store.iterate(callback);
    },
    removeItem: function removeItem(store, key) {
        return store.removeItem(key);
    },
    length: function length(store) {
        return store.length();
    },
    keys: function keys(store) {
        return store.keys();
    }
};

var SIOdal = function (storeNames) {

    "use strict";

    var stores = {};

    var dal = {
        createStore: function createStore(storeName) {

            stores[storeName] = framework.createStore(storeName);

            return stores[storeName];
        },
        getStores: function getStores() {
            return stores;
        },
        deleteStore: function deleteStore() {},
        clearStore: function clearStore(storeName) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.clearStore(stores[storeName]);
        },
        getStoreLength: function getStoreLength(storeName) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.length(stores[storeName]);
        },
        getStoreKeys: function getStoreKeys(storeName) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.keys(stores[storeName]);
        },
        clearAllStores: function clearAllStores() {
            var promises = [];

            for (var store in stores) {
                promises.push(function () {
                    return framework.clearStore(stores[store]);
                });
            }

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clearQueue__["a" /* default */])(promises);
        },
        deleteAllStores: function deleteAllStores() {},
        getItem: function getItem(storeName, key) {

            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.getItem(stores[storeName], key);
        },
        setItem: function setItem(storeName, key, value) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.setItem(stores[storeName], key, value);
        },
        iterate: function iterate(storeName, callback) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.iterate(stores[storeName], callback);
        },
        removeItem: function removeItem(storeName, key) {
            return framework.removeItem(stores[storeName], key);
        },
        cloneItem: function cloneItem(storeNameFrom, storeNameTo, key) {

            return framework.getItem(stores[storeNameFrom], key).then(function (result) {
                return framework.setItem(stores[storeNameTo], key, result);
            });
        },
        moveItem: function moveItem() {},
        init: function init(storeNames) {
            storeNames.forEach(function (name) {
                dal.createStore(name);
            });
        }

    };

    dal.init(storeNames);

    return dal;
}(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].stores);

window.dal = SIOdal;

/* harmony default export */ __webpack_exports__["a"] = (SIOdal);



/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_Sync_clearQueue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zangodb__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zangodb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_zangodb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpmodal_vue__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_helpmodal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_helpmodal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_image_novafos_jpg__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_image_novafos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_image_novafos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_image_lyngbyTaarb_k_logo_png__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_image_lyngbyTaarb_k_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_image_lyngbyTaarb_k_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_image_t_rnbyForsyning_logo_png__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_image_t_rnbyForsyning_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_image_t_rnbyForsyning_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_image_vandOgAffald_logo_png__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_image_vandOgAffald_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_image_vandOgAffald_logo_png__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var state = {
  date: ''
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a,
    'help-modal': __WEBPACK_IMPORTED_MODULE_6__components_helpmodal_vue___default.a
  },
  data: function data() {
    return {
      version: '1.15',
      date: '28. september 2021',
      syncOverlay: false,
      overlay: false,
      state: state,
      errorMessage: '',
      activeStep: 0,
      totalSteps: 8,
      reloadProjekter: false,
      image: '',
      showModal: false
    };
  },

  computed: {
    notification: {
      get: function get() {
        return this.$store.getters.notification;
      },
      set: function set(value) {
        this.$store.dispatch('updateNotification', value);
      }
    }
  },
  methods: {
    showHelpModal: function showHelpModal() {
      this.overlay = false;
      this.showModal = true;
    },
    showMenu: function showMenu() {
      this.overlay = true;
    },
    closeMenu: function closeMenu() {
      this.overlay = false;
    },
    gotoMap: function gotoMap() {
      this.overlay = false;
      this.$router.push({
        name: 'kort'
      });
    },
    gotoProjects: function gotoProjects() {
      this.overlay = false;
      this.$router.push({
        name: 'projekter'
      });
    },
    gotoAbout: function gotoAbout() {
      this.overlay = false;
    },
    gotoSettings: function gotoSettings() {
      this.overlay = false;
    },
    syncData: function syncData() {
      var _this = this;
      var tempdata = [];
      var tempimages = [];
      var bookingId = [];
      var idArr = [];
      var promiseArray = [];
      var user = JSON.parse(this.$cookie.get('user'));
      var promises = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve()];

      this.overlay = false;
      this.errorMessage = '';
      this.syncOverlay = true;

      if (navigator.onLine) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__js_Sync_clearQueue__["a" /* default */])(promises).then(function () {
          _this.activeStep = 1;
          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].iterate("MTTempData", function (value, key, iterationNumber) {
              tempdata.push(value);
            }).then(function () {
              console.log(tempdata);
              resolve(tempdata);
            });
          });
        }).then(function () {
          _this.activeStep = 2;
          var tempdataPromises = [];

          var _loop = function _loop(i) {
            tempdataPromises.push(function () {
              console.log("tempdata test", tempdata[i]);
              try {
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this.$http.post(window['url'] + 'v' + window['version'] + '/booking/gem', tempdata[i], { params: { 'montoernavn': user.navn } }).then(function (response) {
                    return resolve(response);
                  }).catch(function (err) {
                    reject(new Error("Der skete en fejl!")).then(function (err) {
                      // not called
                    }, function (err) {
                      console.log("error", err);
                      _this.errorMessage = "Der skete en fejl. Prøv igen";
                    });
                  });
                }).then(function (response) {
                  if (response.body > 0) {
                    var id = parseInt(response.body);

                    //var id = {old: tempdata[i].id, new: response.body};
                    idArr.push(id);
                    console.log("idArr", idArr);
                    return response.body;
                  } else {
                    return false;
                  }
                });
              } catch (err) {
                console.log("err step 2 catch");
                _this.errorMessage = "Der gik noget galt. Prøv igen";
              }
            });
            console.log("tempdataPromises", tempdataPromises);
          };

          for (var i = 0; i < tempdata.length; i++) {
            _loop(i);
          }
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__js_Sync_clearQueue__["a" /* default */])(tempdataPromises);
          //Aktiverdokumentation
        }).then(function () {
          _this.activeStep = 3;
          __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].clearStore('MTTempData').then(function (result) {});
        }).then(function () {
          _this.activeStep = 4;
          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].iterate("MTTempImages", function (value, key, iterationNumber) {
              tempimages.push(value);
            }).then(function () {
              console.log(tempimages);
              resolve(tempimages);
            });
          });
        }).then(function () {
          var tempimagePromises = [];

          var _loop2 = function _loop2(i) {
            tempimagePromises.push(function () {
              // Check if some of the images were added to a new project
              // if (idArr) {
              //   idArr.forEach(function(item){
              //     console.log(item);
              //     if(item.old == tempimages[i].projectId){
              //       tempimages[i].projectId = item.new;
              //     }
              //   });
              //   console.log("tempimages projectID after", tempimages[i].projectId);
              // }

              var imageToUpload = {};
              imageToUpload.bookingId = tempimages[i].projectId;
              imageToUpload.base64Data = tempimages[i].base64;
              imageToUpload.filnavn = tempimages[i].fileName;
              console.log("imageToUpload", imageToUpload);
              try {
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this.$http.post(window['url'] + 'v' + window['version'] + '/booking/gembillede', imageToUpload).then(function (response) {
                    return resolve(response);
                  }).catch(function (err) {
                    reject(new Error("Der skete en fejl!")).then(function (err) {
                      // not called
                    }, function (err) {
                      console.log("error", err);
                      _this.errorMessage = "Der skete en fejl. Prøv igen";
                    });
                  });
                }).then(function (response) {
                  if (response.body > 0) {
                    return response.body;
                  } else {
                    _this.errorMessage = "Der gik noget galt. Prøv igen";
                    return false;
                  }
                });
              } catch (err) {
                console.log("err step 4 catch", err);
                _this.error = err;
                _this.errorMessage = "Der gik noget galt. Prøv igen" + err;
              }
            });
          };

          for (var i = 0; i < tempimages.length; i++) {
            _loop2(i);
          }
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__js_Sync_clearQueue__["a" /* default */])(tempimagePromises);
        }).then(function () {
          _this.activeStep = 5;
          if (idArr.length > 0) {
            console.log('idArr', idArr);
            try {
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this.$http.post('https://mobileservice.maalertjek.niras.dk/api/v1/booking/aktiverdokumentation', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(idArr)).then(function (response) {
                  return resolve(response);
                }).catch(function (err) {
                  reject(new Error("Der skete en fejl!")).then(function (err) {
                    // not called
                  }, function (err) {
                    console.log("error", err);
                    _this.errorMessage = "Der skete en fejl. Prøv igen";
                  });
                });
              }).then(function (response) {
                console.log('response aktiverdokumentation', response);
                if (response.body > 0) {
                  return response.body;
                } else {
                  console.log("error", response.body);
                  return false;
                }
              });
            } catch (err) {
              console.log("err step 5 catch", err);
              _this.errorMessage = "Der gik noget galt. Prøv igen" + err;
            }
          }
        }).then(function () {
          console.log("image sync done");
          __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].clearStore('MTTempImages').then(function (result) {});
        }).then(function () {
          _this.activeStep = 6;
          __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].clearStore('MTBookingTypes').then(function (result) {});
          __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].clearStore('MTNoteTypes').then(function (result) {});
          __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].clearStore('MTPlacementTypes').then(function (result) {});
          __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].clearStore('MTSettings').then(function (result) {});
          __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].clearStore('MTTasks').then(function (result) {});
          __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].clearStore('MTTimeTypes').then(function (result) {});
          __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].clearStore('MTUsers').then(function (result) {});
        }).then(function () {
          console.log("insert all data");
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__js_Sync_clearQueue__["a" /* default */])(promises).then(function () {
            _this.activeStep = 7;
            try {
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this.$http.get(window['url'] + 'v' + window['version'] + '/lister/allelister').then(function (response) {
                  return resolve(response);
                }).catch(function (err) {
                  reject(new Error("Der skete en fejl!")).then(function (err) {
                    // not called
                  }, function (err) {
                    console.log("error", err);
                    _this.errorMessage = "Der skete en fejl. Prøv igen";
                  });
                });
              }).then(function (response) {
                console.log("response from step 7", response);
                return response.body;
              }, function (response) {
                console.log("Der opstod en fejl");
                return false;
              });
            } catch (err) {
              console.log("err step 7 catch", err);
              _this.errorMessage = "Der gik noget galt. Prøv igen";
            }
          }).then(function (data) {
            if (data == undefined || data == false) {
              _this.errorMessage = "Der gik noget galt. Prøv igen";
              console.log("Der opstod en fejl");
            } else {
              console.log("inserting into IndexedDB", data.bookinger);
              var promiseArray = [];
              console.log("data", data);

              data.bookinger.forEach(function (booking) {
                promiseArray.push(function () {
                  return __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].setItem("MTTasks", booking.id, booking).then(function () {
                    //
                  });
                });
              });
              __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].setItem("MTBookingTypes", "bookingtypes", data.bookingTyper);
              __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].setItem("MTTimeTypes", "timetypes", data.nyTidTyper);
              __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].setItem("MTNoteTypes", "notetypes", data.bemaerkningTyper);
              __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].setItem("MTPlacementTypes", "placementtypes", data.placeringTyper);
              __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].setItem("MTUsers", "users", data.montoerer);

              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__js_Sync_clearQueue__["a" /* default */])(promiseArray);
            }
          }).then(function () {
            _this.activeStep = 8;
            console.log("insert settings");
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__js_Sync_clearQueue__["a" /* default */])(promises);
            try {
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this.$http.get('https://mobileservice.maalertjek.niras.dk/api/indstillinger').then(function (response) {
                  return resolve(response);
                }).catch(function (err) {
                  reject(new Error("Der skete en fejl!")).then(function (err) {
                    // not called
                  }, function (err) {
                    console.log("error", err);
                    _this.errorMessage = "Der skete en fejl. Prøv igen";
                  });
                });
              }).then(function (response) {
                return response.body;
              }, function (response) {
                return false;
              });
            } catch (err) {
              console.log("err step 8 catch", err);
              _this.errorMessage = "Der gik noget galt. Prøv igen" + err;
            }
          }).then(function (data) {
            if (data == undefined || data == false) {
              _this.errorMessage = "Der skete en fejl";
              console.log("der opstod en fejl");
            } else {
              window['url'] = data.serviceUrl;
              window['version'] = data.serviceVersion;
              return __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].setItem("MTSettings", "settings", data);
            }
          }).then(function () {
            _this.syncOverlay = false;
            _this.activeStep = 0;
            _this.errorMessage = '';
            _this.$store.dispatch('updateNotification', 0);
            localStorage.clear();

            _this.$router.push({
              name: 'default'
            });

            // hent nyt data på projektsiden, så listen opdatere
          });
        });
      } else {
        _this.errorMessage = "Du har ikke noget internet";
        setTimeout(function () {
          _this.syncOverlay = false;
          _this.activeStep = 0;
          _this.errorMessage = '';
        }, 5000);
      }
    },
    logout: function logout() {
      this.overlay = false;
      this.$router.push({
        name: 'init',
        params: { key: 'Key' }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    $(document).foundation();

    window['apikey'] = this.$cookie.get('apikey');
    window['user'] = JSON.parse(this.$cookie.get('user'));
    window['url'] = this.$cookie.get('url');
    window['version'] = this.$cookie.get('version');

    if (!this.$cookie.get('downloaded')) {
      if (this.$route.name == 'init') {
        window['apikey'] = this.$route.params.key;
        console.log("apikey", window['apikey']);

        this.$router.push({
          name: 'init',
          key: window['apikey']
        });
      } else {
        this.$router.push({
          name: 'default'
        });
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].getItem('MTSettings', 'settings').then(function (result) {
        if (result.firmanavn == "Novafos") {
          this.image = __WEBPACK_IMPORTED_MODULE_7__assets_image_novafos_jpg___default.a;
        }
        if (result.firmanavn == "Lyngby-Taarnbæk Forsyning") {
          this.image = __WEBPACK_IMPORTED_MODULE_8__assets_image_lyngbyTaarb_k_logo_png___default.a;
        }
        if (result.firmanavn == "Taarnby Forsyning") {
          this.image = __WEBPACK_IMPORTED_MODULE_9__assets_image_t_rnbyForsyning_logo_png___default.a;
        }
        if (result.firmanavn == "Vand & Affald") {
          this.image = __WEBPACK_IMPORTED_MODULE_10__assets_image_vandOgAffald_logo_png___default.a;
        }
      });

      __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].getItem('MTSettings', 'settings').then(function (result) {
        _this.image = result.logoUrl;
      });

      _this.$store.dispatch('updateNotification', localStorage.getItem('notification') == null ? 0 : localStorage.getItem('notification'));
    }
  }
});

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_Sync_clearQueue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_image_image_png__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_image_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_image_image_png__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'formUpload',
    props: ['upload'],
    data: function data() {
        return {
            dataSource: undefined,
            dataSourceFull: undefined,
            images: []
        };
    },
    mounted: function mounted() {
        var _this = this;
        $(document).foundation();

        if (_this.upload.thumb != null && _this.upload.thumb != undefined) {
            var result = _this.upload;
            var dataView = new DataView(result.thumb || result.data);
            var blob = new Blob([dataView], { type: result.type });

            _this.dataSource = URL.createObjectURL(blob);

            var dataViewFull = new DataView(result.data);
            var blobFull = new Blob([dataViewFull], { type: result.type });

            _this.dataSourceFull = URL.createObjectURL(blobFull);
        } else {
            _this.dataSource = __WEBPACK_IMPORTED_MODULE_2__assets_image_image_png___default.a; // <-- Placeholder
        }
    },

    methods: {
        removeUpload: function removeUpload(id) {
            var _this = this;

            URL.revokeObjectURL(_this.dataSource);

            console.log("removeUpload", id);

            _this.$emit('removeUpload', id);
        }
    },
    beforeDestroy: function beforeDestroy() {
        var _this = this;

        URL.revokeObjectURL(_this.dataSource);
        URL.revokeObjectURL(_this.dataSourceFull);
    }
});

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_dist_leaflet_css__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_leaflet_dist_leaflet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__js_Sync_dal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_proj4_dist_proj4_src__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_proj4_dist_proj4_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_proj4_dist_proj4_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__js_proj4js__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_image_green_circle_svg__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_image_green_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_image_green_circle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_image_red_circle_svg__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_image_red_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_image_red_circle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_image_black_circle_svg__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_image_black_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_image_black_circle_svg__);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'mapcomponent',
    components: {
        'v-map': __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet___default.a.Map,
        'v-tilelayer': __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet___default.a.TileLayer,
        'v-popup': __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet___default.a.Popup,
        'v-marker': __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet___default.a.Marker,
        'v-tooltip': __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet___default.a.Tooltip
    },
    data: function data() {
        var _options;

        return {
            zoom: 14,
            center: [56.129172, 9.219482],
            url: '//{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="//osm.org/copyright">OpenStreetMap</a> contributors',
            markers: [],
            centerObj: [],
            unfinishedObj: [],
            options: (_options = { permanent: true, custom: true, className: 'tooltipBox' }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_options, 'custom', true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_options, 'dashOffset', ""), _options),
            minX: null,
            maxX: null,
            minY: null,
            maxY: null,
            doneLoading: false
        };
    },

    methods: {
        init: function init() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var marker, items, user, promiseIterateTempData, promiseIterateTasks, cookie, result, _i, value, x, y, popupContent, source, dest, point, setIcon, iteration, _i2, lat, lng, calcX, calcY, newCenterObject;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.doneLoading = false;
                                marker = [];
                                items = [];
                                user = JSON.parse(_this.$cookie.get('user'));
                                promiseIterateTempData = __WEBPACK_IMPORTED_MODULE_6__js_Sync_dal__["a" /* default */].iterate('MTTempData', function (value, key, iterationNumber) {
                                    if (value.montoerId === user.id) {
                                        var date = moment(value.fratid).format('YYYYMMDD');

                                        if (window['selectedDate'] !== null) {
                                            if (date.includes(window['selectedDate'])) {
                                                items.push(value);
                                            }
                                        } else {
                                            var now = moment(new Date()).format('YYYYMMDD');

                                            if (date.includes(now)) {
                                                items.push(value);
                                            }
                                        }
                                    }
                                });
                                _context.prev = 5;
                                _context.next = 8;
                                return promiseIterateTempData;

                            case 8:
                                promiseIterateTasks = __WEBPACK_IMPORTED_MODULE_6__js_Sync_dal__["a" /* default */].iterate('MTTasks', function (value, key, iterationNumber) {
                                    var date = moment(value.fratid).format('YYYYMMDD');
                                    var selected = '';

                                    if (value.montoerId == user.id) {
                                        if (window['selectedDate'] !== null && window['selectedDate'] !== '') {
                                            selected = window['selectedDate'];
                                        } else {
                                            selected = moment(new Date()).format('YYYYMMDD');
                                        }

                                        if (date.includes(selected)) {
                                            var tempItems = items;
                                            var existsBool = false;
                                            tempItems.forEach(function (item) {
                                                if (item.id === value.id) {
                                                    existsBool = true;
                                                }
                                            });

                                            if (!existsBool) {
                                                items.push(value);
                                                existsBool = false;
                                            }
                                        }
                                    }
                                });
                                _context.prev = 9;
                                _context.next = 12;
                                return promiseIterateTasks;

                            case 12:
                                cookie = _this.$cookie.get('apikey');
                                _context.prev = 13;

                                // const promiseCurrentPosition = new Promise((resolve, reject) => {
                                //     navigator.geolocation.getCurrentPosition(position => {
                                //         resolve(position.coords)
                                //     })
                                // })

                                // const currentPosition = await promiseCurrentPosition

                                console.log('step 1: result', items);
                                // console.log('currentPosition', currentPosition)

                                result = items.sort(function (a, b) {
                                    return new Date(a.fratid) - new Date(b.fratid);
                                });


                                for (_i in result) {
                                    value = result[_i];


                                    if (value.adresse.koordinater === null) {
                                        console.log('koordinat er null');
                                    } else if (value.adresse.koordinater.x === null || value.adresse.koordinater.y === null || value.adresse.koordinater.x === 0 || value.adresse.koordinater.y === 0) {
                                        console.log('koordinat er null');
                                    } else {
                                        x = value.adresse.koordinater.x;
                                        y = value.adresse.koordinater.y;
                                        popupContent = '';


                                        __WEBPACK_IMPORTED_MODULE_8__js_proj4js__["a" /* default */].defs['EPSG:4326'] = '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs';
                                        __WEBPACK_IMPORTED_MODULE_8__js_proj4js__["a" /* default */].defs['EPSG:25832'] = '+title=  ETRF89 / UTM zone 32N EPSG:25832 +proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs';

                                        source = new __WEBPACK_IMPORTED_MODULE_8__js_proj4js__["a" /* default */].Proj('EPSG:25832');
                                        dest = new __WEBPACK_IMPORTED_MODULE_8__js_proj4js__["a" /* default */].Proj('EPSG:4326');
                                        point = new __WEBPACK_IMPORTED_MODULE_8__js_proj4js__["a" /* default */].Point(x, y);


                                        __WEBPACK_IMPORTED_MODULE_8__js_proj4js__["a" /* default */].transform(source, dest, point);

                                        popupContent = '<h4 class="text-center">' + value.bookingTypeNavn + '</h4>';
                                        popupContent += '<b>Adresse:</b> <br />' + value.adresse.vejnavn + ' ' + value.adresse.husnummer;
                                        if (value.adresse.etage == null || value.adresse.etage == undefined || value.adresse.etage == '') {
                                            // No data
                                        } else {
                                            popupContent += '. ' + value.adresse.etage;
                                        }
                                        if (value.adresse.doer == null || value.adresse.doer == undefined || value.adresse.doer == '') {
                                            // No data
                                        } else {
                                            popupContent += ' - ' + value.adresse.doer;
                                        }
                                        popupContent += ', ' + value.adresse.postnummer + ' ' + value.adresse.by;
                                        popupContent += '<br />';
                                        popupContent += '<b>Tidspunkt:</b> <br /> ' + moment(value.fratid).format('HH:mm') + ' - ' + moment(value.tiltid).format('HH:mm');
                                        popupContent += '<br />';
                                        popupContent += '<b>Kunde:</b>' + '<br />' + value.kunde.navn;
                                        popupContent += '<br />';
                                        popupContent += '<a class="button" href="/#/projekt/' + value.id + '">Gå til booking</a>';
                                        // popupContent += `<a class="button" target="_blank" style="margin-top: 0px;" href="https://www.google.com/maps/dir/${currentPosition.latitude},${currentPosition.longitude}/${value.adresse.vejnavn}+${value.adresse.husnummer},+${value.adresse.postnummer}+${value.adresse.by}">Rutevejledning</a>`

                                        setIcon = function setIcon(item) {
                                            if (item.maalerStand !== undefined && item.maalerStand !== "" && item.maalerStand !== null) {
                                                return new L.icon({
                                                    iconUrl: __WEBPACK_IMPORTED_MODULE_9__assets_image_green_circle_svg___default.a,
                                                    iconSize: [25, 25],
                                                    iconAnchor: [12.5, 12.5]
                                                });
                                            } else if (item.nytMaalernummer !== null && item.nytMaalernummer !== "") {
                                                return new L.icon({
                                                    iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_image_black_circle_svg___default.a,
                                                    iconSize: [25, 25],
                                                    iconAnchor: [12.5, 12.5]
                                                });
                                            } else if (item.nytidTypeId > 0) {
                                                return new L.icon({
                                                    iconUrl: __WEBPACK_IMPORTED_MODULE_10__assets_image_red_circle_svg___default.a,
                                                    iconSize: [25, 25],
                                                    iconAnchor: [12.5, 12.5]
                                                });
                                            } else {
                                                return new L.icon({
                                                    iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_image_black_circle_svg___default.a,
                                                    iconSize: [25, 25],
                                                    iconAnchor: [12.5, 12.5]
                                                });
                                            }
                                        };

                                        iteration = parseInt(_i) + 1;


                                        marker.push({
                                            coordinates: L.latLng(point.y, point.x),
                                            popup: popupContent,
                                            tooltip: iteration.toString(),
                                            icon: setIcon(value),
                                            stroke: false,
                                            weight: 0,
                                            opacity: 1,
                                            nyMaalerStand: value.nyMaalerStand,
                                            nytMaalernummer: value.nytMaalernummer,
                                            sidsteaflaesning: value.sidsteaflaesning,
                                            maalerStand: value.maalerStand,
                                            nytidTypeId: value.nytidTypeId,
                                            value: value
                                        });
                                    }
                                }

                                if (marker.length > 0) {
                                    console.log('if marker.length > 0', marker.length);
                                    _this.markers = marker;

                                    for (_i2 in marker) {
                                        if (marker[_i2].nyMaalerStand !== null && marker[_i2].nyMaalerStand !== "" && marker[_i2].nytMaalernummer !== null && marker[_i2].nytMaalernummer !== "" && marker[_i2].sidsteaflaesning > 0 && marker[_i2].sidsteaflaesning !== null && marker[_i2].sidsteaflaesning !== "" && marker[_i2].maalerStand !== undefined && marker[_i2].maalerStand != "" && marker[_i2].maalerStand !== null) {
                                            if (marker[_i2].nytidTypeId === undefined || marker[_i2].nytidTypeId === 0) {
                                                _this.centerObj.push(marker[_i2].coordinates);
                                            } else {
                                                // red color
                                            }
                                        } else if (marker[_i2].nytidTypeId > 0) {
                                            // red color
                                        } else {
                                            // black color
                                            _this.unfinishedObj.push(marker[_i2].coordinates);
                                        }
                                    }
                                    if (_this.unfinishedObj !== [] && _this.unfinishedObj[0] !== undefined) {
                                        lat = _this.unfinishedObj[0].lat;
                                        lng = _this.unfinishedObj[0].lng;

                                        console.log('this.center[lat, lng]', [lat, lng]);
                                        _this.center = [lat, lng];
                                    } else {
                                        if (_this.centerObj != []) {
                                            for (i in _this.centerObj) {
                                                if (_this.centerObj[i].lat < _this.minX || _this.minX == null) {
                                                    _this.minX = _this.centerObj[i].lat;
                                                }
                                                if (_this.centerObj[i].lng < _this.minY || _this.minY == null) {
                                                    _this.minY = _this.centerObj[i].lng;
                                                }
                                                if (_this.centerObj[i].lat > _this.maxX || _this.minX == null) {
                                                    _this.maxX = _this.centerObj[i].lat;
                                                }
                                                if (_this.centerObj[i].lng > _this.maxY || _this.minX == null) {
                                                    _this.maxY = _this.centerObj[i].lng;
                                                }
                                            }

                                            calcX = (_this.maxX - _this.minX) / 2 + _this.minX;
                                            calcY = (_this.maxY - _this.minY) / 2 + _this.minY;
                                            newCenterObject = [calcX, calcY];


                                            if (newCenterObject !== []) {
                                                console.log('this.center newCenterObject', newCenterObject);
                                                _this.center = newCenterObject;
                                                _this.zoom = 12;
                                            } else {
                                                console.log("else");
                                            }
                                        } else {
                                            console.log("else wat");
                                        }
                                    }
                                } else {
                                    console.log('else this.center = default');
                                    _this.center = [56.129172, 9.219482];
                                }
                                _context.next = 23;
                                break;

                            case 20:
                                _context.prev = 20;
                                _context.t0 = _context['catch'](13);
                                throw _context.t0;

                            case 23:
                                _context.next = 28;
                                break;

                            case 25:
                                _context.prev = 25;
                                _context.t1 = _context['catch'](9);
                                throw _context.t1;

                            case 28:
                                _context.next = 33;
                                break;

                            case 30:
                                _context.prev = 30;
                                _context.t2 = _context['catch'](5);
                                throw _context.t2;

                            case 33:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[5, 30], [9, 25], [13, 20]]);
            }))();
        },
        generateGoogleMapsLink: function generateGoogleMapsLink(adresse) {
            // let windowReference = window.open()
            // new Promise((resolve, reject) => {
            //     navigator.geolocation.getCurrentPosition(position => {
            //         resolve(position)
            //     })
            // }).then(position => {
            //     let url = `https://www.google.com/maps/dir/${position.coords.latitude},${position.coords.longitude}/${adresse.vejnavn}+${adresse.husnummer},+${adresse.postnummer}+${adresse.by}`
            //     // windowReference.name = '_blank'
            //     windowReference.location = url
            // })
            navigator.geolocation.getCurrentPosition(function (position) {
                var url = 'https://www.google.com/maps/dir/' + position.coords.latitude + ',' + position.coords.longitude + '/' + adresse.vejnavn + '+' + adresse.husnummer + ',+' + adresse.postnummer + '+' + adresse.by;
                window.open(url, '_blank');
            });
        }
        // init() {
        //     var _this = this;
        //     var marker = [];
        //     var items = [];
        //     var user = JSON.parse(this.$cookie.get('user'));

        //     return new Promise(function (resolve, reject) {

        //         DAL.iterate("MTTempData", function (value, key, iterationNumber) {

        //             if (value.montoerId == user.id) {
        //                 var date = moment(value.fratid).format('YYYYMMDD');

        //                 if (window['selectedDate'] != null) {
        //                     if (date.includes(window['selectedDate'])) {
        //                         items.push(value);
        //                     }
        //                 } else {
        //                     var now = moment(new Date()).format('YYYYMMDD');

        //                     if (date.includes(now)) {
        //                         items.push(value);
        //                     }
        //                 }
        //             }

        //         }).then(function () {
        //             DAL.iterate("MTTasks", function (value, key, iterationNumber) {
        //                 var date = moment(value.fratid).format('YYYYMMDD');
        //                 var selected = '';

        //                 if (value.montoerId == user.id) {
        //                     if (window['selectedDate'] != null) {
        //                         selected = window['selectedDate'];
        //                     } else {
        //                         selected = moment(new Date()).format('YYYYMMDD');
        //                     }

        //                     if (date.includes(selected)) {
        //                         var tempItems = items;
        //                         var existsBool = false;
        //                         tempItems.forEach(function(item){
        //                             if(item.id === value.id){
        //                                 existsBool = true;
        //                             }
        //                         });

        //                         if(!existsBool){
        //                             items.push(value);
        //                             existsBool = false;
        //                         }
        //                     }
        //                 }
        //             }).then(function () {
        //                 resolve(items)
        //             })
        //         })

        //     }).then(function (result) {
        //         return new Promise((resolve, reject) => {
        //             navigator.geolocation.getCurrentPosition(currentPosition => {
        //                 currentPosition = currentPosition.coords
        //                 resolve({position: currentPosition, items: result})
        //             })
        //         })
        //     }).then(function (object) {
        //         return new Promise(function (resolve, reject) {
        //             let result = object.items

        //             result.sort(function(a, b) {
        //                 return new Date(a.fratid) - new Date(b.fratid);
        //             });

        //             for (var i in result) {

        //                 var value = result[i];

        //                 if (value.adresse.koordinater == null ) {
        //                     console.log("koordinat er null");
        //                 } else if (value.adresse.koordinater.x == null || value.adresse.koordinater.y == null || value.adresse.koordinater.x == 0 || value.adresse.koordinater.y == 0) {
        //                     console.log("koordinat er null");
        //                 } else {
        //                     console.log("if coordinates is defined")
        //                     var x = value.adresse.koordinater.x;
        //                     var y = value.adresse.koordinater.y;
        //                     var popupContent = '';

        //                     Proj4js.defs["EPSG:4326"] = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs";
        //                     Proj4js.defs["EPSG:25832"] = "+title=  ETRF89 / UTM zone 32N EPSG:25832 +proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"

        //                     var source = new Proj4js.Proj("EPSG:25832");
        //                     var dest = new Proj4js.Proj("EPSG:4326");

        //                     var point = new Proj4js.Point(x, y);

        //                     Proj4js.transform(source, dest, point);

        //                     popupContent = '<h4 class="text-center">' + value.bookingTypeNavn + '</h4>'
        //                     popupContent += '<b>Adresse:</b> <br />' + value.adresse.vejnavn + ' ' + value.adresse.husnummer;
        //                     if (value.adresse.etage == null || value.adresse.etage == undefined || value.adresse.etage == '') {
        //                         // No data
        //                     } else {
        //                         popupContent += '. ' + value.adresse.etage;
        //                     }
        //                     if (value.adresse.doer == null || value.adresse.doer == undefined || value.adresse.doer == '') {
        //                         // No data
        //                     } else {
        //                         popupContent += ' - ' + value.adresse.doer;
        //                     }
        //                     popupContent += ', ' + value.adresse.postnummer + ' ' + value.adresse.by;
        //                     popupContent += '<br />';
        //                     popupContent += '<b>Tidspunkt:</b> <br /> ' + moment(value.fratid).format('HH:mm') + ' - ' + moment(value.tiltid).format('HH:mm');
        //                     popupContent += '<br />';
        //                     popupContent += '<b>Kunde:</b>' + '<br />' + value.kunde.navn;
        //                     popupContent += '<br />';
        //                     popupContent += '<a class="button" href="/#/projekt/' + value.id +'">Gå til booking</a>';
        //                     popupContent += `<a class="button" target="_blank" style="margin-top: 0px;" href="https://www.google.com/maps/dir/${object.position.latitude},${object.position.longitude}/${value.adresse.vejnavn}+${value.adresse.husnummer},+${value.adresse.postnummer}+${value.adresse.by}">Rutevejledning</a>`

        //                     var setIcon = function(item) {
        //                         if (
        //                             item.nyMaalerStand !== null && item.nyMaalerStand !== ""
        //                             && item.nytMaalernummer !== null && item.nytMaalernummer !== ""
        //                             && item.sidsteaflaesning > 0 && item.sidsteaflaesning !== null && item.sidsteaflaesning !== ""
        //                             && item.maalerStand !== undefined && item.maalerStand != "" && item.maalerStand !== null
        //                         ){
        //                             if (item.nytidTypeId === undefined || item.nytidTypeId === 0) {
        //                                 return new L.icon({  
        //                                     iconUrl: greenCircle,
        //                                     iconSize: [25, 25],
        //                                     iconAnchor: [12.5, 12.5]
        //                                 })
        //                             } else if (item.nytidTypeId > 0) {
        //                                 return new L.icon({
        //                                     iconUrl: redCircle,
        //                                     iconSize: [25, 25],
        //                                     iconAnchor: [12.5, 12.5]
        //                                 })
        //                             } else {
        //                                 return new L.icon({
        //                                     iconUrl: blackCircle,
        //                                     iconSize: [25, 25],
        //                                     iconAnchor: [12.5, 12.5]
        //                                 })
        //                             }
        //                         } else if (item.nytidTypeId > 0) {
        //                             return new L.icon({
        //                                 iconUrl: redCircle,
        //                                 iconSize: [25, 25],
        //                                 iconAnchor: [12.5, 12.5]
        //                             })
        //                         } else {
        //                             return new L.icon({
        //                                 iconUrl: blackCircle,
        //                                 iconSize: [25, 25],
        //                                 iconAnchor: [12.5, 12.5]
        //                             })
        //                         }
        //                     }

        //                     var iteration = parseInt(i) + 1;

        //                     console.log("value", value)

        //                     marker.push({
        //                         coordinates: L.latLng(point.y, point.x), 
        //                         popup: popupContent, 
        //                         tooltip: iteration.toString(),
        //                         icon: setIcon(value),
        //                         stroke: false,
        //                         weight: 0,
        //                         opacity: 1,
        //                         nyMaalerStand: value.nyMaalerStand,
        //                         nytMaalernummer: value.nytMaalernummer,
        //                         sidsteaflaesning: value.sidsteaflaesning,
        //                         maalerStand: value.maalerStand,
        //                         nytidTypeId: value.nytidTypeId
        //                     })
        //                 }
        //             }
        //             if (marker.length > 0) {
        //                 console.log("if marker.length > 0")

        //                 _this.markers = marker;

        //                 for (i in marker) {
        //                     if (
        //                         marker[i].nyMaalerStand !== null && marker[i].nyMaalerStand !== ""
        //                         && marker[i].nytMaalernummer !== null && marker[i].nytMaalernummer !== ""
        //                         && marker[i].sidsteaflaesning > 0 && marker[i].sidsteaflaesning !== null && marker[i].sidsteaflaesning !== ""
        //                         && marker[i].maalerStand !== undefined && marker[i].maalerStand != "" && marker[i].maalerStand !== null
        //                     ) {
        //                         if (marker[i].nytidTypeId === undefined || marker[i].nytidTypeId === 0) {
        //                             _this.centerObj.push(marker[i].coordinates)
        //                         } else {
        //                             // red color
        //                         }
        //                     } else if (marker[i].nytidTypeId > 0) {
        //                         // red color
        //                     } else {
        //                         // black color
        //                         _this.unfinishedObj.push(marker[i].coordinates)
        //                     }
        //                 }

        //                 if (_this.unfinishedObj !== [] && _this.unfinishedObj[0] !== undefined) {
        //                     console.log("if unfinishedObj != []")
        //                     console.log(_this.unfinishedObj)
        //                     _this.center = _this.unfinishedObj[0];
        //                 } else {

        //                     if (_this.centerObj != []) {
        //                         console.log("if centerObj")
        //                         for (i in _this.centerObj) {
        //                             if (_this.centerObj[i].lat < _this.minX || _this.minX == null) {
        //                                 _this.minX = _this.centerObj[i].lat;
        //                             }
        //                             if (_this.centerObj[i].lng < _this.minY || _this.minY == null) {
        //                                 _this.minY = _this.centerObj[i].lng;
        //                             }
        //                             if (_this.centerObj[i].lat > _this.maxX || _this.minX == null) {
        //                                 _this.maxX = _this.centerObj[i].lat;
        //                             }
        //                             if (_this.centerObj[i].lng > _this.maxY || _this.minX == null) {
        //                                 _this.maxY = _this.centerObj[i].lng;
        //                             }
        //                         }

        //                         var calcX = ((_this.maxX - _this.minX) / 2) + _this.minX;
        //                         var calcY = ((_this.maxY - _this.minY) / 2) + _this.minY;
        //                         var newCenterObject = [calcX, calcY]

        //                         if (newCenterObject !== []) {
        //                             console.log("if newCenterObj")
        //                             _this.center = newCenterObject;
        //                             _this.zoom = 12;
        //                         } else {
        //                             console.log("else")
        //                         }
        //                     } else {
        //                         console.log("else wat")
        //                     }
        //                 }
        //             } else {
        //                 _this.center = [56.129172, 9.219482]
        //             }
        //         });
        //     });
        // }

    },
    mounted: function mounted() {
        // var _this = this;
        $(document).foundation();
        $('header').show();
        // this.init().then(function (result) {
        //     console.log("init after", result)
        //     if (result.length > 0) {
        //         console.log("result", result);
        //         _this.markers = result;
        //         _this.center = result[0].coordinates;
        //     }
        // });
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return _this2.init();

                        case 3:
                            // let cookie = this.$cookie.get('apikey')
                            // if (cookie === 'DBB06AEE-989F-4F9E-847A-DC5C97FAA94A') {
                            //     alert(this.center)
                            // }
                            // this.center = [56.129172, 9.219482]
                            _this2.doneLoading = true;
                            _context2.next = 10;
                            break;

                        case 6:
                            _context2.prev = 6;
                            _context2.t0 = _context2['catch'](0);

                            console.log('error init map', _context2.t0);
                            _this2.doneLoading = true;

                        case 10:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[0, 6]]);
        }))();
    }
});

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__ = __webpack_require__(52);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'helpmodal',
    data: function data() {
        return {
            overlay: false
        };
    },

    methods: {
        closeModal: function closeModal() {
            this.$emit('close');
        },
        clearAll: function clearAll() {
            var _this = this;

            this.overlay = true;
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__["a" /* default */].clearStore('MTBookingTypes').then(function (result) {});
                __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__["a" /* default */].clearStore('MTNoteTypes').then(function (result) {});
                __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__["a" /* default */].clearStore('MTPlacementTypes').then(function (result) {});
                __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__["a" /* default */].clearStore('MTSettings').then(function (result) {});
                __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__["a" /* default */].clearStore('MTTasks').then(function (result) {});
                __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__["a" /* default */].clearStore('MTTimeTypes').then(function (result) {});
                __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__["a" /* default */].clearStore('MTUsers').then(function (result) {});
                __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__["a" /* default */].clearStore('MTTempData').then(function (result) {});
                __WEBPACK_IMPORTED_MODULE_0__js_Sync_dal__["a" /* default */].clearStore('MTTempImages').then(function (result) {});

                _this.$cookie.delete('downloaded');
                _this.$cookie.delete('url');
                _this.$cookie.delete('user');
                _this.$cookie.delete('version');

                _this.overlay = false;
                _this.$emit('close');

                _this.$router.push({
                    name: 'default'
                });
            }, 3000);
        }
    }
});

/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_webrtc_adapter__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_webrtc_adapter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_webrtc_adapter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zxing_library__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zxing_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__zxing_library__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'modal',
    data: function data() {
        return {
            lastResult: null,
            finalResult: "",
            codeReader: null
        };
    },

    methods: {
        stopCamera: function stopCamera(e) {
            e.preventDefault();
            this.codeReader.reset();
            this.$emit("close", this.finalResult, false);
        },
        cancelCamera: function cancelCamera(e) {
            e.preventDefault();
            this.codeReader.reset();
            this.$emit("close", null, false);
        }
    },
    watch: {
        finalResult: function finalResult(val, oldVal) {
            if (oldVal != val) {
                console.log("oldVal", oldVal);
                console.log("val", val);
            }
        }
    },
    created: function created() {},
    mounted: function mounted() {
        try {
            var _this = this;
            $(document).foundation();

            var hints = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
            hints.set(__WEBPACK_IMPORTED_MODULE_2__zxing_library__["DecodeHintType"].TRY_HARDER, true);

            var videoHtmlElementId = "video";
            var codeReader = new __WEBPACK_IMPORTED_MODULE_2__zxing_library__["BrowserBarcodeReader"]();
            _this.codeReader = codeReader;

            codeReader.listVideoInputDevices().then(function (devices) {
                var handleDecodeResult = function handleDecodeResult(result, error) {
                    if (result) {
                        _this.finalResult = result.getText();
                    }
                };
                codeReader.decodeFromVideoDevice(undefined, videoHtmlElementId, handleDecodeResult);
            });
        } catch (e) {
            console.log(e.message);
            _this.finalResult = e.message;
        }
    }
});

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'startpage',
    data: function data() {
        return {
            msg: ''
        };
    },
    mounted: function mounted() {
        var _this = this;
        $(document).foundation();
        $('header').hide();
        setTimeout(function () {
            _this.$router.push({
                name: 'init',
                params: { key: 'Key' }
            });
        }, 100);
    }
});

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_Sync_dal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_Sync_clearQueue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zangodb__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zangodb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_zangodb__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'init',
    data: function data() {
        return {
            step1: true,
            step2: false,
            step3: false,
            //key: '58255dfc-7963-46f5-9001-302da1f70327',
            //key: 'DBB06AEE-989F-4F9E-847A-DC5C97FAA94A',
            key: '',
            validated: false,
            user: '',
            selected: '',
            errorMessage: '',
            options: [],
            empty: true,
            showLoader: false,
            activeStep: 0,
            totalSteps: 1,
            downloading: false,
            url: '',
            message: ''
        };
    },

    methods: {
        gotoStep2: function gotoStep2() {
            this.step1 = false;
            this.step2 = true;
            this.step3 = false;
            this.errorMessage = "";
        },
        gotoStep1: function gotoStep1() {
            this.step1 = true;
            this.step2 = false;
            this.step3 = false;
            this.errorMessage = "";
        },
        validateKey: function validateKey() {
            this.downloading = true;
            var _this = this;
            var promiseArray = [];
            var promises = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve()];
            window['apikey'] = this.key;
            if (navigator.onLine) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_Sync_clearQueue__["a" /* default */])(promises).then(function () {
                    try {
                        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            _this.$http.get('//mobileservice.maalertjek.niras.dk/api/indstillinger').then(function (response) {
                                return resolve(response);
                            }).catch(function (err) {
                                return _this.errorMessage = "Den angivne nøgle er forkert";
                            }, _this.downloading = false, reject);
                        }).then(function (response) {
                            return response.body;
                        }, function (response) {
                            _this.errorMessage = "Den angivne nøgle er forkert";
                            _this.downloading = false;
                            return false;
                        });
                    } catch (err) {
                        console.log("err");
                        _this.errorMessage = "Der skete en fejl. Prøv venligst igen";
                    }
                }).then(function (data) {
                    if (data == undefined) {
                        _this.errorMessage = "Den angivne nøgle er forkert";
                        _this.downloading = false;
                    } else {
                        _this.downloading = true;
                        window['url'] = data.serviceUrl;
                        window['version'] = data.serviceVersion;
                        return __WEBPACK_IMPORTED_MODULE_2__js_Sync_dal__["a" /* default */].setItem("MTSettings", "settings", data);
                    }
                }).then(function () {
                    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        _this.$http.get(window['url'] + 'v' + window['version'] + '/lister/montoerer').then(function (response) {
                            return resolve(response);
                        }).catch(function () {
                            return _this.errorMessage = "Der skete en fejl. Prøv venligst igen";
                        }, reject);
                    }).then(function (response) {
                        return response.body;
                    }, function (response) {
                        _this.errorMessage = "Den angivne nøgle er forkert";
                        _this.downloading = false;
                        return false;
                    });
                }).then(function (data) {
                    if (data == undefined) {
                        _this.errorMessage = "Den angivne nøgle er forkert";
                        _this.downloading = false;
                    } else {
                        _this.errorMessage = '';
                        _this.validated = true;
                        _this.options = data;
                        _this.step1 = false;
                        _this.step2 = true;
                        _this.step3 = false;
                        _this.errorMessage = "";
                        _this.downloading = false;
                        return __WEBPACK_IMPORTED_MODULE_2__js_Sync_dal__["a" /* default */].setItem("MTUsers", "users", data);
                    }
                });
            } else {
                _this.errorMessage = "Du har ikke noget internet";
            }
        },
        chooseUser: function chooseUser() {
            if (this.empty == false) {
                this.$cookie.set('url', window['url'], { expires: '20Y' });
                this.$cookie.set('version', window['version'], { expires: '20Y' });
                this.$cookie.set('apikey', window['apikey'], { expires: '20Y' });
                this.$cookie.set('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(window['user']), { expires: '20Y' });
                this.step1 = false;
                this.step2 = false;
                this.step3 = true;
                this.errorMessage = "";
            } else {
                this.errorMessage = "Vælg en bruger i listen";
            }
        },
        getServerData: function getServerData() {
            var _this = this;
            var promiseArray = [];
            this.showLoader = true;
            var promises = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve()];

            // Check om der allerede findes noget i indexedDB
            // Slet hvis det findes

            if (navigator.onLine) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_Sync_clearQueue__["a" /* default */])(promises).then(function () {
                    var _this2 = this;

                    _this.activeStep = 1;
                    _this.message = "Dette kan tage lidt tid...";
                    try {
                        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            _this.$http.get(window['url'] + 'v' + window['version'] + '/lister/allelister').then(function (response) {
                                return resolve(response);
                            }).catch(function () {
                                return reject;
                            });
                        }).then(function (response) {
                            return response.body;
                        }, function (response) {
                            _this2.message = "";
                            _this2.errorMessage = "Der opstod en fejl under installationen";
                            return false;
                        });
                    } catch (err) {
                        console.log("err", err);
                        _this.errorMessage = "Der skete en fejl. Prøv venligst igen";
                    }
                }).then(function (data) {
                    if (data == undefined) {
                        this.message = "";
                        this.errorMessage = "Der opstod en fejl under installationen";
                    } else {
                        var promiseArray = [];

                        data.bookinger.forEach(function (booking) {
                            promiseArray.push(function () {
                                return __WEBPACK_IMPORTED_MODULE_2__js_Sync_dal__["a" /* default */].setItem("MTTasks", booking.id, booking).then(function () {});
                            });
                        });

                        __WEBPACK_IMPORTED_MODULE_2__js_Sync_dal__["a" /* default */].setItem("MTBookingTypes", "bookingtypes", data.bookingTyper);
                        __WEBPACK_IMPORTED_MODULE_2__js_Sync_dal__["a" /* default */].setItem("MTTimeTypes", "timetypes", data.nyTidTyper);
                        __WEBPACK_IMPORTED_MODULE_2__js_Sync_dal__["a" /* default */].setItem("MTNoteTypes", "notetypes", data.bemaerkningTyper);
                        __WEBPACK_IMPORTED_MODULE_2__js_Sync_dal__["a" /* default */].setItem("MTPlacementTypes", "placementtypes", data.placeringTyper);

                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_Sync_clearQueue__["a" /* default */])(promiseArray);
                    }
                }).then(function () {
                    _this.showLoader = false;
                    _this.message = "";
                    _this.$cookie.set('downloaded', true, { expires: '1Y' });
                    _this.$router.push({
                        name: 'projekter'
                    });
                });
            } else {
                _this.errorMessage = "Du har ikke noget internet";
            }
        }
    },
    watch: {
        selected: function selected(val, oldVal) {
            if (oldVal != val) {
                window['user'] = { navn: val.navn, id: val.id };
                if (val != '') {
                    this.empty = false;
                    this.errorMessage = '';
                } else {
                    ;
                    this.empty = true;
                }
            }
        }
    },
    mounted: function mounted() {
        $(document).foundation();
        $('header').hide();

        console.log("mounted", this.$route.params.key);

        var _this = this;
        if (this.$route.params.key) {
            if (this.$cookie.get('apikey')) {
                console.log("got key from cookie");
                this.key = this.$cookie.get('apikey');
            } else if (this.$route.params.key != "Key") {
                this.key = this.$route.params.key;
            } else {
                this.key = "";
            }
        }

        if (this.$cookie.get('downloaded')) {
            _this.$router.push({
                name: 'projekter'
            });
        } else {
            console.log("app isn't downloaded");
        }
    }
});

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MapComponent_vue__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MapComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MapComponent_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var state = {
    date: ''
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'kort',
    components: {
        mapcomponent: __WEBPACK_IMPORTED_MODULE_1__components_MapComponent_vue___default.a,
        Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a
    },
    data: function data() {
        return {
            state: state,
            selectedDate: window['selectedDate'],
            today: new Date()
        };
    },

    filters: {
        moment: function (_moment) {
            function moment(_x) {
                return _moment.apply(this, arguments);
            }

            moment.toString = function () {
                return _moment.toString();
            };

            return moment;
        }(function (text) {
            return moment(text).format('DD[.] MMM YYYY');
        })
    },
    methods: {
        goBack: function goBack() {
            this.$router.go(-1);
        }
    },
    mounted: function mounted() {
        $(document).foundation();
        $('header').hide();
        var _this = this;

        if (!this.$cookie.get('downloaded')) {
            _this.$router.push({
                name: 'default'
            });
        }
    }
});

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormUpload__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FormUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_FormUploadHandler__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_web_cam__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_web_cam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_web_cam__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__webpack_require__(887);
__webpack_require__(896);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "projekt",
    components: {
        FormUpload: __WEBPACK_IMPORTED_MODULE_2__components_FormUpload___default.a,
        modal: __WEBPACK_IMPORTED_MODULE_4__components_modal___default.a,
        WebCam: __WEBPACK_IMPORTED_MODULE_5_vue_web_cam__["WebCam"]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_FormUploadHandler__["a" /* default */]],
    data: function data() {
        return {
            showModal: false,
            images: "",
            filteredResult: "",
            show: "booking",
            noteselect: "",
            note: "",
            overlay: false,
            userEmail: "",
            difference: null,
            diff: '',
            localImages: [],
            timetypes: [],
            selected: null,
            notetypes: [],
            data: {
                målerplacering: "",
                tidligerestand: null,
                tidligereaktuelstand: null,
                nummer: null,
                aktuelstand: 0,
                nytidselect: 0,
                email: "",
                mobil: ""
            },
            popup: false,
            maxDeviation: null,
            deviation: false,
            webcam: {
                active: false,
                text: 'Aktiver kamera',
                availableCameras: null,
                selectedCameraId: null
            }
        };
    },

    methods: {
        scanClick: function scanClick() {
            this.showModal = true;
        },
        closeAlert: function closeAlert() {
            this.deviation = false;
        },
        childClicked: function childClicked(result, value) {
            var _this = this;
            var input = document.getElementById('number');

            if (value == false) {
                if (result != null) {
                    _this.data.nummer = result;
                    input.value = result;
                }
            }
            console.log("result", result);
            this.showModal = false;
        },
        goBack: function goBack() {
            this.$router.go(-1);
        },
        gotoMap: function gotoMap() {
            this.$router.push({
                name: "kort"
            });
        },
        closeMenu: function closeMenu() {
            this.overlay = false;
        },
        receipt: function receipt() {
            this.overlay = true;
        },
        saveInfo: function saveInfo() {
            var data = this.filteredResult;
            var _this = this;

            this.popup = true;

            setTimeout(function () {
                _this.popup = false;
            }, 1500);

            data.maalerplacering = this.data.målerplacering;
            data.sidsteaflaesning = this.data.tidligerestand;
            data.maalerStand = this.data.tidligereaktuelstand;
            data.nytMaalernummer = this.data.nummer;
            data.nyMaalerStand = this.data.aktuelstand;
            data.bemaerkning = this.note;
            if (this.noteselect != "") {
                data.bemaerkning += '\r\n' + this.noteselect;
            }
            data.nytidTypeId = this.data.nytidselect;
            if (this.data.email != "") {
                data.kunde.email = this.data.email;
            }
            if (this.data.mobil != "") {
                data.kunde.mobil = this.data.mobil;
            }

            console.log('data', data);

            __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].setItem("MTTempData", data.id, data).then(function () {
                _this.$store.dispatch('updateNotification', 1);
            });

            this.checkDeviation(); // check om der er en afvigelse på årsforbrug på mere end 15 % 
        },
        removeImage: function removeImage(image) {
            console.log("remove image", image);
        },
        goToBooking: function goToBooking() {
            this.show = "booking";
        },
        goToCustomer: function goToCustomer() {
            this.show = "customer";
        },
        goToNotes: function goToNotes() {
            this.show = "notes";
        },
        goToImages: function goToImages() {
            this.show = "images";
        },
        getServerData: function getServerData() {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var tasks = [];

                __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].iterate("MTTempData", function (value, key, iterationNumber) {
                    if (value.id == _this.$route.params.id) {
                        tasks.push(value);
                    }
                }).then(function () {
                    if (tasks.length > 0) {
                        console.log("found some data");
                    } else {
                        return __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].iterate("MTTasks", function (value, key, iterationNumber) {
                            if (value.id == _this.$route.params.id) {
                                console.log("found something inside tasks", value);
                                tasks.push(value);
                            }
                        });
                    }
                }).then(function () {
                    _this.filteredResult = tasks[0];
                    _this.data.målerplacering = _this.filteredResult.maalerplacering;
                    _this.data.tidligerestand = _this.filteredResult.sidsteaflaesning;
                    _this.data.tidligereaktuelstand = _this.filteredResult.maalerStand;
                    _this.data.aktuelstand = _this.filteredResult.nyMaalerStand;
                    _this.data.nummer = _this.filteredResult.nytMaalernummer;
                    _this.note = _this.filteredResult.bemaerkning;
                    _this.data.nytidselect = _this.filteredResult.nytidTypeId;

                    if (_this.data.nytidTypeId != undefined) {
                        _this.selected = _this.data.nytidTypeId;
                    }
                    resolve(tasks);
                });
            }).then(function () {
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].iterate('MTTempImages', function (value, key, iterationNumber) {
                        if (value.projectId == _this.filteredResult.id) {
                            _this.localImages.push(value);
                        }
                    }).then(function () {
                        console.log("images", _this.localImages);
                        resolve(_this.localImages);
                    });
                });
            });
        },
        checkDeviation: function checkDeviation() {
            console.log('check deviation');
            this.beregnForbrugAfvigelseIProcentForDato(this.filteredResult.sidsteaflaesning, this.filteredResult.aflaesningsdato, this.filteredResult.maalerStand, this.filteredResult.fratid, this.filteredResult.aarsforbrug);
        },
        dateString2Date: function dateString2Date(date) {
            var dateFormat = new Date(date);
            var newDate = new Date(dateFormat.getFullYear(), dateFormat.getMonth(), dateFormat.getDate());
            return newDate;
        },
        beregnForbrug: function beregnForbrug(senesteStand, nyStand) {
            var forbrug = nyStand - senesteStand;
            return forbrug;
        },
        beregnForventetForbrugForDato: function beregnForventetForbrugForDato(senesteStandDatoTid, nyStandDatoTid, aarsforbrug) {
            var oneDayInMiliseconds = 86400000;
            var totalDays = Math.floor((this.dateString2Date(nyStandDatoTid) - this.dateString2Date(senesteStandDatoTid)) / oneDayInMiliseconds);
            var totalYears = totalDays / 365.0;
            var forventetForbrug = totalYears * aarsforbrug;
            return forventetForbrug;
        },
        beregnForbrugAfvigelseIProcent: function beregnForbrugAfvigelseIProcent(forventetForbrug, forbrug) {
            var forbrugAfvigelse = Math.abs(forbrug - forventetForbrug) / forventetForbrug;
            if (forbrugAfvigelse === Infinity || forbrugAfvigelse < 0) {
                forbrugAfvigelse = 0;
            }
            var forbrugAfvigelseIProcent = forbrugAfvigelse * 100;
            return forbrugAfvigelseIProcent;
        },
        beregnForbrugAfvigelseIProcentForDato: function beregnForbrugAfvigelseIProcentForDato(senesteStand, senesteStandDatoTid, nyStand, nyStandDatoTid, aarsforbrug) {
            var _this = this;
            var forventetForbrug = this.beregnForventetForbrugForDato(senesteStandDatoTid, nyStandDatoTid, aarsforbrug);
            console.log('forventetForbrug', forventetForbrug);
            var forbrug = this.beregnForbrug(senesteStand, nyStand);
            console.log('forbrug', forbrug);
            var forbrugAfvigelseIProcent = this.beregnForbrugAfvigelseIProcent(forventetForbrug, forbrug);
            console.log('forbrugAfvigelseIProcent', forbrugAfvigelseIProcent);
            var maxDeviation = null;

            __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].getItem('MTSettings', 'settings').then(function (result) {
                if (result == null) {
                    console.log("Kunne ikke finde nogle indstillinger i IDB");
                } else {
                    console.log('maxAfvigelseFraForventetForbrug', result.maxAfvigelseFraForventetForbrug);
                    _this.maxDeviation = result.maxAfvigelseFraForventetForbrug;
                }
            }).then(function () {
                if (_this.maxDeviation !== null && forbrugAfvigelseIProcent > _this.maxDeviation) {
                    _this.deviation = true;
                    console.log('Der er en afvigelse på mere end ' + _this.maxDeviation + '!');
                }
            });
        },
        capture_screenshot: function capture_screenshot() {
            this.gotScreenshot(this.$refs.webcam.capture());
        },
        toggleCamera: function toggleCamera() {
            if (this.webcam.active) {
                this.webcam.active = false;
                this.webcam.text = 'Aktiver kamera';
                this.webcam.availableCameras = null;
                this.webcam.selectedCameraId = null;
            } else {
                this.webcam.active = true;
                this.webcam.text = 'Deaktiver kamera';
            }
        },
        getAvailableCameras: function getAvailableCameras(list) {
            this.webcam.availableCameras = list;
            if (list.length > 1) {
                this.webcam.selectedCameraId = list[1].deviceId;
            } else {
                this.webcam.selectedCameraId = list[0].deviceId;
            }
        }
    },
    filters: {
        moment: function (_moment) {
            function moment(_x) {
                return _moment.apply(this, arguments);
            }

            moment.toString = function () {
                return _moment.toString();
            };

            return moment;
        }(function (text) {
            return moment(text).format('HH:mm');
        }),
        formattedDate: function formattedDate(text) {
            return moment(text).format('DD MMMM [kl.] HH:mm');
        },
        shorten: function shorten(text) {
            if (text.length > 28) {
                return text.substring(0, 28) + '...';
            }
            return text;
        }
    },
    beforeMount: function beforeMount() {
        this.getServerData();
    },
    mounted: function mounted() {
        var _this = this;
        $(document).foundation();
        $("header").hide();

        _this.openScan = false;

        __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].getItem('MTTimeTypes', 'timetypes').then(function (result) {
            if (result == null) {
                console.log("Kunne ikke finde nogle tidstyper i IDB");
            } else {
                _this.timetypes = result;
            }
        });

        __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].getItem('MTNoteTypes', 'notetypes').then(function (result) {
            if (result == null) {
                console.log("Kunne ikke finde nogle bemærkningstyper i IDB");
            } else {
                _this.notetypes = result;
            }
        });

        __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].getItem('MTBookingTypes', 'bookingtypes').then(function (result) {
            if (result == null) {
                console.log("Kunne ikke finde nogle bookingtyper i IDB");
            } else {
                _this.bookings = result;
            }
        });

        __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].getItem('MTPlacementTypes', 'placementtypes').then(function (result) {
            if (result == null) {
                console.log("Kunne ikke finde nogle placeringstyper i IDB");
            } else {
                _this.placement = result;
            }
        });
    }
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_Sync_clearQueue__ = __webpack_require__(89);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _ = __webpack_require__(898);




var state = {
  date: ''
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projekter',
  props: ['reloadData'],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      selectedUser: '',
      projects: [],
      users: '',
      // Datepicker
      state: state,
      // Filtered
      filteredResult: [],
      createNew: false,
      showUserList: false
    };
  },

  computed: {
    projectView: function projectView() {
      return this.filteredResult;
    }
  },
  watch: {
    reloadData: function reloadData(oldVal, val) {
      if (oldVal != val) {
        this.getTasksFromIDB(window['selectedDate'], window['user'].id);
      }
    }
  },
  methods: {
    classObject: function classObject(item) {
      // console.log('item.nyMaalerStand !== null', item.nyMaalerStand !== null)
      // console.log('item.nyMaalerStand !== ""', item.nyMaalerStand !== "")
      // console.log('item.nytMaalernummer !== null', item.nytMaalernummer !== null)
      // console.log('item.nytMaalernummer !== ""', item.nytMaalernummer !== "")
      // console.log('item.sidsteaflaesning', item.sidsteaflaesning)
      // console.log('item.sidsteaflaesning > 0', item.sidsteaflaesning > 0)
      // console.log('item.sidsteaflaesning !== null', item.sidsteaflaesning !== null)
      // console.log('item.sidsteaflaesning !== ""', item.sidsteaflaesning !== "")
      // console.log('item.maalerStand !== undefined', item.maalerStand !== undefined)
      // console.log('item.nytidTypeId === undefined', item.nytidTypeId === undefined)
      // console.log('item.nytidTypeId === 0', item.nytidTypeId === 0)
      // console.log('item.nytidTypeId > 0', item.nytidTypeId > 0)
      // console.log('item end')

      if (item.maalerStand !== undefined && item.maalerStand !== "" && item.maalerStand !== null) {
        return {
          'green-color': true
        };
      } else if (item.nytMaalernummer !== null && item.nytMaalernummer !== "") {
        return false;
      } else if (item.nytidTypeId > 0) {
        return {
          'red-color': true
        };
      } else {
        return false;
      }
    },
    gotoProject: function gotoProject(project) {
      this.$router.push({
        name: 'projekt',
        params: { id: project.id }
      });
    },
    getSelectedDate: function getSelectedDate(date) {
      if (date == undefined || date == "" || date == null) {
        date = new Date();
      }
      var formatted = moment(date).format('YYYYMMDD');
      window['selectedDate'] = formatted;
      this.getTasksFromIDB(formatted, window['user'].id);
    },
    showUsers: function showUsers() {
      this.showUserList = !this.showUserList;
      //$('.user-list').toggle();
    },
    selectUser: function selectUser(user) {
      this.selectedUser = user;
      console.log('user', user);
      window['user'] = user;
      this.$cookie.delete('user');
      this.$cookie.set('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(window['user']), { expires: '20Y' });
      this.getSelectedDate(this.state.date);
    },
    getTasksFromIDB: function getTasksFromIDB(selectedDate, selectedUserId) {
      var _this = this;
      var tasks = [];

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (selectedDate == null || selectedDate == undefined || selectedDate == '') {
          selectedDate = moment(new Date()).format('YYYYMMDD');
        }
        __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].iterate("MTTempData", function (value, key, iterationNumber) {
          var date = moment(value.fratid).format('YYYYMMDD');
          if (date.includes(selectedDate)) {
            if (value.montoerId == selectedUserId) {
              console.log("value", value);
              tasks.push(value);
            }
          }
        }).then(function () {
          return __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].iterate("MTTasks", function (value, key, iterationNumber) {
            var date = moment(value.fratid).format('YYYYMMDD');
            if (date.includes(selectedDate)) {
              var tempTasks = tasks;
              var existsBool = false;
              if (value.montoerId == selectedUserId) {
                tempTasks.forEach(function (item) {
                  if (item.id === value.id) {
                    existsBool = true;
                  }
                });
                if (!existsBool) {
                  tasks.push(value);
                  existsBool = false;
                }
              }
            }
          }).then(function () {
            resolve(tasks);
          });
        });
      }).then(function (result) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          tasks.sort(function (a, b) {
            return new Date(a.fratid) - new Date(b.fratid);
          });
          if (selectedDate != null) {
            _this.projects = tasks;
            _this.sortByUser(tasks);
          } else {
            _this.projects = tasks;
          }
          resolve(tasks);
        });
      }).then(function () {
        _this.sortByUser(tasks);
      });
    },
    sortByUser: function sortByUser(data) {
      this.filteredResult = [];
      for (var i = 0; i < data.length; i++) {
        if (data[i].montoerId == this.selectedUser.id) {
          this.filteredResult.push(data[i]);
        }
      }
    }
  },
  filters: {
    moment: function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    }(function (text) {
      return moment(text).format('HH:mm');
    }),
    shorten: function shorten(text) {
      if (text.length > 24) {
        return text.substring(0, 24) + '...';
      }
      return text;
    }
  },
  mounted: function mounted() {
    var _this = this;

    $(document).foundation();
    $('header').show();

    if (!this.$cookie.get('downloaded')) {
      _this.$router.push({
        name: 'default'
      });
    } else {
      var today = moment(new Date());
      window['user'] = JSON.parse(this.$cookie.get('user'));
      this.selectedUser = window['user'];
      window['apikey'] = this.$cookie.get('apikey');

      __WEBPACK_IMPORTED_MODULE_3__js_Sync_dal__["a" /* default */].getItem('MTUsers', 'users').then(function (result) {
        if (result == null) {
          console.log("Kunne ikke finde nogle brugere i IDB");
        } else {
          _this.users = result;
        }
      });

      // get tasks for the given date
      this.getTasksFromIDB(window['selectedDate'], window['user'].id);
    }
  }
});

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_Sync_clearQueue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zangodb__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zangodb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_zangodb__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'velkommen',
    data: function data() {
        return {
            showLoader: false,
            activeStep: 0,
            totalSteps: 2,
            errorMessage: ''
        };
    },

    methods: {
        getServerData: function getServerData() {
            var _this = this;
            var promiseArray = [];
            this.showLoader = true;
            var promises = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve()];

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__js_Sync_clearQueue__["a" /* default */])(promises).then(function () {
                var _this2 = this;

                _this.activeStep = 1;

                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    _this.$http.get('https://mobileservice.maalertjek.niras.dk/api/indstillinger').then(function (response) {
                        return resolve(response);
                    }).catch(function () {
                        return reject;
                    });
                }).then(function (response) {
                    console.log("response", response.body);
                    return response.body;
                }, function (response) {
                    console.log("error");
                    _this2.errorMessage = "Der opstod en fejl under installationen";
                    return false;
                });
            }).then(function (data) {
                if (data == undefined) {
                    console.log("response is undefined");
                    this.errorMessage = "Der opstod en fejl under installationen";
                } else {
                    console.log("inserting into IndexedDB", data);
                    return __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].setItem("MTSettings", "settings", data);
                }
            }).then(function () {
                var _this3 = this;

                _this.activeStep = 2;

                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    _this.$http.get('https://mobileservice.maalertjek.niras.dk/api/v1/lister/allelister').then(function (response) {
                        return resolve(response);
                    }).catch(function () {
                        return reject;
                    });
                }).then(function (response) {
                    console.log("response", response.body);
                    return response.body;
                }, function (response) {
                    console.log("error");
                    _this3.errorMessage = "Der opstod en fejl under installationen";
                    return false;
                });
            }).then(function (data) {
                if (data == undefined) {
                    console.log("response is undefined");
                    this.errorMessage = "Der opstod en fejl under installationen";
                } else {
                    console.log("inserting into IndexedDB", data.bookinger);
                    var promiseArray = [];

                    data.bookinger.forEach(function (booking) {
                        promiseArray.push(function () {
                            return __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].setItem("MTTasks", booking.id, booking).then(function () {
                                console.log("Inserted task:", booking.id);
                            });
                        });
                    });
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__js_Sync_clearQueue__["a" /* default */])(promiseArray);
                }
            }).then(function () {
                _this.showLoader = false;
                _this.$cookie.set('downloaded', true, { expires: '1y' });
                _this.$router.push({
                    name: 'projekter'
                });
            });
        }
    },
    mounted: function mounted() {
        $(document).foundation();
        $('header').hide();

        if (this.$cookie.get('downloaded')) {
            this.$router.push({
                name: 'projekter'
            });
        }
    }
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    stores: ["MTTempImage", "MTSettings", "MTTasks", "MTTempData"]
});

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/*
  proj4js.js -- Javascript reprojection library. 
  
  Authors:      Mike Adair madairATdmsolutions.ca
                Richard Greenwood richATgreenwoodmap.com
                Didier Richard didier.richardATign.fr
                Stephen Irons stephen.ironsATclear.net.nz
                Olivier Terral oterralATgmail.com
                
  License:      
 Copyright (c) 2012, Mike Adair, Richard Greenwood, Didier Richard, 
                     Stephen Irons and Olivier Terral

 Permission is hereby granted, free of charge, to any person obtaining a
 copy of this software and associated documentation files (the "Software"),
 to deal in the Software without restriction, including without limitation
 the rights to use, copy, modify, merge, publish, distribute, sublicense,
 and/or sell copies of the Software, and to permit persons to whom the
 Software is furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included
 in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 DEALINGS IN THE SOFTWARE.
 
 Note: This program is an almost direct port of the C library PROJ.4.
*/
/* ======================================================================
    proj4js.js
   ====================================================================== */

/*
Author:       Mike Adair madairATdmsolutions.ca
              Richard Greenwood rich@greenwoodmap.com
License:      LGPL as per: http://www.gnu.org/copyleft/lesser.html

$Id: Proj.js 2956 2007-07-09 12:17:52Z steven $
*/

/**
 * Namespace: Proj4js
 *
 * Proj4js is a JavaScript library to transform point coordinates from one 
 * coordinate system to another, including datum transformations.
 *
 * This library is a port of both the Proj.4 and GCTCP C libraries to JavaScript. 
 * Enabling these transformations in the browser allows geographic data stored 
 * in different projections to be combined in browser-based web mapping 
 * applications.
 * 
 * Proj4js must have access to coordinate system initialization strings (which
 * are the same as for PROJ.4 command line).  Thes can be included in your 
 * application using a <script> tag or Proj4js can load CS initialization 
 * strings from a local directory or a web service such as spatialreference.org.
 *
 * Similarly, Proj4js must have access to projection transform code.  These can
 * be included individually using a <script> tag in your page, built into a 
 * custom build of Proj4js or loaded dynamically at run-time.  Using the
 * -combined and -compressed versions of Proj4js includes all projection class
 * code by default.
 *
 * Note that dynamic loading of defs and code happens ascynchrously, check the
 * Proj.readyToUse flag before using the Proj object.  If the defs and code
 * required by your application are loaded through script tags, dynamic loading
 * is not required and the Proj object will be readyToUse on return from the 
 * constructor.
 * 
 * All coordinates are handled as points which have a .x and a .y property
 * which will be modified in place.
 *
 * Override Proj4js.reportError for output of alerts and warnings.
 *
 * See http://trac.osgeo.org/proj4js/wiki/UserGuide for full details.
*/

/**
 * Global namespace object for Proj4js library
 */
var Proj4js = {

  /**
   * Property: defaultDatum
   * The datum to use when no others a specified
   */
  defaultDatum: 'WGS84', //default datum

  /** 
  * Method: transform(source, dest, point)
  * Transform a point coordinate from one map projection to another.  This is
  * really the only public method you should need to use.
  *
  * Parameters:
  * source - {Proj4js.Proj} source map projection for the transformation
  * dest - {Proj4js.Proj} destination map projection for the transformation
  * point - {Object} point to transform, may be geodetic (long, lat) or
  *     projected Cartesian (x,y), but should always have x,y properties.
  */
  transform: function transform(source, dest, point) {
    if (!source.readyToUse) {
      this.reportError("Proj4js initialization for:" + source.srsCode + " not yet complete");
      return point;
    }
    if (!dest.readyToUse) {
      this.reportError("Proj4js initialization for:" + dest.srsCode + " not yet complete");
      return point;
    }

    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && ((source.datum.datum_type == Proj4js.common.PJD_3PARAM || source.datum.datum_type == Proj4js.common.PJD_7PARAM) && dest.datumCode != "WGS84" || (dest.datum.datum_type == Proj4js.common.PJD_3PARAM || dest.datum.datum_type == Proj4js.common.PJD_7PARAM) && source.datumCode != "WGS84")) {
      var wgs84 = Proj4js.WGS84;
      this.transform(source, wgs84, point);
      source = wgs84;
    }

    // DGR, 2010/11/12
    if (source.axis != "enu") {
      this.adjust_axis(source, false, point);
    }

    // Transform source points to long/lat, if they aren't already.
    if (source.projName == "longlat") {
      point.x *= Proj4js.common.D2R; // convert degrees to radians
      point.y *= Proj4js.common.D2R;
    } else {
      if (source.to_meter) {
        point.x *= source.to_meter;
        point.y *= source.to_meter;
      }
      source.inverse(point); // Convert Cartesian to longlat
    }

    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) {
      point.x += source.from_greenwich;
    }

    // Convert datums if needed, and if possible.
    point = this.datum_transform(source.datum, dest.datum, point);

    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) {
      point.x -= dest.from_greenwich;
    }

    if (dest.projName == "longlat") {
      // convert radians to decimal degrees
      point.x *= Proj4js.common.R2D;
      point.y *= Proj4js.common.R2D;
    } else {
      // else project
      dest.forward(point);
      if (dest.to_meter) {
        point.x /= dest.to_meter;
        point.y /= dest.to_meter;
      }
    }

    // DGR, 2010/11/12
    if (dest.axis != "enu") {
      this.adjust_axis(dest, true, point);
    }

    return point;
  }, // transform()

  /** datum_transform()
    source coordinate system definition,
    destination coordinate system definition,
    point to transform in geodetic coordinates (long, lat, height)
  */
  datum_transform: function datum_transform(source, dest, point) {

    // Short cut if the datums are identical.
    if (source.compare_datums(dest)) {
      return point; // in this case, zero is sucess,
      // whereas cs_compare_datums returns 1 to indicate TRUE
      // confusing, should fix this
    }

    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type == Proj4js.common.PJD_NODATUM || dest.datum_type == Proj4js.common.PJD_NODATUM) {
      return point;
    }

    // Do we need to go through geocentric coordinates?
    if (source.es != dest.es || source.a != dest.a || source.datum_type == Proj4js.common.PJD_3PARAM || source.datum_type == Proj4js.common.PJD_7PARAM || dest.datum_type == Proj4js.common.PJD_3PARAM || dest.datum_type == Proj4js.common.PJD_7PARAM) {

      // Convert to geocentric coordinates.
      source.geodetic_to_geocentric(point);
      // CHECK_RETURN;

      // Convert between datums
      if (source.datum_type == Proj4js.common.PJD_3PARAM || source.datum_type == Proj4js.common.PJD_7PARAM) {
        source.geocentric_to_wgs84(point);
        // CHECK_RETURN;
      }

      if (dest.datum_type == Proj4js.common.PJD_3PARAM || dest.datum_type == Proj4js.common.PJD_7PARAM) {
        dest.geocentric_from_wgs84(point);
        // CHECK_RETURN;
      }

      // Convert back to geodetic coordinates
      dest.geocentric_to_geodetic(point);
      // CHECK_RETURN;
    }

    return point;
  }, // cs_datum_transform

  /**
   * Function: adjust_axis
   * Normalize or de-normalized the x/y/z axes.  The normal form is "enu"
   * (easting, northing, up).
   * Parameters:
   * crs {Proj4js.Proj} the coordinate reference system
   * denorm {Boolean} when false, normalize
   * point {Object} the coordinates to adjust
   */
  adjust_axis: function adjust_axis(crs, denorm, point) {
    var xin = point.x,
        yin = point.y,
        zin = point.z || 0.0;
    var v, t;
    for (var i = 0; i < 3; i++) {
      if (denorm && i == 2 && point.z === undefined) {
        continue;
      }
      if (i == 0) {
        v = xin;t = 'x';
      } else if (i == 1) {
        v = yin;t = 'y';
      } else {
        v = zin;t = 'z';
      }
      switch (crs.axis[i]) {
        case 'e':
          point[t] = v;
          break;
        case 'w':
          point[t] = -v;
          break;
        case 'n':
          point[t] = v;
          break;
        case 's':
          point[t] = -v;
          break;
        case 'u':
          if (point[t] !== undefined) {
            point.z = v;
          }
          break;
        case 'd':
          if (point[t] !== undefined) {
            point.z = -v;
          }
          break;
        default:
          alert("ERROR: unknow axis (" + crs.axis[i] + ") - check definition of " + crs.projName);
          return null;
      }
    }
    return point;
  },

  /**
   * Function: reportError
   * An internal method to report errors back to user. 
   * Override this in applications to report error messages or throw exceptions.
   */
  reportError: function reportError(msg) {
    //console.log(msg);
  },

  /**
   *
   * Title: Private Methods
   * The following properties and methods are intended for internal use only.
   *
   * This is a minimal implementation of JavaScript inheritance methods so that 
   * Proj4js can be used as a stand-alone library.
   * These are copies of the equivalent OpenLayers methods at v2.7
   */

  /**
   * Function: extend
   * Copy all properties of a source object to a destination object.  Modifies
   *     the passed in destination object.  Any properties on the source object
   *     that are set to undefined will not be (re)set on the destination object.
   *
   * Parameters:
   * destination - {Object} The object that will be modified
   * source - {Object} The object with properties to be set on the destination
   *
   * Returns:
   * {Object} The destination object.
   */
  extend: function extend(destination, source) {
    destination = destination || {};
    if (source) {
      for (var property in source) {
        var value = source[property];
        if (value !== undefined) {
          destination[property] = value;
        }
      }
    }
    return destination;
  },

  /**
   * Constructor: Class
   * Base class used to construct all other classes. Includes support for 
   *     multiple inheritance. 
   *  
   */
  Class: function Class() {
    var Class = function Class() {
      this.initialize.apply(this, arguments);
    };

    var extended = {};
    var parent;
    for (var i = 0; i < arguments.length; ++i) {
      if (typeof arguments[i] == "function") {
        // get the prototype of the superclass
        parent = arguments[i].prototype;
      } else {
        // in this case we're extending with the prototype
        parent = arguments[i];
      }
      Proj4js.extend(extended, parent);
    }
    Class.prototype = extended;

    return Class;
  },

  /**
   * Function: bind
   * Bind a function to an object.  Method to easily create closures with
   *     'this' altered.
   * 
   * Parameters:
   * func - {Function} Input function.
   * object - {Object} The object to bind to the input function (as this).
   * 
   * Returns:
   * {Function} A closure with 'this' set to the passed in object.
   */
  bind: function bind(func, object) {
    // create a reference to all arguments past the second one
    var args = Array.prototype.slice.apply(arguments, [2]);
    return function () {
      // Push on any additional arguments from the actual function call.
      // These will come after those sent to the bind call.
      var newArgs = args.concat(Array.prototype.slice.apply(arguments, [0]));
      return func.apply(object, newArgs);
    };
  },

  /**
   * The following properties and methods handle dynamic loading of JSON objects.
   */

  /**
   * Property: scriptName
   * {String} The filename of this script without any path.
   */
  scriptName: "proj4js.combined.js",

  /**
   * Property: defsLookupService
   * AJAX service to retreive projection definition parameters from
   */
  defsLookupService: 'http://spatialreference.org/ref',

  /**
   * Property: libPath
   * internal: http server path to library code.
   */
  libPath: null,

  /**
   * Function: getScriptLocation
   * Return the path to this script.
   *
   * Returns:
   * Path to this script
   */
  getScriptLocation: function getScriptLocation() {
    if (this.libPath) return this.libPath;
    var scriptName = this.scriptName;
    var scriptNameLen = scriptName.length;

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].getAttribute('src');
      if (src) {
        var index = src.lastIndexOf(scriptName);
        // is it found, at the end of the URL?
        if (index > -1 && index + scriptNameLen == src.length) {
          this.libPath = src.slice(0, -scriptNameLen);
          break;
        }
      }
    }
    return this.libPath || "";
  },

  /**
   * Function: loadScript
   * Load a JS file from a URL into a <script> tag in the page.
   * 
   * Parameters:
   * url - {String} The URL containing the script to load
   * onload - {Function} A method to be executed when the script loads successfully
   * onfail - {Function} A method to be executed when there is an error loading the script
   * loadCheck - {Function} A boolean method that checks to see if the script 
   *            has loaded.  Typically this just checks for the existance of
   *            an object in the file just loaded.
   */
  loadScript: function loadScript(url, onload, onfail, loadCheck) {
    var script = document.createElement('script');
    script.defer = false;
    script.type = "text/javascript";
    script.id = url;
    script.src = url;
    script.onload = onload;
    script.onerror = onfail;
    script.loadCheck = loadCheck;
    if (/MSIE/.test(navigator.userAgent)) {
      script.onreadystatechange = this.checkReadyState;
    }
    document.getElementsByTagName('head')[0].appendChild(script);
  },

  /**
   * Function: checkReadyState
   * IE workaround since there is no onerror handler.  Calls the user defined 
   * loadCheck method to determine if the script is loaded.
   * 
   */
  checkReadyState: function checkReadyState() {
    if (this.readyState == 'loaded') {
      if (!this.loadCheck()) {
        this.onerror();
      } else {
        this.onload();
      }
    }
  }
};

/**
 * Class: Proj4js.Proj
 *
 * Proj objects provide transformation methods for point coordinates
 * between geodetic latitude/longitude and a projected coordinate system. 
 * once they have been initialized with a projection code.
 *
 * Initialization of Proj objects is with a projection code, usually EPSG codes,
 * which is the key that will be used with the Proj4js.defs array.
 * 
 * The code passed in will be stripped of colons and converted to uppercase
 * to locate projection definition files.
 *
 * A projection object has properties for units and title strings.
 */
Proj4js.Proj = Proj4js.Class({

  /**
   * Property: readyToUse
   * Flag to indicate if initialization is complete for this Proj object
   */
  readyToUse: false,

  /**
   * Property: title
   * The title to describe the projection
   */
  title: null,

  /**
   * Property: projName
   * The projection class for this projection, e.g. lcc (lambert conformal conic,
   * or merc for mercator).  These are exactly equivalent to their Proj4 
   * counterparts.
   */
  projName: null,
  /**
   * Property: units
   * The units of the projection.  Values include 'm' and 'degrees'
   */
  units: null,
  /**
   * Property: datum
   * The datum specified for the projection
   */
  datum: null,
  /**
   * Property: x0
   * The x coordinate origin
   */
  x0: 0,
  /**
   * Property: y0
   * The y coordinate origin
   */
  y0: 0,
  /**
   * Property: localCS
   * Flag to indicate if the projection is a local one in which no transforms
   * are required.
   */
  localCS: false,

  /**
  * Property: queue
  * Buffer (FIFO) to hold callbacks waiting to be called when projection loaded.
  */
  queue: null,

  /**
  * Constructor: initialize
  * Constructor for Proj4js.Proj objects
  *
  * Parameters:
  * srsCode - a code for map projection definition parameters.  These are usually
  * (but not always) EPSG codes.
  */
  initialize: function initialize(srsCode, callback) {
    this.srsCodeInput = srsCode;

    //Register callbacks prior to attempting to process definition
    this.queue = [];
    if (callback) {
      this.queue.push(callback);
    }

    //check to see if this is a WKT string
    if (srsCode.indexOf('GEOGCS') >= 0 || srsCode.indexOf('GEOCCS') >= 0 || srsCode.indexOf('PROJCS') >= 0 || srsCode.indexOf('LOCAL_CS') >= 0) {
      this.parseWKT(srsCode);
      this.deriveConstants();
      this.loadProjCode(this.projName);
      return;
    }

    // DGR 2008-08-03 : support urn and url
    if (srsCode.indexOf('urn:') == 0) {
      //urn:ORIGINATOR:def:crs:CODESPACE:VERSION:ID
      var urn = srsCode.split(':');
      if ((urn[1] == 'ogc' || urn[1] == 'x-ogc') && urn[2] == 'def' && urn[3] == 'crs') {
        srsCode = urn[4] + ':' + urn[urn.length - 1];
      }
    } else if (srsCode.indexOf('http://') == 0) {
      //url#ID
      var url = srsCode.split('#');
      if (url[0].match(/epsg.org/)) {
        // http://www.epsg.org/#
        srsCode = 'EPSG:' + url[1];
      } else if (url[0].match(/RIG.xml/)) {
        //http://librairies.ign.fr/geoportail/resources/RIG.xml#
        //http://interop.ign.fr/registers/ign/RIG.xml#
        srsCode = 'IGNF:' + url[1];
      }
    }
    this.srsCode = srsCode.toUpperCase();
    if (this.srsCode.indexOf("EPSG") == 0) {
      this.srsCode = this.srsCode;
      this.srsAuth = 'epsg';
      this.srsProjNumber = this.srsCode.substring(5);
      // DGR 2007-11-20 : authority IGNF
    } else if (this.srsCode.indexOf("IGNF") == 0) {
      this.srsCode = this.srsCode;
      this.srsAuth = 'IGNF';
      this.srsProjNumber = this.srsCode.substring(5);
      // DGR 2008-06-19 : pseudo-authority CRS for WMS
    } else if (this.srsCode.indexOf("CRS") == 0) {
      this.srsCode = this.srsCode;
      this.srsAuth = 'CRS';
      this.srsProjNumber = this.srsCode.substring(4);
    } else {
      this.srsAuth = '';
      this.srsProjNumber = this.srsCode;
    }

    this.loadProjDefinition();
  },

  /**
   * Function: loadProjDefinition
   *    Loads the coordinate system initialization string if required.
   *    Note that dynamic loading happens asynchronously so an application must 
   *    wait for the readyToUse property is set to true.
   *    To prevent dynamic loading, include the defs through a script tag in
   *    your application.
   *
   */
  loadProjDefinition: function loadProjDefinition() {
    //check in memory
    if (Proj4js.defs[this.srsCode]) {
      this.defsLoaded();
      return;
    }

    //else check for def on the server
    var url = Proj4js.getScriptLocation() + 'defs/' + this.srsAuth.toUpperCase() + this.srsProjNumber + '.js';
    Proj4js.loadScript(url, Proj4js.bind(this.defsLoaded, this), Proj4js.bind(this.loadFromService, this), Proj4js.bind(this.checkDefsLoaded, this));
  },

  /**
   * Function: loadFromService
   *    Creates the REST URL for loading the definition from a web service and 
   *    loads it.
   *
   */
  loadFromService: function loadFromService() {
    //else load from web service
    var url = Proj4js.defsLookupService + '/' + this.srsAuth + '/' + this.srsProjNumber + '/proj4js/';
    Proj4js.loadScript(url, Proj4js.bind(this.defsLoaded, this), Proj4js.bind(this.defsFailed, this), Proj4js.bind(this.checkDefsLoaded, this));
  },

  /**
   * Function: defsLoaded
   * Continues the Proj object initilization once the def file is loaded
   *
   */
  defsLoaded: function defsLoaded() {
    this.parseDefs();
    this.loadProjCode(this.projName);
  },

  /**
   * Function: checkDefsLoaded
   *    This is the loadCheck method to see if the def object exists
   *
   */
  checkDefsLoaded: function checkDefsLoaded() {
    if (Proj4js.defs[this.srsCode]) {
      return true;
    } else {
      return false;
    }
  },

  /**
  * Function: defsFailed
  *    Report an error in loading the defs file, but continue on using WGS84
  *
  */
  defsFailed: function defsFailed() {
    Proj4js.reportError('failed to load projection definition for: ' + this.srsCode);
    Proj4js.defs[this.srsCode] = Proj4js.defs['WGS84']; //set it to something so it can at least continue
    this.defsLoaded();
  },

  /**
   * Function: loadProjCode
   *    Loads projection class code dynamically if required.
   *     Projection code may be included either through a script tag or in
   *     a built version of proj4js
   *
   */
  loadProjCode: function loadProjCode(projName) {
    if (Proj4js.Proj[projName]) {
      this.initTransforms();
      return;
    }

    //the URL for the projection code
    var url = Proj4js.getScriptLocation() + 'projCode/' + projName + '.js';
    Proj4js.loadScript(url, Proj4js.bind(this.loadProjCodeSuccess, this, projName), Proj4js.bind(this.loadProjCodeFailure, this, projName), Proj4js.bind(this.checkCodeLoaded, this, projName));
  },

  /**
  * Function: loadProjCodeSuccess
  *    Loads any proj dependencies or continue on to final initialization.
  *
  */
  loadProjCodeSuccess: function loadProjCodeSuccess(projName) {
    if (Proj4js.Proj[projName].dependsOn) {
      this.loadProjCode(Proj4js.Proj[projName].dependsOn);
    } else {
      this.initTransforms();
    }
  },

  /**
  * Function: defsFailed
  *    Report an error in loading the proj file.  Initialization of the Proj
  *    object has failed and the readyToUse flag will never be set.
  *
  */
  loadProjCodeFailure: function loadProjCodeFailure(projName) {
    Proj4js.reportError("failed to find projection file for: " + projName);
    //TBD initialize with identity transforms so proj will still work?
  },

  /**
   * Function: checkCodeLoaded
   *    This is the loadCheck method to see if the projection code is loaded
   *
   */
  checkCodeLoaded: function checkCodeLoaded(projName) {
    if (Proj4js.Proj[projName]) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * Function: initTransforms
   *    Finalize the initialization of the Proj object
   *
   */
  initTransforms: function initTransforms() {
    Proj4js.extend(this, Proj4js.Proj[this.projName]);
    this.init();
    this.readyToUse = true;
    if (this.queue) {
      var item;
      while (item = this.queue.shift()) {
        item.call(this, this);
      }
    }
  },

  /**
   * Function: parseWKT
   * Parses a WKT string to get initialization parameters
   *
   */
  wktRE: /^(\w+)\[(.*)\]$/,
  parseWKT: function parseWKT(wkt) {
    var wktMatch = wkt.match(this.wktRE);
    if (!wktMatch) return;
    var wktObject = wktMatch[1];
    var wktContent = wktMatch[2];
    var wktTemp = wktContent.split(",");
    var wktName;
    if (wktObject.toUpperCase() == "TOWGS84") {
      wktName = wktObject; //no name supplied for the TOWGS84 array
    } else {
      wktName = wktTemp.shift();
    }
    wktName = wktName.replace(/^\"/, "");
    wktName = wktName.replace(/\"$/, "");

    /*
    wktContent = wktTemp.join(",");
    var wktArray = wktContent.split("],");
    for (var i=0; i<wktArray.length-1; ++i) {
      wktArray[i] += "]";
    }
    */

    var wktArray = new Array();
    var bkCount = 0;
    var obj = "";
    for (var i = 0; i < wktTemp.length; ++i) {
      var token = wktTemp[i];
      for (var j = 0; j < token.length; ++j) {
        if (token.charAt(j) == "[") ++bkCount;
        if (token.charAt(j) == "]") --bkCount;
      }
      obj += token;
      if (bkCount === 0) {
        wktArray.push(obj);
        obj = "";
      } else {
        obj += ",";
      }
    }

    //do something based on the type of the wktObject being parsed
    //add in variations in the spelling as required
    switch (wktObject) {
      case 'LOCAL_CS':
        this.projName = 'identity';
        this.localCS = true;
        this.srsCode = wktName;
        break;
      case 'GEOGCS':
        this.projName = 'longlat';
        this.geocsCode = wktName;
        if (!this.srsCode) this.srsCode = wktName;
        break;
      case 'PROJCS':
        this.srsCode = wktName;
        break;
      case 'GEOCCS':
        break;
      case 'PROJECTION':
        this.projName = Proj4js.wktProjections[wktName];
        break;
      case 'DATUM':
        this.datumName = wktName;
        break;
      case 'LOCAL_DATUM':
        this.datumCode = 'none';
        break;
      case 'SPHEROID':
        this.ellps = wktName;
        this.a = parseFloat(wktArray.shift());
        this.rf = parseFloat(wktArray.shift());
        break;
      case 'PRIMEM':
        this.from_greenwich = parseFloat(wktArray.shift()); //to radians?
        break;
      case 'UNIT':
        this.units = wktName;
        this.unitsPerMeter = parseFloat(wktArray.shift());
        break;
      case 'PARAMETER':
        var name = wktName.toLowerCase();
        var value = parseFloat(wktArray.shift());
        //there may be many variations on the wktName values, add in case
        //statements as required
        switch (name) {
          case 'false_easting':
            this.x0 = value;
            break;
          case 'false_northing':
            this.y0 = value;
            break;
          case 'scale_factor':
            this.k0 = value;
            break;
          case 'central_meridian':
            this.long0 = value * Proj4js.common.D2R;
            break;
          case 'latitude_of_origin':
            this.lat0 = value * Proj4js.common.D2R;
            break;
          case 'more_here':
            break;
          default:
            break;
        }
        break;
      case 'TOWGS84':
        this.datum_params = wktArray;
        break;
      //DGR 2010-11-12: AXIS
      case 'AXIS':
        var name = wktName.toLowerCase();
        var value = wktArray.shift();
        switch (value) {
          case 'EAST':
            value = 'e';break;
          case 'WEST':
            value = 'w';break;
          case 'NORTH':
            value = 'n';break;
          case 'SOUTH':
            value = 's';break;
          case 'UP':
            value = 'u';break;
          case 'DOWN':
            value = 'd';break;
          case 'OTHER':
          default:
            value = ' ';break; //FIXME
        }
        if (!this.axis) {
          this.axis = "enu";
        }
        switch (name) {
          case 'x':
            this.axis = value + this.axis.substr(1, 2);break;
          case 'y':
            this.axis = this.axis.substr(0, 1) + value + this.axis.substr(2, 1);break;
          case 'z':
            this.axis = this.axis.substr(0, 2) + value;break;
          default:
            break;
        }
      case 'MORE_HERE':
        break;
      default:
        break;
    }
    for (var i = 0; i < wktArray.length; ++i) {
      this.parseWKT(wktArray[i]);
    }
  },

  /**
   * Function: parseDefs
   * Parses the PROJ.4 initialization string and sets the associated properties.
   *
   */
  parseDefs: function parseDefs() {
    this.defData = Proj4js.defs[this.srsCode];
    var paramName, paramVal;
    if (!this.defData) {
      return;
    }
    var paramArray = this.defData.split("+");

    for (var prop = 0; prop < paramArray.length; prop++) {
      var property = paramArray[prop].split("=");
      paramName = property[0].toLowerCase();
      paramVal = property[1];

      switch (paramName.replace(/\s/gi, "")) {// trim out spaces
        case "":
          break; // throw away nameless parameter
        case "title":
          this.title = paramVal;break;
        case "proj":
          this.projName = paramVal.replace(/\s/gi, "");break;
        case "units":
          this.units = paramVal.replace(/\s/gi, "");break;
        case "datum":
          this.datumCode = paramVal.replace(/\s/gi, "");break;
        case "nadgrids":
          this.nagrids = paramVal.replace(/\s/gi, "");break;
        case "ellps":
          this.ellps = paramVal.replace(/\s/gi, "");break;
        case "a":
          this.a = parseFloat(paramVal);break; // semi-major radius
        case "b":
          this.b = parseFloat(paramVal);break; // semi-minor radius
        // DGR 2007-11-20
        case "rf":
          this.rf = parseFloat(paramVal);break; // inverse flattening rf= a/(a-b)
        case "lat_0":
          this.lat0 = paramVal * Proj4js.common.D2R;break; // phi0, central latitude
        case "lat_1":
          this.lat1 = paramVal * Proj4js.common.D2R;break; //standard parallel 1
        case "lat_2":
          this.lat2 = paramVal * Proj4js.common.D2R;break; //standard parallel 2
        case "lat_ts":
          this.lat_ts = paramVal * Proj4js.common.D2R;break; // used in merc and eqc
        case "lon_0":
          this.long0 = paramVal * Proj4js.common.D2R;break; // lam0, central longitude
        case "alpha":
          this.alpha = parseFloat(paramVal) * Proj4js.common.D2R;break; //for somerc projection
        case "lonc":
          this.longc = paramVal * Proj4js.common.D2R;break; //for somerc projection
        case "x_0":
          this.x0 = parseFloat(paramVal);break; // false easting
        case "y_0":
          this.y0 = parseFloat(paramVal);break; // false northing
        case "k_0":
          this.k0 = parseFloat(paramVal);break; // projection scale factor
        case "k":
          this.k0 = parseFloat(paramVal);break; // both forms returned
        case "r_a":
          this.R_A = true;break; // sphere--area of ellipsoid
        case "zone":
          this.zone = parseInt(paramVal, 10);break; // UTM Zone
        case "south":
          this.utmSouth = true;break; // UTM north/south
        case "towgs84":
          this.datum_params = paramVal.split(",");break;
        case "to_meter":
          this.to_meter = parseFloat(paramVal);break; // cartesian scaling
        case "from_greenwich":
          this.from_greenwich = paramVal * Proj4js.common.D2R;break;
        // DGR 2008-07-09 : if pm is not a well-known prime meridian take
        // the value instead of 0.0, then convert to radians
        case "pm":
          paramVal = paramVal.replace(/\s/gi, "");
          this.from_greenwich = Proj4js.PrimeMeridian[paramVal] ? Proj4js.PrimeMeridian[paramVal] : parseFloat(paramVal);
          this.from_greenwich *= Proj4js.common.D2R;
          break;
        // DGR 2010-11-12: axis
        case "axis":
          paramVal = paramVal.replace(/\s/gi, "");
          var legalAxis = "ewnsud";
          if (paramVal.length == 3 && legalAxis.indexOf(paramVal.substr(0, 1)) != -1 && legalAxis.indexOf(paramVal.substr(1, 1)) != -1 && legalAxis.indexOf(paramVal.substr(2, 1)) != -1) {
            this.axis = paramVal;
          } //FIXME: be silent ?
          break;
        case "no_defs":
          break;
        default: //alert("Unrecognized parameter: " + paramName);
      } // switch()
    } // for paramArray
    this.deriveConstants();
  },

  /**
   * Function: deriveConstants
   * Sets several derived constant values and initialization of datum and ellipse
   *     parameters.
   *
   */
  deriveConstants: function deriveConstants() {
    if (this.nagrids == '@null') this.datumCode = 'none';
    if (this.datumCode && this.datumCode != 'none') {
      var datumDef = Proj4js.Datum[this.datumCode];
      if (datumDef) {
        this.datum_params = datumDef.towgs84 ? datumDef.towgs84.split(',') : null;
        this.ellps = datumDef.ellipse;
        this.datumName = datumDef.datumName ? datumDef.datumName : this.datumCode;
      }
    }
    if (!this.a) {
      // do we have an ellipsoid?
      var ellipse = Proj4js.Ellipsoid[this.ellps] ? Proj4js.Ellipsoid[this.ellps] : Proj4js.Ellipsoid['WGS84'];
      Proj4js.extend(this, ellipse);
    }
    if (this.rf && !this.b) this.b = (1.0 - 1.0 / this.rf) * this.a;
    if (this.rf === 0 || Math.abs(this.a - this.b) < Proj4js.common.EPSLN) {
      this.sphere = true;
      this.b = this.a;
    }
    this.a2 = this.a * this.a; // used in geocentric
    this.b2 = this.b * this.b; // used in geocentric
    this.es = (this.a2 - this.b2) / this.a2; // e ^ 2
    this.e = Math.sqrt(this.es); // eccentricity
    if (this.R_A) {
      this.a *= 1. - this.es * (Proj4js.common.SIXTH + this.es * (Proj4js.common.RA4 + this.es * Proj4js.common.RA6));
      this.a2 = this.a * this.a;
      this.b2 = this.b * this.b;
      this.es = 0.;
    }
    this.ep2 = (this.a2 - this.b2) / this.b2; // used in geocentric
    if (!this.k0) this.k0 = 1.0; //default value
    //DGR 2010-11-12: axis
    if (!this.axis) {
      this.axis = "enu";
    }

    this.datum = new Proj4js.datum(this);
  }
});

Proj4js.Proj.longlat = {
  init: function init() {
    //no-op for longlat
  },
  forward: function forward(pt) {
    //identity transform
    return pt;
  },
  inverse: function inverse(pt) {
    //identity transform
    return pt;
  }
};
Proj4js.Proj.identity = Proj4js.Proj.longlat;

/**
  Proj4js.defs is a collection of coordinate system definition objects in the 
  PROJ.4 command line format.
  Generally a def is added by means of a separate .js file for example:

    <SCRIPT type="text/javascript" src="defs/EPSG26912.js"></SCRIPT>

  def is a CS definition in PROJ.4 WKT format, for example:
    +proj="tmerc"   //longlat, etc.
    +a=majorRadius
    +b=minorRadius
    +lat0=somenumber
    +long=somenumber
*/
Proj4js.defs = {
  // These are so widely used, we'll go ahead and throw them in
  // without requiring a separate .js file
  'WGS84': "+title=long/lat:WGS84 +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees",
  'EPSG:4326': "+title=long/lat:WGS84 +proj=longlat +a=6378137.0 +b=6356752.31424518 +ellps=WGS84 +datum=WGS84 +units=degrees",
  'EPSG:4269': "+title=long/lat:NAD83 +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees",
  'EPSG:3875': "+title= Google Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs"
};
Proj4js.defs['EPSG:3785'] = Proj4js.defs['EPSG:3875']; //maintain backward compat, official code is 3875
Proj4js.defs['GOOGLE'] = Proj4js.defs['EPSG:3875'];
Proj4js.defs['EPSG:900913'] = Proj4js.defs['EPSG:3875'];
Proj4js.defs['EPSG:102113'] = Proj4js.defs['EPSG:3875'];

Proj4js.common = {
  PI: 3.141592653589793238, //Math.PI,
  HALF_PI: 1.570796326794896619, //Math.PI*0.5,
  TWO_PI: 6.283185307179586477, //Math.PI*2,
  FORTPI: 0.78539816339744833,
  R2D: 57.29577951308232088,
  D2R: 0.01745329251994329577,
  SEC_TO_RAD: 4.84813681109535993589914102357e-6, /* SEC_TO_RAD = Pi/180/3600 */
  EPSLN: 1.0e-10,
  MAX_ITER: 20,
  // following constants from geocent.c
  COS_67P5: 0.38268343236508977, /* cosine of 67.5 degrees */
  AD_C: 1.0026000, /* Toms region 1 constant */

  /* datum_type values */
  PJD_UNKNOWN: 0,
  PJD_3PARAM: 1,
  PJD_7PARAM: 2,
  PJD_GRIDSHIFT: 3,
  PJD_WGS84: 4, // WGS84 or equivalent
  PJD_NODATUM: 5, // WGS84 or equivalent
  SRS_WGS84_SEMIMAJOR: 6378137.0, // only used in grid shift transforms

  // ellipoid pj_set_ell.c
  SIXTH: .1666666666666666667, /* 1/6 */
  RA4: .04722222222222222222, /* 17/360 */
  RA6: .02215608465608465608, /* 67/3024 */
  RV4: .06944444444444444444, /* 5/72 */
  RV6: .04243827160493827160, /* 55/1296 */

  // Function to compute the constant small m which is the radius of
  //   a parallel of latitude, phi, divided by the semimajor axis.
  // -----------------------------------------------------------------
  msfnz: function msfnz(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / Math.sqrt(1.0 - con * con);
  },

  // Function to compute the constant small t for use in the forward
  //   computations in the Lambert Conformal Conic and the Polar
  //   Stereographic projections.
  // -----------------------------------------------------------------
  tsfnz: function tsfnz(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = .5 * eccent;
    con = Math.pow((1.0 - con) / (1.0 + con), com);
    return Math.tan(.5 * (this.HALF_PI - phi)) / con;
  },

  // Function to compute the latitude angle, phi2, for the inverse of the
  //   Lambert Conformal Conic and Polar Stereographic projections.
  // ----------------------------------------------------------------
  phi2z: function phi2z(eccent, ts) {
    var eccnth = .5 * eccent;
    var con, dphi;
    var phi = this.HALF_PI - 2 * Math.atan(ts);
    for (var i = 0; i <= 15; i++) {
      con = eccent * Math.sin(phi);
      dphi = this.HALF_PI - 2 * Math.atan(ts * Math.pow((1.0 - con) / (1.0 + con), eccnth)) - phi;
      phi += dphi;
      if (Math.abs(dphi) <= .0000000001) return phi;
    }
    alert("phi2z has NoConvergence");
    return -9999;
  },

  /* Function to compute constant small q which is the radius of a 
     parallel of latitude, phi, divided by the semimajor axis. 
  ------------------------------------------------------------*/
  qsfnz: function qsfnz(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
      con = eccent * sinphi;
      return (1.0 - eccent * eccent) * (sinphi / (1.0 - con * con) - .5 / eccent * Math.log((1.0 - con) / (1.0 + con)));
    } else {
      return 2.0 * sinphi;
    }
  },

  /* Function to eliminate roundoff errors in asin
  ----------------------------------------------*/
  asinz: function asinz(x) {
    if (Math.abs(x) > 1.0) {
      x = x > 1.0 ? 1.0 : -1.0;
    }
    return Math.asin(x);
  },

  // following functions from gctpc cproj.c for transverse mercator projections
  e0fn: function e0fn(x) {
    return 1.0 - 0.25 * x * (1.0 + x / 16.0 * (3.0 + 1.25 * x));
  },
  e1fn: function e1fn(x) {
    return 0.375 * x * (1.0 + 0.25 * x * (1.0 + 0.46875 * x));
  },
  e2fn: function e2fn(x) {
    return 0.05859375 * x * x * (1.0 + 0.75 * x);
  },
  e3fn: function e3fn(x) {
    return x * x * x * (35.0 / 3072.0);
  },
  mlfn: function mlfn(e0, e1, e2, e3, phi) {
    return e0 * phi - e1 * Math.sin(2.0 * phi) + e2 * Math.sin(4.0 * phi) - e3 * Math.sin(6.0 * phi);
  },

  srat: function srat(esinp, exp) {
    return Math.pow((1.0 - esinp) / (1.0 + esinp), exp);
  },

  // Function to return the sign of an argument
  sign: function sign(x) {
    if (x < 0.0) return -1;else return 1;
  },

  // Function to adjust longitude to -180 to 180; input in radians
  adjust_lon: function adjust_lon(x) {
    x = Math.abs(x) < this.PI ? x : x - this.sign(x) * this.TWO_PI;
    return x;
  },

  // IGNF - DGR : algorithms used by IGN France

  // Function to adjust latitude to -90 to 90; input in radians
  adjust_lat: function adjust_lat(x) {
    x = Math.abs(x) < this.HALF_PI ? x : x - this.sign(x) * this.PI;
    return x;
  },

  // Latitude Isometrique - close to tsfnz ...
  latiso: function latiso(eccent, phi, sinphi) {
    if (Math.abs(phi) > this.HALF_PI) return +Number.NaN;
    if (phi == this.HALF_PI) return Number.POSITIVE_INFINITY;
    if (phi == -1.0 * this.HALF_PI) return -1.0 * Number.POSITIVE_INFINITY;

    var con = eccent * sinphi;
    return Math.log(Math.tan((this.HALF_PI + phi) / 2.0)) + eccent * Math.log((1.0 - con) / (1.0 + con)) / 2.0;
  },

  fL: function fL(x, L) {
    return 2.0 * Math.atan(x * Math.exp(L)) - this.HALF_PI;
  },

  // Inverse Latitude Isometrique - close to ph2z
  invlatiso: function invlatiso(eccent, ts) {
    var phi = this.fL(1.0, ts);
    var Iphi = 0.0;
    var con = 0.0;
    do {
      Iphi = phi;
      con = eccent * Math.sin(Iphi);
      phi = this.fL(Math.exp(eccent * Math.log((1.0 + con) / (1.0 - con)) / 2.0), ts);
    } while (Math.abs(phi - Iphi) > 1.0e-12);
    return phi;
  },

  // Needed for Gauss Schreiber
  // Original:  Denis Makarov (info@binarythings.com)
  // Web Site:  http://www.binarythings.com
  sinh: function sinh(x) {
    var r = Math.exp(x);
    r = (r - 1.0 / r) / 2.0;
    return r;
  },

  cosh: function cosh(x) {
    var r = Math.exp(x);
    r = (r + 1.0 / r) / 2.0;
    return r;
  },

  tanh: function tanh(x) {
    var r = Math.exp(x);
    r = (r - 1.0 / r) / (r + 1.0 / r);
    return r;
  },

  asinh: function asinh(x) {
    var s = x >= 0 ? 1.0 : -1.0;
    return s * Math.log(Math.abs(x) + Math.sqrt(x * x + 1.0));
  },

  acosh: function acosh(x) {
    return 2.0 * Math.log(Math.sqrt((x + 1.0) / 2.0) + Math.sqrt((x - 1.0) / 2.0));
  },

  atanh: function atanh(x) {
    return Math.log((x - 1.0) / (x + 1.0)) / 2.0;
  },

  // Grande Normale
  gN: function gN(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1.0 - temp * temp);
  },

  //code from the PROJ.4 pj_mlfn.c file;  this may be useful for other projections
  pj_enfn: function pj_enfn(es) {
    var en = new Array();
    en[0] = this.C00 - es * (this.C02 + es * (this.C04 + es * (this.C06 + es * this.C08)));
    en[1] = es * (this.C22 - es * (this.C04 + es * (this.C06 + es * this.C08)));
    var t = es * es;
    en[2] = t * (this.C44 - es * (this.C46 + es * this.C48));
    t *= es;
    en[3] = t * (this.C66 - es * this.C68);
    en[4] = t * es * this.C88;
    return en;
  },

  pj_mlfn: function pj_mlfn(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
  },

  pj_inv_mlfn: function pj_inv_mlfn(arg, es, en) {
    var k = 1. / (1. - es);
    var phi = arg;
    for (var i = Proj4js.common.MAX_ITER; i; --i) {
      /* rarely goes over 2 iterations */
      var s = Math.sin(phi);
      var t = 1. - es * s * s;
      //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
      //phi -= t * (t * Math.sqrt(t)) * k;
      t = (this.pj_mlfn(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
      phi -= t;
      if (Math.abs(t) < Proj4js.common.EPSLN) return phi;
    }
    Proj4js.reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
  },

  /* meridinal distance for ellipsoid and inverse
  **	8th degree - accurate to < 1e-5 meters when used in conjuction
  **		with typical major axis values.
  **	Inverse determines phi to EPS (1e-11) radians, about 1e-6 seconds.
  */
  C00: 1.0,
  C02: .25,
  C04: .046875,
  C06: .01953125,
  C08: .01068115234375,
  C22: .75,
  C44: .46875,
  C46: .01302083333333333333,
  C48: .00712076822916666666,
  C66: .36458333333333333333,
  C68: .00569661458333333333,
  C88: .3076171875

};

/** datum object
*/
Proj4js.datum = Proj4js.Class({

  initialize: function initialize(proj) {
    this.datum_type = Proj4js.common.PJD_WGS84; //default setting
    if (proj.datumCode && proj.datumCode == 'none') {
      this.datum_type = Proj4js.common.PJD_NODATUM;
    }
    if (proj && proj.datum_params) {
      for (var i = 0; i < proj.datum_params.length; i++) {
        proj.datum_params[i] = parseFloat(proj.datum_params[i]);
      }
      if (proj.datum_params[0] != 0 || proj.datum_params[1] != 0 || proj.datum_params[2] != 0) {
        this.datum_type = Proj4js.common.PJD_3PARAM;
      }
      if (proj.datum_params.length > 3) {
        if (proj.datum_params[3] != 0 || proj.datum_params[4] != 0 || proj.datum_params[5] != 0 || proj.datum_params[6] != 0) {
          this.datum_type = Proj4js.common.PJD_7PARAM;
          proj.datum_params[3] *= Proj4js.common.SEC_TO_RAD;
          proj.datum_params[4] *= Proj4js.common.SEC_TO_RAD;
          proj.datum_params[5] *= Proj4js.common.SEC_TO_RAD;
          proj.datum_params[6] = proj.datum_params[6] / 1000000.0 + 1.0;
        }
      }
    }
    if (proj) {
      this.a = proj.a; //datum object also uses these values
      this.b = proj.b;
      this.es = proj.es;
      this.ep2 = proj.ep2;
      this.datum_params = proj.datum_params;
    }
  },

  /****************************************************************/
  // cs_compare_datums()
  //   Returns TRUE if the two datums match, otherwise FALSE.
  compare_datums: function compare_datums(dest) {
    if (this.datum_type != dest.datum_type) {
      return false; // false, datums are not equal
    } else if (this.a != dest.a || Math.abs(this.es - dest.es) > 0.000000000050) {
      // the tolerence for es is to ensure that GRS80 and WGS84
      // are considered identical
      return false;
    } else if (this.datum_type == Proj4js.common.PJD_3PARAM) {
      return this.datum_params[0] == dest.datum_params[0] && this.datum_params[1] == dest.datum_params[1] && this.datum_params[2] == dest.datum_params[2];
    } else if (this.datum_type == Proj4js.common.PJD_7PARAM) {
      return this.datum_params[0] == dest.datum_params[0] && this.datum_params[1] == dest.datum_params[1] && this.datum_params[2] == dest.datum_params[2] && this.datum_params[3] == dest.datum_params[3] && this.datum_params[4] == dest.datum_params[4] && this.datum_params[5] == dest.datum_params[5] && this.datum_params[6] == dest.datum_params[6];
    } else if (this.datum_type == Proj4js.common.PJD_GRIDSHIFT || dest.datum_type == Proj4js.common.PJD_GRIDSHIFT) {
      alert("ERROR: Grid shift transformations are not implemented.");
      return false;
    } else {
      return true; // datums are equal
    }
  }, // cs_compare_datums()

  /*
   * The function Convert_Geodetic_To_Geocentric converts geodetic coordinates
   * (latitude, longitude, and height) to geocentric coordinates (X, Y, Z),
   * according to the current ellipsoid parameters.
   *
   *    Latitude  : Geodetic latitude in radians                     (input)
   *    Longitude : Geodetic longitude in radians                    (input)
   *    Height    : Geodetic height, in meters                       (input)
   *    X         : Calculated Geocentric X coordinate, in meters    (output)
   *    Y         : Calculated Geocentric Y coordinate, in meters    (output)
   *    Z         : Calculated Geocentric Z coordinate, in meters    (output)
   *
   */
  geodetic_to_geocentric: function geodetic_to_geocentric(p) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; //Z value not always supplied
    var X; // output
    var Y;
    var Z;

    var Error_Code = 0; //  GEOCENT_NO_ERROR;
    var Rn; /*  Earth radius at location  */
    var Sin_Lat; /*  Math.sin(Latitude)  */
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */
    var Cos_Lat; /*  Math.cos(Latitude)  */

    /*
    ** Don't blow up if Latitude is just a little out of the value
    ** range as it may just be a rounding issue.  Also removed longitude
    ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
    */
    if (Latitude < -Proj4js.common.HALF_PI && Latitude > -1.001 * Proj4js.common.HALF_PI) {
      Latitude = -Proj4js.common.HALF_PI;
    } else if (Latitude > Proj4js.common.HALF_PI && Latitude < 1.001 * Proj4js.common.HALF_PI) {
      Latitude = Proj4js.common.HALF_PI;
    } else if (Latitude < -Proj4js.common.HALF_PI || Latitude > Proj4js.common.HALF_PI) {
      /* Latitude out of range */
      Proj4js.reportError('geocent:lat out of range:' + Latitude);
      return null;
    }

    if (Longitude > Proj4js.common.PI) Longitude -= 2 * Proj4js.common.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = this.a / Math.sqrt(1.0e0 - this.es * Sin2_Lat);
    X = (Rn + Height) * Cos_Lat * Math.cos(Longitude);
    Y = (Rn + Height) * Cos_Lat * Math.sin(Longitude);
    Z = (Rn * (1 - this.es) + Height) * Sin_Lat;

    p.x = X;
    p.y = Y;
    p.z = Z;
    return Error_Code;
  }, // cs_geodetic_to_geocentric()


  geocentric_to_geodetic: function geocentric_to_geodetic(p) {
    /* local defintions and variables */
    /* end-criterium of loop, accuracy of sin(Latitude) */
    var genau = 1.E-12;
    var genau2 = genau * genau;
    var maxiter = 30;

    var P; /* distance between semi-minor axis and location */
    var RR; /* distance between center and location */
    var CT; /* sin of geocentric latitude */
    var ST; /* cos of geocentric latitude */
    var RX;
    var RK;
    var RN; /* Earth radius at location */
    var CPHI0; /* cos of start or old geodetic latitude in iterations */
    var SPHI0; /* sin of start or old geodetic latitude in iterations */
    var CPHI; /* cos of searched geodetic latitude */
    var SPHI; /* sin of searched geodetic latitude */
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */
    var At_Pole; /* indicates location is in polar region */
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */

    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; //Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;

    At_Pole = false;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);

    /*      special cases for latitude and longitude */
    if (P / this.a < genau) {

      /*  special case, if P=0. (X=0., Y=0.) */
      At_Pole = true;
      Longitude = 0.0;

      /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
       *  of ellipsoid (=center of mass), Latitude becomes PI/2 */
      if (RR / this.a < genau) {
        Latitude = Proj4js.common.HALF_PI;
        Height = -this.b;
        return;
      }
    } else {
      /*  ellipsoidal (geodetic) longitude
       *  interval: -PI < Longitude <= +PI */
      Longitude = Math.atan2(Y, X);
    }

    /* --------------------------------------------------------------
     * Following iterative algorithm was developped by
     * "Institut fï¿½r Erdmessung", University of Hannover, July 1988.
     * Internet: www.ife.uni-hannover.de
     * Iterative computation of CPHI,SPHI and Height.
     * Iteration of CPHI and SPHI to 10**-12 radian resp.
     * 2*10**-7 arcsec.
     * --------------------------------------------------------------
     */
    CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - this.es * (2.0 - this.es) * ST * ST);
    CPHI0 = ST * (1.0 - this.es) * RX;
    SPHI0 = CT * RX;
    iter = 0;

    /* loop to find sin(Latitude) resp. Latitude
     * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */
    do {
      iter++;
      RN = this.a / Math.sqrt(1.0 - this.es * SPHI0 * SPHI0);

      /*  ellipsoidal (geodetic) height */
      Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - this.es * SPHI0 * SPHI0);

      RK = this.es * RN / (RN + Height);
      RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
      CPHI = ST * (1.0 - RK) * RX;
      SPHI = CT * RX;
      SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
      CPHI0 = CPHI;
      SPHI0 = SPHI;
    } while (SDPHI * SDPHI > genau2 && iter < maxiter);

    /*      ellipsoidal (geodetic) latitude */
    Latitude = Math.atan(SPHI / Math.abs(CPHI));

    p.x = Longitude;
    p.y = Latitude;
    p.z = Height;
    return p;
  }, // cs_geocentric_to_geodetic()

  /** Convert_Geocentric_To_Geodetic
   * The method used here is derived from 'An Improved Algorithm for
   * Geocentric to Geodetic Coordinate Conversion', by Ralph Toms, Feb 1996
   */
  geocentric_to_geodetic_noniter: function geocentric_to_geodetic_noniter(p) {
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0; //Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;

    var W; /* distance from Z axis */
    var W2; /* square of distance from Z axis */
    var T0; /* initial estimate of vertical component */
    var T1; /* corrected estimate of vertical component */
    var S0; /* initial estimate of horizontal component */
    var S1; /* corrected estimate of horizontal component */
    var Sin_B0; /* Math.sin(B0), B0 is estimate of Bowring aux variable */
    var Sin3_B0; /* cube of Math.sin(B0) */
    var Cos_B0; /* Math.cos(B0) */
    var Sin_p1; /* Math.sin(phi1), phi1 is estimated latitude */
    var Cos_p1; /* Math.cos(phi1) */
    var Rn; /* Earth radius at location */
    var Sum; /* numerator of Math.cos(phi1) */
    var At_Pole; /* indicates location is in polar region */

    X = parseFloat(X); // cast from string to float
    Y = parseFloat(Y);
    Z = parseFloat(Z);

    At_Pole = false;
    if (X != 0.0) {
      Longitude = Math.atan2(Y, X);
    } else {
      if (Y > 0) {
        Longitude = Proj4js.common.HALF_PI;
      } else if (Y < 0) {
        Longitude = -Proj4js.common.HALF_PI;
      } else {
        At_Pole = true;
        Longitude = 0.0;
        if (Z > 0.0) {
          /* north pole */
          Latitude = Proj4js.common.HALF_PI;
        } else if (Z < 0.0) {
          /* south pole */
          Latitude = -Proj4js.common.HALF_PI;
        } else {
          /* center of earth */
          Latitude = Proj4js.common.HALF_PI;
          Height = -this.b;
          return;
        }
      }
    }
    W2 = X * X + Y * Y;
    W = Math.sqrt(W2);
    T0 = Z * Proj4js.common.AD_C;
    S0 = Math.sqrt(T0 * T0 + W2);
    Sin_B0 = T0 / S0;
    Cos_B0 = W / S0;
    Sin3_B0 = Sin_B0 * Sin_B0 * Sin_B0;
    T1 = Z + this.b * this.ep2 * Sin3_B0;
    Sum = W - this.a * this.es * Cos_B0 * Cos_B0 * Cos_B0;
    S1 = Math.sqrt(T1 * T1 + Sum * Sum);
    Sin_p1 = T1 / S1;
    Cos_p1 = Sum / S1;
    Rn = this.a / Math.sqrt(1.0 - this.es * Sin_p1 * Sin_p1);
    if (Cos_p1 >= Proj4js.common.COS_67P5) {
      Height = W / Cos_p1 - Rn;
    } else if (Cos_p1 <= -Proj4js.common.COS_67P5) {
      Height = W / -Cos_p1 - Rn;
    } else {
      Height = Z / Sin_p1 + Rn * (this.es - 1.0);
    }
    if (At_Pole == false) {
      Latitude = Math.atan(Sin_p1 / Cos_p1);
    }

    p.x = Longitude;
    p.y = Latitude;
    p.z = Height;
    return p;
  }, // geocentric_to_geodetic_noniter()

  /****************************************************************/
  // pj_geocentic_to_wgs84( p )
  //  p = point to transform in geocentric coordinates (x,y,z)
  geocentric_to_wgs84: function geocentric_to_wgs84(p) {

    if (this.datum_type == Proj4js.common.PJD_3PARAM) {
      // if( x[io] == HUGE_VAL )
      //    continue;
      p.x += this.datum_params[0];
      p.y += this.datum_params[1];
      p.z += this.datum_params[2];
    } else if (this.datum_type == Proj4js.common.PJD_7PARAM) {
      var Dx_BF = this.datum_params[0];
      var Dy_BF = this.datum_params[1];
      var Dz_BF = this.datum_params[2];
      var Rx_BF = this.datum_params[3];
      var Ry_BF = this.datum_params[4];
      var Rz_BF = this.datum_params[5];
      var M_BF = this.datum_params[6];
      // if( x[io] == HUGE_VAL )
      //    continue;
      var x_out = M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF;
      var y_out = M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF;
      var z_out = M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF;
      p.x = x_out;
      p.y = y_out;
      p.z = z_out;
    }
  }, // cs_geocentric_to_wgs84

  /****************************************************************/
  // pj_geocentic_from_wgs84()
  //  coordinate system definition,
  //  point to transform in geocentric coordinates (x,y,z)
  geocentric_from_wgs84: function geocentric_from_wgs84(p) {

    if (this.datum_type == Proj4js.common.PJD_3PARAM) {
      //if( x[io] == HUGE_VAL )
      //    continue;
      p.x -= this.datum_params[0];
      p.y -= this.datum_params[1];
      p.z -= this.datum_params[2];
    } else if (this.datum_type == Proj4js.common.PJD_7PARAM) {
      var Dx_BF = this.datum_params[0];
      var Dy_BF = this.datum_params[1];
      var Dz_BF = this.datum_params[2];
      var Rx_BF = this.datum_params[3];
      var Ry_BF = this.datum_params[4];
      var Rz_BF = this.datum_params[5];
      var M_BF = this.datum_params[6];
      var x_tmp = (p.x - Dx_BF) / M_BF;
      var y_tmp = (p.y - Dy_BF) / M_BF;
      var z_tmp = (p.z - Dz_BF) / M_BF;
      //if( x[io] == HUGE_VAL )
      //    continue;

      p.x = x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp;
      p.y = -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp;
      p.z = Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp;
    } //cs_geocentric_from_wgs84()
  }
});

/** point object, nothing fancy, just allows values to be
    passed back and forth by reference rather than by value.
    Other point classes may be used as long as they have
    x and y properties, which will get modified in the transform method.
*/
Proj4js.Point = Proj4js.Class({

  /**
   * Constructor: Proj4js.Point
   *
   * Parameters:
   * - x {float} or {Array} either the first coordinates component or
   *     the full coordinates
   * - y {float} the second component
   * - z {float} the third component, optional.
   */
  initialize: function initialize(x, y, z) {
    if ((typeof x === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(x)) == 'object') {
      this.x = x[0];
      this.y = x[1];
      this.z = x[2] || 0.0;
    } else if (typeof x == 'string' && typeof y == 'undefined') {
      var coords = x.split(',');
      this.x = parseFloat(coords[0]);
      this.y = parseFloat(coords[1]);
      this.z = parseFloat(coords[2]) || 0.0;
    } else {
      this.x = x;
      this.y = y;
      this.z = z || 0.0;
    }
  },

  /**
   * APIMethod: clone
   * Build a copy of a Proj4js.Point object.
   *
   * Return:
   * {Proj4js}.Point the cloned point.
   */
  clone: function clone() {
    return new Proj4js.Point(this.x, this.y, this.z);
  },

  /**
   * APIMethod: toString
   * Return a readable string version of the point
   *
   * Return:
   * {String} String representation of Proj4js.Point object. 
   *           (ex. <i>"x=5,y=42"</i>)
   */
  toString: function toString() {
    return "x=" + this.x + ",y=" + this.y;
  },

  /** 
   * APIMethod: toShortString
   * Return a short string version of the point.
   *
   * Return:
   * {String} Shortened String representation of Proj4js.Point object. 
   *         (ex. <i>"5, 42"</i>)
   */
  toShortString: function toShortString() {
    return this.x + ", " + this.y;
  }
});

Proj4js.PrimeMeridian = {
  "greenwich": 0.0, //"0dE",
  "lisbon": -9.131906111111, //"9d07'54.862\"W",
  "paris": 2.337229166667, //"2d20'14.025\"E",
  "bogota": -74.080916666667, //"74d04'51.3\"W",
  "madrid": -3.687938888889, //"3d41'16.58\"W",
  "rome": 12.452333333333, //"12d27'8.4\"E",
  "bern": 7.439583333333, //"7d26'22.5\"E",
  "jakarta": 106.807719444444, //"106d48'27.79\"E",
  "ferro": -17.666666666667, //"17d40'W",
  "brussels": 4.367975, //"4d22'4.71\"E",
  "stockholm": 18.058277777778, //"18d3'29.8\"E",
  "athens": 23.7163375, //"23d42'58.815\"E",
  "oslo": 10.722916666667 //"10d43'22.5\"E"
};

Proj4js.Ellipsoid = {
  "MERIT": { a: 6378137.0, rf: 298.257, ellipseName: "MERIT 1983" },
  "SGS85": { a: 6378136.0, rf: 298.257, ellipseName: "Soviet Geodetic System 85" },
  "GRS80": { a: 6378137.0, rf: 298.257222101, ellipseName: "GRS 1980(IUGG, 1980)" },
  "IAU76": { a: 6378140.0, rf: 298.257, ellipseName: "IAU 1976" },
  "airy": { a: 6377563.396, b: 6356256.910, ellipseName: "Airy 1830" },
  "APL4.": { a: 6378137, rf: 298.25, ellipseName: "Appl. Physics. 1965" },
  "NWL9D": { a: 6378145.0, rf: 298.25, ellipseName: "Naval Weapons Lab., 1965" },
  "mod_airy": { a: 6377340.189, b: 6356034.446, ellipseName: "Modified Airy" },
  "andrae": { a: 6377104.43, rf: 300.0, ellipseName: "Andrae 1876 (Den., Iclnd.)" },
  "aust_SA": { a: 6378160.0, rf: 298.25, ellipseName: "Australian Natl & S. Amer. 1969" },
  "GRS67": { a: 6378160.0, rf: 298.2471674270, ellipseName: "GRS 67(IUGG 1967)" },
  "bessel": { a: 6377397.155, rf: 299.1528128, ellipseName: "Bessel 1841" },
  "bess_nam": { a: 6377483.865, rf: 299.1528128, ellipseName: "Bessel 1841 (Namibia)" },
  "clrk66": { a: 6378206.4, b: 6356583.8, ellipseName: "Clarke 1866" },
  "clrk80": { a: 6378249.145, rf: 293.4663, ellipseName: "Clarke 1880 mod." },
  "CPM": { a: 6375738.7, rf: 334.29, ellipseName: "Comm. des Poids et Mesures 1799" },
  "delmbr": { a: 6376428.0, rf: 311.5, ellipseName: "Delambre 1810 (Belgium)" },
  "engelis": { a: 6378136.05, rf: 298.2566, ellipseName: "Engelis 1985" },
  "evrst30": { a: 6377276.345, rf: 300.8017, ellipseName: "Everest 1830" },
  "evrst48": { a: 6377304.063, rf: 300.8017, ellipseName: "Everest 1948" },
  "evrst56": { a: 6377301.243, rf: 300.8017, ellipseName: "Everest 1956" },
  "evrst69": { a: 6377295.664, rf: 300.8017, ellipseName: "Everest 1969" },
  "evrstSS": { a: 6377298.556, rf: 300.8017, ellipseName: "Everest (Sabah & Sarawak)" },
  "fschr60": { a: 6378166.0, rf: 298.3, ellipseName: "Fischer (Mercury Datum) 1960" },
  "fschr60m": { a: 6378155.0, rf: 298.3, ellipseName: "Fischer 1960" },
  "fschr68": { a: 6378150.0, rf: 298.3, ellipseName: "Fischer 1968" },
  "helmert": { a: 6378200.0, rf: 298.3, ellipseName: "Helmert 1906" },
  "hough": { a: 6378270.0, rf: 297.0, ellipseName: "Hough" },
  "intl": { a: 6378388.0, rf: 297.0, ellipseName: "International 1909 (Hayford)" },
  "kaula": { a: 6378163.0, rf: 298.24, ellipseName: "Kaula 1961" },
  "lerch": { a: 6378139.0, rf: 298.257, ellipseName: "Lerch 1979" },
  "mprts": { a: 6397300.0, rf: 191.0, ellipseName: "Maupertius 1738" },
  "new_intl": { a: 6378157.5, b: 6356772.2, ellipseName: "New International 1967" },
  "plessis": { a: 6376523.0, rf: 6355863.0, ellipseName: "Plessis 1817 (France)" },
  "krass": { a: 6378245.0, rf: 298.3, ellipseName: "Krassovsky, 1942" },
  "SEasia": { a: 6378155.0, b: 6356773.3205, ellipseName: "Southeast Asia" },
  "walbeck": { a: 6376896.0, b: 6355834.8467, ellipseName: "Walbeck" },
  "WGS60": { a: 6378165.0, rf: 298.3, ellipseName: "WGS 60" },
  "WGS66": { a: 6378145.0, rf: 298.25, ellipseName: "WGS 66" },
  "WGS72": { a: 6378135.0, rf: 298.26, ellipseName: "WGS 72" },
  "WGS84": { a: 6378137.0, rf: 298.257223563, ellipseName: "WGS 84" },
  "sphere": { a: 6370997.0, b: 6370997.0, ellipseName: "Normal Sphere (r=6370997)" }
};

Proj4js.Datum = {
  "WGS84": { towgs84: "0,0,0", ellipse: "WGS84", datumName: "WGS84" },
  "GGRS87": { towgs84: "-199.87,74.79,246.62", ellipse: "GRS80", datumName: "Greek_Geodetic_Reference_System_1987" },
  "NAD83": { towgs84: "0,0,0", ellipse: "GRS80", datumName: "North_American_Datum_1983" },
  "NAD27": { nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat", ellipse: "clrk66", datumName: "North_American_Datum_1927" },
  "potsdam": { towgs84: "606.0,23.0,413.0", ellipse: "bessel", datumName: "Potsdam Rauenberg 1950 DHDN" },
  "carthage": { towgs84: "-263.0,6.0,431.0", ellipse: "clark80", datumName: "Carthage 1934 Tunisia" },
  "hermannskogel": { towgs84: "653.0,-212.0,449.0", ellipse: "bessel", datumName: "Hermannskogel" },
  "ire65": { towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15", ellipse: "mod_airy", datumName: "Ireland 1965" },
  "nzgd49": { towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993", ellipse: "intl", datumName: "New Zealand Geodetic Datum 1949" },
  "OSGB36": { towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894", ellipse: "airy", datumName: "Airy 1830" }
};

Proj4js.WGS84 = new Proj4js.Proj('WGS84');
Proj4js.Datum['OSB36'] = Proj4js.Datum['OSGB36']; //as returned from spatialreference.org

//lookup table to go from the projection name in WKT to the Proj4js projection name
//build this out as required
Proj4js.wktProjections = {
  "Lambert Tangential Conformal Conic Projection": "lcc",
  "Mercator": "merc",
  "Popular Visualisation Pseudo Mercator": "merc",
  "Mercator_1SP": "merc",
  "Transverse_Mercator": "tmerc",
  "Transverse Mercator": "tmerc",
  "Lambert Azimuthal Equal Area": "laea",
  "Universal Transverse Mercator System": "utm"
};

/* ======================================================================
    projCode/aea.js
   ====================================================================== */

/*******************************************************************************
NAME                     ALBERS CONICAL EQUAL AREA 

PURPOSE:	Transforms input longitude and latitude to Easting and Northing
        for the Albers Conical Equal Area projection.  The longitude
        and latitude must be in radians.  The Easting and Northing
        values will be returned in meters.

PROGRAMMER              DATE
----------              ----
T. Mittan,       	Feb, 1992

ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.
*******************************************************************************/

Proj4js.Proj.aea = {
  init: function init() {

    if (Math.abs(this.lat1 + this.lat2) < Proj4js.common.EPSLN) {
      Proj4js.reportError("aeaInitEqualLatitudes");
      return;
    }
    this.temp = this.b / this.a;
    this.es = 1.0 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);

    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = Proj4js.common.msfnz(this.e3, this.sin_po, this.cos_po);
    this.qs1 = Proj4js.common.qsfnz(this.e3, this.sin_po, this.cos_po);

    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = Proj4js.common.msfnz(this.e3, this.sin_po, this.cos_po);
    this.qs2 = Proj4js.common.qsfnz(this.e3, this.sin_po, this.cos_po);

    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = Proj4js.common.qsfnz(this.e3, this.sin_po, this.cos_po);

    if (Math.abs(this.lat1 - this.lat2) > Proj4js.common.EPSLN) {
      this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    } else {
      this.ns0 = this.con;
    }
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
  },

  /* Albers Conical Equal Area forward equations--mapping lat,long to x,y
    -------------------------------------------------------------------*/
  forward: function forward(p) {

    var lon = p.x;
    var lat = p.y;

    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);

    var qs = Proj4js.common.qsfnz(this.e3, this.sin_phi, this.cos_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * Proj4js.common.adjust_lon(lon - this.long0);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;

    p.x = x;
    p.y = y;
    return p;
  },

  inverse: function inverse(p) {
    var rh1, qs, con, theta, lon, lat;

    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
      rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
      con = 1.0;
    } else {
      rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
      con = -1.0;
    }
    theta = 0.0;
    if (rh1 != 0.0) {
      theta = Math.atan2(con * p.x, con * p.y);
    }
    con = rh1 * this.ns0 / this.a;
    qs = (this.c - con * con) / this.ns0;
    if (this.e3 >= 1e-10) {
      con = 1 - .5 * (1.0 - this.es) * Math.log((1.0 - this.e3) / (1.0 + this.e3)) / this.e3;
      if (Math.abs(Math.abs(con) - Math.abs(qs)) > .0000000001) {
        lat = this.phi1z(this.e3, qs);
      } else {
        if (qs >= 0) {
          lat = .5 * Proj4js.common.PI;
        } else {
          lat = -.5 * Proj4js.common.PI;
        }
      }
    } else {
      lat = this.phi1z(this.e3, qs);
    }

    lon = Proj4js.common.adjust_lon(theta / this.ns0 + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
  },

  /* Function to compute phi1, the latitude for the inverse of the
     Albers Conical Equal-Area projection.
  -------------------------------------------*/
  phi1z: function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = Proj4js.common.asinz(.5 * qs);
    if (eccent < Proj4js.common.EPSLN) return phi;

    var eccnts = eccent * eccent;
    for (var i = 1; i <= 25; i++) {
      sinphi = Math.sin(phi);
      cosphi = Math.cos(phi);
      con = eccent * sinphi;
      com = 1.0 - con * con;
      dphi = .5 * com * com / cosphi * (qs / (1.0 - eccnts) - sinphi / com + .5 / eccent * Math.log((1.0 - con) / (1.0 + con)));
      phi = phi + dphi;
      if (Math.abs(dphi) <= 1e-7) return phi;
    }
    Proj4js.reportError("aea:phi1z:Convergence error");
    return null;
  }

};

/* ======================================================================
    projCode/sterea.js
   ====================================================================== */

Proj4js.Proj.sterea = {
  dependsOn: 'gauss',

  init: function init() {
    Proj4js.Proj['gauss'].init.apply(this);
    if (!this.rc) {
      Proj4js.reportError("sterea:init:E_ERROR_0");
      return;
    }
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2.0 * this.rc;
    if (!this.title) this.title = "Oblique Stereographic Alternative";
  },

  forward: function forward(p) {
    var sinc, cosc, cosl, k;
    p.x = Proj4js.common.adjust_lon(p.x - this.long0); /* adjust del longitude */
    Proj4js.Proj['gauss'].forward.apply(this, [p]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1.0 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
  },

  inverse: function inverse(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a; /* descale and de-offset */
    p.y = (p.y - this.y0) / this.a;

    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = Math.sqrt(p.x * p.x + p.y * p.y)) {
      var c = 2.0 * Math.atan2(rho, this.R2);
      sinc = Math.sin(c);
      cosc = Math.cos(c);
      lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
      lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
      lat = this.phic0;
      lon = 0.;
    }

    p.x = lon;
    p.y = lat;
    Proj4js.Proj['gauss'].inverse.apply(this, [p]);
    p.x = Proj4js.common.adjust_lon(p.x + this.long0); /* adjust longitude to CM */
    return p;
  }
};

/* ======================================================================
    projCode/poly.js
   ====================================================================== */

/* Function to compute, phi4, the latitude for the inverse of the
   Polyconic projection.
------------------------------------------------------------*/
function phi4z(eccent, e0, e1, e2, e3, a, b, c, phi) {
  var sinphi, sin2ph, tanphi, ml, mlp, con1, con2, con3, dphi, i;

  phi = a;
  for (i = 1; i <= 15; i++) {
    sinphi = Math.sin(phi);
    tanphi = Math.tan(phi);
    c = tanphi * Math.sqrt(1.0 - eccent * sinphi * sinphi);
    sin2ph = Math.sin(2.0 * phi);
    /*
    ml = e0 * *phi - e1 * sin2ph + e2 * sin (4.0 *  *phi);
    mlp = e0 - 2.0 * e1 * cos (2.0 *  *phi) + 4.0 * e2 *  cos (4.0 *  *phi);
    */
    ml = e0 * phi - e1 * sin2ph + e2 * Math.sin(4.0 * phi) - e3 * Math.sin(6.0 * phi);
    mlp = e0 - 2.0 * e1 * Math.cos(2.0 * phi) + 4.0 * e2 * Math.cos(4.0 * phi) - 6.0 * e3 * Math.cos(6.0 * phi);
    con1 = 2.0 * ml + c * (ml * ml + b) - 2.0 * a * (c * ml + 1.0);
    con2 = eccent * sin2ph * (ml * ml + b - 2.0 * a * ml) / (2.0 * c);
    con3 = 2.0 * (a - ml) * (c * mlp - 2.0 / sin2ph) - 2.0 * mlp;
    dphi = con1 / (con2 + con3);
    phi += dphi;
    if (Math.abs(dphi) <= .0000000001) return phi;
  }
  Proj4js.reportError("phi4z: No convergence");
  return null;
}

/* Function to compute the constant e4 from the input of the eccentricity
   of the spheroid, x.  This constant is used in the Polar Stereographic
   projection.
--------------------------------------------------------------------*/
function e4fn(x) {
  var con, com;
  con = 1.0 + x;
  com = 1.0 - x;
  return Math.sqrt(Math.pow(con, con) * Math.pow(com, com));
}

/*******************************************************************************
NAME                             POLYCONIC 

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Polyconic projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE
----------              ----
T. Mittan		Mar, 1993

ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.
*******************************************************************************/

Proj4js.Proj.poly = {

  /* Initialize the POLYCONIC projection
    ----------------------------------*/
  init: function init() {
    var temp; /* temporary variable		*/
    if (this.lat0 == 0) this.lat0 = 90; //this.lat0 ca

    /* Place parameters in static storage for common use
      -------------------------------------------------*/
    this.temp = this.b / this.a;
    this.es = 1.0 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles 
    this.e = Math.sqrt(this.es);
    this.e0 = Proj4js.common.e0fn(this.es);
    this.e1 = Proj4js.common.e1fn(this.es);
    this.e2 = Proj4js.common.e2fn(this.es);
    this.e3 = Proj4js.common.e3fn(this.es);
    this.ml0 = Proj4js.common.mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
    //if (!this.ml0) {this.ml0=0;}
  },

  /* Polyconic forward equations--mapping lat,long to x,y
    ---------------------------------------------------*/
  forward: function forward(p) {
    var sinphi, cosphi; /* sin and cos value				*/
    var al; /* temporary values				*/
    var c; /* temporary values				*/
    var con, ml; /* cone constant, small m			*/
    var ms; /* small m					*/
    var x, y;

    var lon = p.x;
    var lat = p.y;

    con = Proj4js.common.adjust_lon(lon - this.long0);
    if (Math.abs(lat) <= .0000001) {
      x = this.x0 + this.a * con;
      y = this.y0 - this.a * this.ml0;
    } else {
      sinphi = Math.sin(lat);
      cosphi = Math.cos(lat);

      ml = Proj4js.common.mlfn(this.e0, this.e1, this.e2, this.e3, lat);
      ms = Proj4js.common.msfnz(this.e, sinphi, cosphi);
      con = sinphi;
      x = this.x0 + this.a * ms * Math.sin(con) / sinphi;
      y = this.y0 + this.a * (ml - this.ml0 + ms * (1.0 - Math.cos(con)) / sinphi);
    }

    p.x = x;
    p.y = y;
    return p;
  },

  /* Inverse equations
  -----------------*/
  inverse: function inverse(p) {
    var sin_phi, cos_phi; /* sin and cos value				*/
    var al; /* temporary values				*/
    var b; /* temporary values				*/
    var c; /* temporary values				*/
    var con, ml; /* cone constant, small m			*/
    var iflg; /* error flag					*/
    var lon, lat;
    p.x -= this.x0;
    p.y -= this.y0;
    al = this.ml0 + p.y / this.a;
    iflg = 0;

    if (Math.abs(al) <= .0000001) {
      lon = p.x / this.a + this.long0;
      lat = 0.0;
    } else {
      b = al * al + p.x / this.a * (p.x / this.a);
      iflg = phi4z(this.es, this.e0, this.e1, this.e2, this.e3, this.al, b, c, lat);
      if (iflg != 1) return iflg;
      lon = Proj4js.common.adjust_lon(Proj4js.common.asinz(p.x * c / this.a) / Math.sin(lat) + this.long0);
    }

    p.x = lon;
    p.y = lat;
    return p;
  }
};

/* ======================================================================
    projCode/equi.js
   ====================================================================== */

/*******************************************************************************
NAME                             EQUIRECTANGULAR 

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Equirectangular projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE
----------              ----
T. Mittan		Mar, 1993

ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.
*******************************************************************************/
Proj4js.Proj.equi = {

  init: function init() {
    if (!this.x0) this.x0 = 0;
    if (!this.y0) this.y0 = 0;
    if (!this.lat0) this.lat0 = 0;
    if (!this.long0) this.long0 = 0;
    ///this.t2;
  },

  /* Equirectangular forward equations--mapping lat,long to x,y
    ---------------------------------------------------------*/
  forward: function forward(p) {

    var lon = p.x;
    var lat = p.y;

    var dlon = Proj4js.common.adjust_lon(lon - this.long0);
    var x = this.x0 + this.a * dlon * Math.cos(this.lat0);
    var y = this.y0 + this.a * lat;

    this.t1 = x;
    this.t2 = Math.cos(this.lat0);
    p.x = x;
    p.y = y;
    return p;
  }, //equiFwd()


  /* Equirectangular inverse equations--mapping x,y to lat/long
    ---------------------------------------------------------*/
  inverse: function inverse(p) {

    p.x -= this.x0;
    p.y -= this.y0;
    var lat = p.y / this.a;

    if (Math.abs(lat) > Proj4js.common.HALF_PI) {
      Proj4js.reportError("equi:Inv:DataError");
    }
    var lon = Proj4js.common.adjust_lon(this.long0 + p.x / (this.a * Math.cos(this.lat0)));
    p.x = lon;
    p.y = lat;
  } //equiInv()
};

/* ======================================================================
    projCode/merc.js
   ====================================================================== */

/*******************************************************************************
NAME                            MERCATOR

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Mercator projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE
----------              ----
D. Steinwand, EROS      Nov, 1991
T. Mittan		Mar, 1993

ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.
*******************************************************************************/

//static double r_major = a;		   /* major axis 				*/
//static double r_minor = b;		   /* minor axis 				*/
//static double lon_center = long0;	   /* Center longitude (projection center) */
//static double lat_origin =  lat0;	   /* center latitude			*/
//static double e,es;		           /* eccentricity constants		*/
//static double m1;		               /* small value m			*/
//static double false_northing = y0;   /* y offset in meters			*/
//static double false_easting = x0;	   /* x offset in meters			*/
//scale_fact = k0 

Proj4js.Proj.merc = {
  init: function init() {
    //?this.temp = this.r_minor / this.r_major;
    //this.temp = this.b / this.a;
    //this.es = 1.0 - Math.sqrt(this.temp);
    //this.e = Math.sqrt( this.es );
    //?this.m1 = Math.cos(this.lat_origin) / (Math.sqrt( 1.0 - this.es * Math.sin(this.lat_origin) * Math.sin(this.lat_origin)));
    //this.m1 = Math.cos(0.0) / (Math.sqrt( 1.0 - this.es * Math.sin(0.0) * Math.sin(0.0)));
    if (this.lat_ts) {
      if (this.sphere) {
        this.k0 = Math.cos(this.lat_ts);
      } else {
        this.k0 = Proj4js.common.msfnz(this.es, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
      }
    }
  },

  /* Mercator forward equations--mapping lat,long to x,y
    --------------------------------------------------*/

  forward: function forward(p) {
    //alert("ll2m coords : "+coords);
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * Proj4js.common.R2D > 90.0 && lat * Proj4js.common.R2D < -90.0 && lon * Proj4js.common.R2D > 180.0 && lon * Proj4js.common.R2D < -180.0) {
      Proj4js.reportError("merc:forward: llInputOutOfRange: " + lon + " : " + lat);
      return null;
    }

    var x, y;
    if (Math.abs(Math.abs(lat) - Proj4js.common.HALF_PI) <= Proj4js.common.EPSLN) {
      Proj4js.reportError("merc:forward: ll2mAtPoles");
      return null;
    } else {
      if (this.sphere) {
        x = this.x0 + this.a * this.k0 * Proj4js.common.adjust_lon(lon - this.long0);
        y = this.y0 + this.a * this.k0 * Math.log(Math.tan(Proj4js.common.FORTPI + 0.5 * lat));
      } else {
        var sinphi = Math.sin(lat);
        var ts = Proj4js.common.tsfnz(this.e, lat, sinphi);
        x = this.x0 + this.a * this.k0 * Proj4js.common.adjust_lon(lon - this.long0);
        y = this.y0 - this.a * this.k0 * Math.log(ts);
      }
      p.x = x;
      p.y = y;
      return p;
    }
  },

  /* Mercator inverse equations--mapping x,y to lat/long
  --------------------------------------------------*/
  inverse: function inverse(p) {

    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;

    if (this.sphere) {
      lat = Proj4js.common.HALF_PI - 2.0 * Math.atan(Math.exp(-y / this.a * this.k0));
    } else {
      var ts = Math.exp(-y / (this.a * this.k0));
      lat = Proj4js.common.phi2z(this.e, ts);
      if (lat == -9999) {
        Proj4js.reportError("merc:inverse: lat = -9999");
        return null;
      }
    }
    lon = Proj4js.common.adjust_lon(this.long0 + x / (this.a * this.k0));

    p.x = lon;
    p.y = lat;
    return p;
  }
};

/* ======================================================================
    projCode/utm.js
   ====================================================================== */

/*******************************************************************************
NAME                            TRANSVERSE MERCATOR

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Transverse Mercator projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.
*******************************************************************************/

/**
  Initialize Transverse Mercator projection
*/

Proj4js.Proj.utm = {
  dependsOn: 'tmerc',

  init: function init() {
    if (!this.zone) {
      Proj4js.reportError("utm:init: zone must be specified for UTM");
      return;
    }
    this.lat0 = 0.0;
    this.long0 = (6 * Math.abs(this.zone) - 183) * Proj4js.common.D2R;
    this.x0 = 500000.0;
    this.y0 = this.utmSouth ? 10000000.0 : 0.0;
    this.k0 = 0.9996;

    Proj4js.Proj['tmerc'].init.apply(this);
    this.forward = Proj4js.Proj['tmerc'].forward;
    this.inverse = Proj4js.Proj['tmerc'].inverse;
  }
};
/* ======================================================================
    projCode/eqdc.js
   ====================================================================== */

/*******************************************************************************
NAME                            EQUIDISTANT CONIC 

PURPOSE:	Transforms input longitude and latitude to Easting and Northing
        for the Equidistant Conic projection.  The longitude and
        latitude must be in radians.  The Easting and Northing values
        will be returned in meters.

PROGRAMMER              DATE
----------              ----
T. Mittan		Mar, 1993

ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.
*******************************************************************************/

/* Variables common to all subroutines in this code file
  -----------------------------------------------------*/

Proj4js.Proj.eqdc = {

  /* Initialize the Equidistant Conic projection
    ------------------------------------------*/
  init: function init() {

    /* Place parameters in static storage for common use
      -------------------------------------------------*/

    if (!this.mode) this.mode = 0; //chosen default mode
    this.temp = this.b / this.a;
    this.es = 1.0 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = Proj4js.common.e0fn(this.es);
    this.e1 = Proj4js.common.e1fn(this.es);
    this.e2 = Proj4js.common.e2fn(this.es);
    this.e3 = Proj4js.common.e3fn(this.es);

    this.sinphi = Math.sin(this.lat1);
    this.cosphi = Math.cos(this.lat1);

    this.ms1 = Proj4js.common.msfnz(this.e, this.sinphi, this.cosphi);
    this.ml1 = Proj4js.common.mlfn(this.e0, this.e1, this.e2, this.e3, this.lat1);

    /* format B
    ---------*/
    if (this.mode != 0) {
      if (Math.abs(this.lat1 + this.lat2) < Proj4js.common.EPSLN) {
        Proj4js.reportError("eqdc:Init:EqualLatitudes");
        //return(81);
      }
      this.sinphi = Math.sin(this.lat2);
      this.cosphi = Math.cos(this.lat2);

      this.ms2 = Proj4js.common.msfnz(this.e, this.sinphi, this.cosphi);
      this.ml2 = Proj4js.common.mlfn(this.e0, this.e1, this.e2, this.e3, this.lat2);
      if (Math.abs(this.lat1 - this.lat2) >= Proj4js.common.EPSLN) {
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
      } else {
        this.ns = this.sinphi;
      }
    } else {
      this.ns = this.sinphi;
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = Proj4js.common.mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
  },

  /* Equidistant Conic forward equations--mapping lat,long to x,y
    -----------------------------------------------------------*/
  forward: function forward(p) {
    var lon = p.x;
    var lat = p.y;

    /* Forward equations
      -----------------*/
    var ml = Proj4js.common.mlfn(this.e0, this.e1, this.e2, this.e3, lat);
    var rh1 = this.a * (this.g - ml);
    var theta = this.ns * Proj4js.common.adjust_lon(lon - this.long0);

    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
  },

  /* Inverse equations
    -----------------*/
  inverse: function inverse(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1;
    if (this.ns >= 0) {
      rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
      con = 1.0;
    } else {
      rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
      con = -1.0;
    }
    var theta = 0.0;
    if (rh1 != 0.0) theta = Math.atan2(con * p.x, con * p.y);
    var ml = this.g - rh1 / this.a;
    var lat = this.phi3z(ml, this.e0, this.e1, this.e2, this.e3);
    var lon = Proj4js.common.adjust_lon(this.long0 + theta / this.ns);

    p.x = lon;
    p.y = lat;
    return p;
  },

  /* Function to compute latitude, phi3, for the inverse of the Equidistant
     Conic projection.
  -----------------------------------------------------------------*/
  phi3z: function phi3z(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;

    phi = ml;
    for (var i = 0; i < 15; i++) {
      dphi = (ml + e1 * Math.sin(2.0 * phi) - e2 * Math.sin(4.0 * phi) + e3 * Math.sin(6.0 * phi)) / e0 - phi;
      phi += dphi;
      if (Math.abs(dphi) <= .0000000001) {
        return phi;
      }
    }
    Proj4js.reportError("PHI3Z-CONV:Latitude failed to converge after 15 iterations");
    return null;
  }

};
/* ======================================================================
    projCode/tmerc.js
   ====================================================================== */

/*******************************************************************************
NAME                            TRANSVERSE MERCATOR

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Transverse Mercator projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.
*******************************************************************************/

/**
  Initialize Transverse Mercator projection
*/

Proj4js.Proj.tmerc = {
  init: function init() {
    this.e0 = Proj4js.common.e0fn(this.es);
    this.e1 = Proj4js.common.e1fn(this.es);
    this.e2 = Proj4js.common.e2fn(this.es);
    this.e3 = Proj4js.common.e3fn(this.es);
    this.ml0 = this.a * Proj4js.common.mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
  },

  /**
    Transverse Mercator Forward  - long/lat to x/y
    long/lat in radians
  */
  forward: function forward(p) {
    var lon = p.x;
    var lat = p.y;

    var delta_lon = Proj4js.common.adjust_lon(lon - this.long0); // Delta longitude
    var con; // cone constant
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);

    if (this.sphere) {
      /* spherical form */
      var b = cos_phi * Math.sin(delta_lon);
      if (Math.abs(Math.abs(b) - 1.0) < .0000000001) {
        Proj4js.reportError("tmerc:forward: Point projects into infinity");
        return 93;
      } else {
        x = .5 * this.a * this.k0 * Math.log((1.0 + b) / (1.0 - b));
        con = Math.acos(cos_phi * Math.cos(delta_lon) / Math.sqrt(1.0 - b * b));
        if (lat < 0) con = -con;
        y = this.a * this.k0 * (con - this.lat0);
      }
    } else {
      var al = cos_phi * delta_lon;
      var als = Math.pow(al, 2);
      var c = this.ep2 * Math.pow(cos_phi, 2);
      var tq = Math.tan(lat);
      var t = Math.pow(tq, 2);
      con = 1.0 - this.es * Math.pow(sin_phi, 2);
      var n = this.a / Math.sqrt(con);
      var ml = this.a * Proj4js.common.mlfn(this.e0, this.e1, this.e2, this.e3, lat);

      x = this.k0 * n * al * (1.0 + als / 6.0 * (1.0 - t + c + als / 20.0 * (5.0 - 18.0 * t + Math.pow(t, 2) + 72.0 * c - 58.0 * this.ep2))) + this.x0;
      y = this.k0 * (ml - this.ml0 + n * tq * (als * (0.5 + als / 24.0 * (5.0 - t + 9.0 * c + 4.0 * Math.pow(c, 2) + als / 30.0 * (61.0 - 58.0 * t + Math.pow(t, 2) + 600.0 * c - 330.0 * this.ep2))))) + this.y0;
    }
    p.x = x;p.y = y;
    return p;
  }, // tmercFwd()

  /**
    Transverse Mercator Inverse  -  x/y to long/lat
  */
  inverse: function inverse(p) {
    var con, phi; /* temporary angles       */
    var delta_phi; /* difference between longitudes    */
    var i;
    var max_iter = 6; /* maximun number of iterations */
    var lat, lon;

    if (this.sphere) {
      /* spherical form */
      var f = Math.exp(p.x / (this.a * this.k0));
      var g = .5 * (f - 1 / f);
      var temp = this.lat0 + p.y / (this.a * this.k0);
      var h = Math.cos(temp);
      con = Math.sqrt((1.0 - h * h) / (1.0 + g * g));
      lat = Proj4js.common.asinz(con);
      if (temp < 0) lat = -lat;
      if (g == 0 && h == 0) {
        lon = this.long0;
      } else {
        lon = Proj4js.common.adjust_lon(Math.atan2(g, h) + this.long0);
      }
    } else {
      // ellipsoidal form
      var x = p.x - this.x0;
      var y = p.y - this.y0;

      con = (this.ml0 + y / this.k0) / this.a;
      phi = con;
      for (i = 0; true; i++) {
        delta_phi = (con + this.e1 * Math.sin(2.0 * phi) - this.e2 * Math.sin(4.0 * phi) + this.e3 * Math.sin(6.0 * phi)) / this.e0 - phi;
        phi += delta_phi;
        if (Math.abs(delta_phi) <= Proj4js.common.EPSLN) break;
        if (i >= max_iter) {
          Proj4js.reportError("tmerc:inverse: Latitude failed to converge");
          return 95;
        }
      } // for()
      if (Math.abs(phi) < Proj4js.common.HALF_PI) {
        // sincos(phi, &sin_phi, &cos_phi);
        var sin_phi = Math.sin(phi);
        var cos_phi = Math.cos(phi);
        var tan_phi = Math.tan(phi);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var t = Math.pow(tan_phi, 2);
        var ts = Math.pow(t, 2);
        con = 1.0 - this.es * Math.pow(sin_phi, 2);
        var n = this.a / Math.sqrt(con);
        var r = n * (1.0 - this.es) / con;
        var d = x / (n * this.k0);
        var ds = Math.pow(d, 2);
        lat = phi - n * tan_phi * ds / r * (0.5 - ds / 24.0 * (5.0 + 3.0 * t + 10.0 * c - 4.0 * cs - 9.0 * this.ep2 - ds / 30.0 * (61.0 + 90.0 * t + 298.0 * c + 45.0 * ts - 252.0 * this.ep2 - 3.0 * cs)));
        lon = Proj4js.common.adjust_lon(this.long0 + d * (1.0 - ds / 6.0 * (1.0 + 2.0 * t + c - ds / 20.0 * (5.0 - 2.0 * c + 28.0 * t - 3.0 * cs + 8.0 * this.ep2 + 24.0 * ts))) / cos_phi);
      } else {
        lat = Proj4js.common.HALF_PI * Proj4js.common.sign(y);
        lon = this.long0;
      }
    }
    p.x = lon;
    p.y = lat;
    return p;
  } // tmercInv()
};
/* ======================================================================
    defs/GOOGLE.js
   ====================================================================== */

Proj4js.defs["GOOGLE"] = "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs";
Proj4js.defs["EPSG:900913"] = Proj4js.defs["GOOGLE"];
/* ======================================================================
    projCode/gstmerc.js
   ====================================================================== */

Proj4js.Proj.gstmerc = {
  init: function init() {

    // array of:  a, b, lon0, lat0, k0, x0, y0
    var temp = this.b / this.a;
    this.e = Math.sqrt(1.0 - temp * temp);
    this.lc = this.long0;
    this.rs = Math.sqrt(1.0 + this.e * this.e * Math.pow(Math.cos(this.lat0), 4.0) / (1.0 - this.e * this.e));
    var sinz = Math.sin(this.lat0);
    var pc = Math.asin(sinz / this.rs);
    var sinzpc = Math.sin(pc);
    this.cp = Proj4js.common.latiso(0.0, pc, sinzpc) - this.rs * Proj4js.common.latiso(this.e, this.lat0, sinz);
    this.n2 = this.k0 * this.a * Math.sqrt(1.0 - this.e * this.e) / (1.0 - this.e * this.e * sinz * sinz);
    this.xs = this.x0;
    this.ys = this.y0 - this.n2 * pc;

    if (!this.title) this.title = "Gauss Schreiber transverse mercator";
  },

  // forward equations--mapping lat,long to x,y
  // -----------------------------------------------------------------
  forward: function forward(p) {

    var lon = p.x;
    var lat = p.y;

    var L = this.rs * (lon - this.lc);
    var Ls = this.cp + this.rs * Proj4js.common.latiso(this.e, lat, Math.sin(lat));
    var lat1 = Math.asin(Math.sin(L) / Proj4js.common.cosh(Ls));
    var Ls1 = Proj4js.common.latiso(0.0, lat1, Math.sin(lat1));
    p.x = this.xs + this.n2 * Ls1;
    p.y = this.ys + this.n2 * Math.atan(Proj4js.common.sinh(Ls) / Math.cos(L));
    return p;
  },

  // inverse equations--mapping x,y to lat/long
  // -----------------------------------------------------------------
  inverse: function inverse(p) {

    var x = p.x;
    var y = p.y;

    var L = Math.atan(Proj4js.common.sinh((x - this.xs) / this.n2) / Math.cos((y - this.ys) / this.n2));
    var lat1 = Math.asin(Math.sin((y - this.ys) / this.n2) / Proj4js.common.cosh((x - this.xs) / this.n2));
    var LC = Proj4js.common.latiso(0.0, lat1, Math.sin(lat1));
    p.x = this.lc + L / this.rs;
    p.y = Proj4js.common.invlatiso(this.e, (LC - this.cp) / this.rs);
    return p;
  }

};
/* ======================================================================
    projCode/ortho.js
   ====================================================================== */

/*******************************************************************************
NAME                             ORTHOGRAPHIC 

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Orthographic projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE
----------              ----
T. Mittan		Mar, 1993

ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.
*******************************************************************************/

Proj4js.Proj.ortho = {

  /* Initialize the Orthographic projection
    -------------------------------------*/
  init: function init(def) {
    //double temp;			/* temporary variable		*/

    /* Place parameters in static storage for common use
      -------------------------------------------------*/;
    this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
  },

  /* Orthographic forward equations--mapping lat,long to x,y
    ---------------------------------------------------*/
  forward: function forward(p) {
    var sinphi, cosphi; /* sin and cos value				*/
    var dlon; /* delta longitude value			*/
    var coslon; /* cos of longitude				*/
    var ksp; /* scale factor					*/
    var g;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/
    dlon = Proj4js.common.adjust_lon(lon - this.long0);

    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);

    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1.0;
    if (g > 0 || Math.abs(g) <= Proj4js.common.EPSLN) {
      var x = this.a * ksp * cosphi * Math.sin(dlon);
      var y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    } else {
      Proj4js.reportError("orthoFwdPointError");
    }
    p.x = x;
    p.y = y;
    return p;
  },

  inverse: function inverse(p) {
    var rh; /* height above ellipsoid			*/
    var z; /* angle					*/
    var sinz, cosz; /* sin of z and cos of z			*/
    var temp;
    var con;
    var lon, lat;
    /* Inverse equations
      -----------------*/
    p.x -= this.x0;
    p.y -= this.y0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (rh > this.a + .0000001) {
      Proj4js.reportError("orthoInvDataError");
    }
    z = Proj4js.common.asinz(rh / this.a);

    sinz = Math.sin(z);
    cosz = Math.cos(z);

    lon = this.long0;
    if (Math.abs(rh) <= Proj4js.common.EPSLN) {
      lat = this.lat0;
    }
    lat = Proj4js.common.asinz(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(this.lat0) - Proj4js.common.HALF_PI;
    if (Math.abs(con) <= Proj4js.common.EPSLN) {
      if (this.lat0 >= 0) {
        lon = Proj4js.common.adjust_lon(this.long0 + Math.atan2(p.x, -p.y));
      } else {
        lon = Proj4js.common.adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
      }
    }
    con = cosz - this.sin_p14 * Math.sin(lat);
    p.x = lon;
    p.y = lat;
    return p;
  }
};

/* ======================================================================
    projCode/krovak.js
   ====================================================================== */

/**
   NOTES: According to EPSG the full Krovak projection method should have
          the following parameters.  Within PROJ.4 the azimuth, and pseudo
          standard parallel are hardcoded in the algorithm and can't be 
          altered from outside.  The others all have defaults to match the
          common usage with Krovak projection.

  lat_0 = latitude of centre of the projection
         
  lon_0 = longitude of centre of the projection
  
  ** = azimuth (true) of the centre line passing through the centre of the projection

  ** = latitude of pseudo standard parallel
   
  k  = scale factor on the pseudo standard parallel
  
  x_0 = False Easting of the centre of the projection at the apex of the cone
  
  y_0 = False Northing of the centre of the projection at the apex of the cone

 **/

Proj4js.Proj.krovak = {

  init: function init() {
    /* we want Bessel as fixed ellipsoid */
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    /* if latitude of projection center is not set, use 49d30'N */
    if (!this.lat0) {
      this.lat0 = 0.863937979737193;
    }
    if (!this.long0) {
      this.long0 = 0.7417649320975901 - 0.308341501185665;
    }
    /* if scale not set default to 0.9999 */
    if (!this.k0) {
      this.k0 = 0.9999;
    }
    this.s45 = 0.785398163397448; /* 45° */
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0; /* Latitude of projection centre 49° 30' */
    /*  Ellipsoid Bessel 1841 a = 6377397.155m 1/f = 299.1528128,
                 e2=0.006674372230614;
    */
    this.e2 = this.es; /* 0.006674372230614; */
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1. + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1. - this.e2));
    this.uq = 1.04216856380474; /* DU(2, 59, 42, 42.69689) */
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1. + this.e * Math.sin(this.fi0)) / (1. - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2.);
    this.k = Math.tan(this.u0 / 2. + this.s45) / Math.pow(Math.tan(this.fi0 / 2. + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1. - this.e2) / (1. - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555; /* Latitude of pseudo standard parallel 78° 30'00" N */
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
  },

  /* ellipsoid */
  /* calculate xy from lat/lon */
  /* Constants, identical to inverse transform function */
  forward: function forward(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = Proj4js.common.adjust_lon(lon - this.long0); // Delta longitude
    /* Transformation */
    gfi = Math.pow((1. + this.e * Math.sin(lat)) / (1. - this.e * Math.sin(lat)), this.alfa * this.e / 2.);
    u = 2. * (Math.atan(this.k * Math.pow(Math.tan(lat / 2. + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2. + this.s45), this.n) / Math.pow(Math.tan(s / 2. + this.s45), this.n);
    /* x and y are reverted! */
    //p.y = ro * Math.cos(eps) / a;
    //p.x = ro * Math.sin(eps) / a;
    p.y = ro * Math.cos(eps) / 1.0;
    p.x = ro * Math.sin(eps) / 1.0;

    if (this.czech) {
      p.y *= -1.0;
      p.x *= -1.0;
    }
    return p;
  },

  /* calculate lat/lon from xy */
  inverse: function inverse(p) {
    /* Constants, identisch wie in der Umkehrfunktion */
    var u, deltav, s, d, eps, ro, fi1;
    var ok;

    /* Transformation */
    /* revert y, x*/
    var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (this.czech) {
      p.y *= -1.0;
      p.x *= -1.0;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2. * (Math.atan(Math.pow(this.ro0 / ro, 1. / this.n) * Math.tan(this.s0 / 2. + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    /* ITERATION FOR lat */
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
      p.y = 2. * (Math.atan(Math.pow(this.k, -1. / this.alfa) * Math.pow(Math.tan(u / 2. + this.s45), 1. / this.alfa) * Math.pow((1. + this.e * Math.sin(fi1)) / (1. - this.e * Math.sin(fi1)), this.e / 2.)) - this.s45);
      if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
      fi1 = p.y;
      iter += 1;
    } while (ok == 0 && iter < 15);
    if (iter >= 15) {
      Proj4js.reportError("PHI3Z-CONV:Latitude failed to converge after 15 iterations");
      //console.log('iter:', iter);
      return null;
    }

    return p;
  }
};
/* ======================================================================
    projCode/somerc.js
   ====================================================================== */

/*******************************************************************************
NAME                       SWISS OBLIQUE MERCATOR

PURPOSE:	Swiss projection.
WARNING:  X and Y are inverted (weird) in the swiss coordinate system. Not
   here, since we want X to be horizontal and Y vertical.

ALGORITHM REFERENCES
1. "Formules et constantes pour le Calcul pour la
 projection cylindrique conforme Ã  axe oblique et pour la transformation entre
 des systÃ¨mes de rÃ©fÃ©rence".
 http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf

*******************************************************************************/

Proj4js.Proj.somerc = {

  init: function init() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2.0));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4.0));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    this.K = Math.log(Math.tan(Math.PI / 4.0 + this.b0 / 2.0)) - this.alpha * Math.log(Math.tan(Math.PI / 4.0 + phy0 / 2.0)) + this.alpha * e / 2 * Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
  },

  forward: function forward(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4.0 - p.y / 2.0));
    var Sa2 = this.e / 2.0 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;

    // spheric latitude
    var b = 2.0 * (Math.atan(Math.exp(S)) - Math.PI / 4.0);

    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);

    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));

    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));

    p.y = this.R / 2.0 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
  },

  inverse: function inverse(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;

    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4.0);

    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));

    var lambda = this.lambda0 + I / this.alpha;

    var S = 0.0;
    var phy = b;
    var prevPhy = -1000.0;
    var iteration = 0;
    while (Math.abs(phy - prevPhy) > 0.0000001) {
      if (++iteration > 20) {
        Proj4js.reportError("omercFwdInfinity");
        return;
      }
      //S = Math.log(Math.tan(Math.PI / 4.0 + phy / 2.0));
      S = 1.0 / this.alpha * (Math.log(Math.tan(Math.PI / 4.0 + b / 2.0)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4.0 + Math.asin(this.e * Math.sin(phy)) / 2.0));
      prevPhy = phy;
      phy = 2.0 * Math.atan(Math.exp(S)) - Math.PI / 2.0;
    }

    p.x = lambda;
    p.y = phy;
    return p;
  }
};
/* ======================================================================
    projCode/stere.js
   ====================================================================== */

// Initialize the Stereographic projection

Proj4js.Proj.stere = {
  ssfn_: function ssfn_(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(.5 * (Proj4js.common.HALF_PI + phit)) * Math.pow((1. - sinphi) / (1. + sinphi), .5 * eccen);
  },
  TOL: 1.e-8,
  NITER: 8,
  CONV: 1.e-10,
  S_POLE: 0,
  N_POLE: 1,
  OBLIQ: 2,
  EQUIT: 3,

  init: function init() {
    this.phits = this.lat_ts ? this.lat_ts : Proj4js.common.HALF_PI;
    var t = Math.abs(this.lat0);
    if (Math.abs(t) - Proj4js.common.HALF_PI < Proj4js.common.EPSLN) {
      this.mode = this.lat0 < 0. ? this.S_POLE : this.N_POLE;
    } else {
      this.mode = t > Proj4js.common.EPSLN ? this.OBLIQ : this.EQUIT;
    }
    this.phits = Math.abs(this.phits);
    if (this.es) {
      var X;

      switch (this.mode) {
        case this.N_POLE:
        case this.S_POLE:
          if (Math.abs(this.phits - Proj4js.common.HALF_PI) < Proj4js.common.EPSLN) {
            this.akm1 = 2. * this.k0 / Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
          } else {
            t = Math.sin(this.phits);
            this.akm1 = Math.cos(this.phits) / Proj4js.common.tsfnz(this.e, this.phits, t);
            t *= this.e;
            this.akm1 /= Math.sqrt(1. - t * t);
          }
          break;
        case this.EQUIT:
          this.akm1 = 2. * this.k0;
          break;
        case this.OBLIQ:
          t = Math.sin(this.lat0);
          X = 2. * Math.atan(this.ssfn_(this.lat0, t, this.e)) - Proj4js.common.HALF_PI;
          t *= this.e;
          this.akm1 = 2. * this.k0 * Math.cos(this.lat0) / Math.sqrt(1. - t * t);
          this.sinX1 = Math.sin(X);
          this.cosX1 = Math.cos(X);
          break;
      }
    } else {
      switch (this.mode) {
        case this.OBLIQ:
          this.sinph0 = Math.sin(this.lat0);
          this.cosph0 = Math.cos(this.lat0);
        case this.EQUIT:
          this.akm1 = 2. * this.k0;
          break;
        case this.S_POLE:
        case this.N_POLE:
          this.akm1 = Math.abs(this.phits - Proj4js.common.HALF_PI) >= Proj4js.common.EPSLN ? Math.cos(this.phits) / Math.tan(Proj4js.common.FORTPI - .5 * this.phits) : 2. * this.k0;
          break;
      }
    }
  },

  // Stereographic forward equations--mapping lat,long to x,y
  forward: function forward(p) {
    var lon = p.x;
    lon = Proj4js.common.adjust_lon(lon - this.long0);
    var lat = p.y;
    var x, y;

    if (this.sphere) {
      var sinphi, cosphi, coslam, sinlam;

      sinphi = Math.sin(lat);
      cosphi = Math.cos(lat);
      coslam = Math.cos(lon);
      sinlam = Math.sin(lon);
      switch (this.mode) {
        case this.EQUIT:
          y = 1. + cosphi * coslam;
          if (y <= Proj4js.common.EPSLN) {
            Proj4js.reportError("stere:forward:Equit");
          }
          y = this.akm1 / y;
          x = y * cosphi * sinlam;
          y *= sinphi;
          break;
        case this.OBLIQ:
          y = 1. + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
          if (y <= Proj4js.common.EPSLN) {
            Proj4js.reportError("stere:forward:Obliq");
          }
          y = this.akm1 / y;
          x = y * cosphi * sinlam;
          y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
          break;
        case this.N_POLE:
          coslam = -coslam;
          lat = -lat;
        //Note  no break here so it conitnues through S_POLE
        case this.S_POLE:
          if (Math.abs(lat - Proj4js.common.HALF_PI) < this.TOL) {
            Proj4js.reportError("stere:forward:S_POLE");
          }
          y = this.akm1 * Math.tan(Proj4js.common.FORTPI + .5 * lat);
          x = sinlam * y;
          y *= coslam;
          break;
      }
    } else {
      coslam = Math.cos(lon);
      sinlam = Math.sin(lon);
      sinphi = Math.sin(lat);
      var sinX, cosX;
      if (this.mode == this.OBLIQ || this.mode == this.EQUIT) {
        var Xt = 2. * Math.atan(this.ssfn_(lat, sinphi, this.e));
        sinX = Math.sin(Xt - Proj4js.common.HALF_PI);
        cosX = Math.cos(Xt);
      }
      switch (this.mode) {
        case this.OBLIQ:
          var A = this.akm1 / (this.cosX1 * (1. + this.sinX1 * sinX + this.cosX1 * cosX * coslam));
          y = A * (this.cosX1 * sinX - this.sinX1 * cosX * coslam);
          x = A * cosX;
          break;
        case this.EQUIT:
          var A = 2. * this.akm1 / (1. + cosX * coslam);
          y = A * sinX;
          x = A * cosX;
          break;
        case this.S_POLE:
          lat = -lat;
          coslam = -coslam;
          sinphi = -sinphi;
        case this.N_POLE:
          x = this.akm1 * Proj4js.common.tsfnz(this.e, lat, sinphi);
          y = -x * coslam;
          break;
      }
      x = x * sinlam;
    }
    p.x = x * this.a + this.x0;
    p.y = y * this.a + this.y0;
    return p;
  },

  //* Stereographic inverse equations--mapping x,y to lat/long
  inverse: function inverse(p) {
    var x = (p.x - this.x0) / this.a; /* descale and de-offset */
    var y = (p.y - this.y0) / this.a;
    var lon, lat;

    var cosphi,
        sinphi,
        tp = 0.0,
        phi_l = 0.0,
        rho,
        halfe = 0.0,
        pi2 = 0.0;
    var i;

    if (this.sphere) {
      var c, rh, sinc, cosc;

      rh = Math.sqrt(x * x + y * y);
      c = 2. * Math.atan(rh / this.akm1);
      sinc = Math.sin(c);
      cosc = Math.cos(c);
      lon = 0.;
      switch (this.mode) {
        case this.EQUIT:
          if (Math.abs(rh) <= Proj4js.common.EPSLN) {
            lat = 0.;
          } else {
            lat = Math.asin(y * sinc / rh);
          }
          if (cosc != 0. || x != 0.) lon = Math.atan2(x * sinc, cosc * rh);
          break;
        case this.OBLIQ:
          if (Math.abs(rh) <= Proj4js.common.EPSLN) {
            lat = this.phi0;
          } else {
            lat = Math.asin(cosc * this.sinph0 + y * sinc * this.cosph0 / rh);
          }
          c = cosc - this.sinph0 * Math.sin(lat);
          if (c != 0. || x != 0.) {
            lon = Math.atan2(x * sinc * this.cosph0, c * rh);
          }
          break;
        case this.N_POLE:
          y = -y;
        case this.S_POLE:
          if (Math.abs(rh) <= Proj4js.common.EPSLN) {
            lat = this.phi0;
          } else {
            lat = Math.asin(this.mode == this.S_POLE ? -cosc : cosc);
          }
          lon = x == 0. && y == 0. ? 0. : Math.atan2(x, y);
          break;
      }
      p.x = Proj4js.common.adjust_lon(lon + this.long0);
      p.y = lat;
    } else {
      rho = Math.sqrt(x * x + y * y);
      switch (this.mode) {
        case this.OBLIQ:
        case this.EQUIT:
          tp = 2. * Math.atan2(rho * this.cosX1, this.akm1);
          cosphi = Math.cos(tp);
          sinphi = Math.sin(tp);
          if (rho == 0.0) {
            phi_l = Math.asin(cosphi * this.sinX1);
          } else {
            phi_l = Math.asin(cosphi * this.sinX1 + y * sinphi * this.cosX1 / rho);
          }

          tp = Math.tan(.5 * (Proj4js.common.HALF_PI + phi_l));
          x *= sinphi;
          y = rho * this.cosX1 * cosphi - y * this.sinX1 * sinphi;
          pi2 = Proj4js.common.HALF_PI;
          halfe = .5 * this.e;
          break;
        case this.N_POLE:
          y = -y;
        case this.S_POLE:
          tp = -rho / this.akm1;
          phi_l = Proj4js.common.HALF_PI - 2. * Math.atan(tp);
          pi2 = -Proj4js.common.HALF_PI;
          halfe = -.5 * this.e;
          break;
      }
      for (i = this.NITER; i--; phi_l = lat) {
        //check this
        sinphi = this.e * Math.sin(phi_l);
        lat = 2. * Math.atan(tp * Math.pow((1. + sinphi) / (1. - sinphi), halfe)) - pi2;
        if (Math.abs(phi_l - lat) < this.CONV) {
          if (this.mode == this.S_POLE) lat = -lat;
          lon = x == 0. && y == 0. ? 0. : Math.atan2(x, y);
          p.x = Proj4js.common.adjust_lon(lon + this.long0);
          p.y = lat;
          return p;
        }
      }
    }
  }
};
/* ======================================================================
    projCode/nzmg.js
   ====================================================================== */

/*******************************************************************************
NAME                            NEW ZEALAND MAP GRID

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the New Zealand Map Grid projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.


ALGORITHM REFERENCES

1.  Department of Land and Survey Technical Circular 1973/32
      http://www.linz.govt.nz/docs/miscellaneous/nz-map-definition.pdf

2.  OSG Technical Report 4.1
      http://www.linz.govt.nz/docs/miscellaneous/nzmg.pdf


IMPLEMENTATION NOTES

The two references use different symbols for the calculated values. This
implementation uses the variable names similar to the symbols in reference [1].

The alogrithm uses different units for delta latitude and delta longitude.
The delta latitude is assumed to be in units of seconds of arc x 10^-5.
The delta longitude is the usual radians. Look out for these conversions.

The algorithm is described using complex arithmetic. There were three
options:
   * find and use a Javascript library for complex arithmetic
   * write my own complex library
   * expand the complex arithmetic by hand to simple arithmetic

This implementation has expanded the complex multiplication operations
into parallel simple arithmetic operations for the real and imaginary parts.
The imaginary part is way over to the right of the display; this probably
violates every coding standard in the world, but, to me, it makes it much
more obvious what is going on.

The following complex operations are used:
   - addition
   - multiplication
   - division
   - complex number raised to integer power
   - summation

A summary of complex arithmetic operations:
   (from http://en.wikipedia.org/wiki/Complex_arithmetic)
   addition:       (a + bi) + (c + di) = (a + c) + (b + d)i
   subtraction:    (a + bi) - (c + di) = (a - c) + (b - d)i
   multiplication: (a + bi) x (c + di) = (ac - bd) + (bc + ad)i
   division:       (a + bi) / (c + di) = [(ac + bd)/(cc + dd)] + [(bc - ad)/(cc + dd)]i

The algorithm needs to calculate summations of simple and complex numbers. This is
implemented using a for-loop, pre-loading the summed value to zero.

The algorithm needs to calculate theta^2, theta^3, etc while doing a summation.
There are three possible implementations:
   - use Math.pow in the summation loop - except for complex numbers
   - precalculate the values before running the loop
   - calculate theta^n = theta^(n-1) * theta during the loop
This implementation uses the third option for both real and complex arithmetic.

For example
   psi_n = 1;
   sum = 0;
   for (n = 1; n <=6; n++) {
      psi_n1 = psi_n * psi;       // calculate psi^(n+1)
      psi_n = psi_n1;
      sum = sum + A[n] * psi_n;
   }


TEST VECTORS

NZMG E, N:         2487100.638      6751049.719     metres
NZGD49 long, lat:      172.739194       -34.444066  degrees

NZMG E, N:         2486533.395      6077263.661     metres
NZGD49 long, lat:      172.723106       -40.512409  degrees

NZMG E, N:         2216746.425      5388508.765     metres
NZGD49 long, lat:      169.172062       -46.651295  degrees

Note that these test vectors convert from NZMG metres to lat/long referenced
to NZGD49, not the more usual WGS84. The difference is about 70m N/S and about
10m E/W.

These test vectors are provided in reference [1]. Many more test
vectors are available in
   http://www.linz.govt.nz/docs/topography/topographicdata/placenamesdatabase/nznamesmar08.zip
which is a catalog of names on the 260-series maps.


EPSG CODES

NZMG     EPSG:27200
NZGD49   EPSG:4272

http://spatialreference.org/ defines these as
  Proj4js.defs["EPSG:4272"] = "+proj=longlat +ellps=intl +datum=nzgd49 +no_defs ";
  Proj4js.defs["EPSG:27200"] = "+proj=nzmg +lat_0=-41 +lon_0=173 +x_0=2510000 +y_0=6023150 +ellps=intl +datum=nzgd49 +units=m +no_defs ";


LICENSE
  Copyright: Stephen Irons 2008
  Released under terms of the LGPL as per: http://www.gnu.org/copyleft/lesser.html

*******************************************************************************/

/**
  Initialize New Zealand Map Grip projection
*/

Proj4js.Proj.nzmg = {

  /**
   * iterations: Number of iterations to refine inverse transform.
   *     0 -> km accuracy
   *     1 -> m accuracy -- suitable for most mapping applications
   *     2 -> mm accuracy
   */
  iterations: 1,

  init: function init() {
    this.A = new Array();
    this.A[1] = +0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = +0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = +0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = +0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = +0.00067;
    this.A[10] = -0.00034;

    this.B_re = new Array();this.B_im = new Array();
    this.B_re[1] = +0.7557853228;this.B_im[1] = 0.0;
    this.B_re[2] = +0.249204646;this.B_im[2] = +0.003371507;
    this.B_re[3] = -0.001541739;this.B_im[3] = +0.041058560;
    this.B_re[4] = -0.10162907;this.B_im[4] = +0.01727609;
    this.B_re[5] = -0.26623489;this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;this.B_im[6] = -1.1651967;

    this.C_re = new Array();this.C_im = new Array();
    this.C_re[1] = +1.3231270439;this.C_im[1] = 0.0;
    this.C_re[2] = -0.577245789;this.C_im[2] = -0.007809598;
    this.C_re[3] = +0.508307513;this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;this.C_im[4] = +0.18200602;
    this.C_re[5] = +1.01418179;this.C_im[5] = +1.64497696;
    this.C_re[6] = +1.9660549;this.C_im[6] = +2.5127645;

    this.D = new Array();
    this.D[1] = +1.5627014243;
    this.D[2] = +0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = +0.007317;
    this.D[7] = +0.01220;
    this.D[8] = +0.00394;
    this.D[9] = -0.0013;
  },

  /**
    New Zealand Map Grid Forward  - long/lat to x/y
    long/lat in radians
  */
  forward: function forward(p) {
    var lon = p.x;
    var lat = p.y;

    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;

    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / Proj4js.common.SEC_TO_RAD * 1E-5;var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0

    var d_psi = 0;
    for (var n = 1; n <= 10; n++) {
      d_phi_n = d_phi_n * d_phi;
      d_psi = d_psi + this.A[n] * d_phi_n;
    }

    // 2. Calculate theta
    var th_re = d_psi;var th_im = d_lambda;

    // 3. Calculate z
    var th_n_re = 1;var th_n_im = 0; // theta^0
    var th_n_re1;var th_n_im1;

    var z_re = 0;var z_im = 0;
    for (var n = 1; n <= 6; n++) {
      th_n_re1 = th_n_re * th_re - th_n_im * th_im;th_n_im1 = th_n_im * th_re + th_n_re * th_im;
      th_n_re = th_n_re1;th_n_im = th_n_im1;
      z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }

    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;

    return p;
  },

  /**
    New Zealand Map Grid Inverse  -  x/y to long/lat
  */
  inverse: function inverse(p) {

    var x = p.x;
    var y = p.y;

    var delta_x = x - this.x0;
    var delta_y = y - this.y0;

    // 1. Calculate z
    var z_re = delta_y / this.a;var z_im = delta_x / this.a;

    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;var z_n_im = 0; // z^0
    var z_n_re1;var z_n_im1;

    var th_re = 0;var th_im = 0;
    for (var n = 1; n <= 6; n++) {
      z_n_re1 = z_n_re * z_re - z_n_im * z_im;z_n_im1 = z_n_im * z_re + z_n_re * z_im;
      z_n_re = z_n_re1;z_n_im = z_n_im1;
      th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }

    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for (var i = 0; i < this.iterations; i++) {
      var th_n_re = th_re;var th_n_im = th_im;
      var th_n_re1;var th_n_im1;

      var num_re = z_re;var num_im = z_im;
      for (var n = 2; n <= 6; n++) {
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;th_n_im = th_n_im1;
        num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
      }

      th_n_re = 1;th_n_im = 0;
      var den_re = this.B_re[1];var den_im = this.B_im[1];
      for (var n = 2; n <= 6; n++) {
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;th_n_im = th_n_im1;
        den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
      }

      // Complex division
      var den2 = den_re * den_re + den_im * den_im;
      th_re = (num_re * den_re + num_im * den_im) / den2;th_im = (num_im * den_re - num_re * den_im) / den2;
    }

    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0

    var d_phi = 0;
    for (var n = 1; n <= 9; n++) {
      d_psi_n = d_psi_n * d_psi;
      d_phi = d_phi + this.D[n] * d_psi_n;
    }

    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * Proj4js.common.SEC_TO_RAD * 1E5;
    var lon = this.long0 + d_lambda;

    p.x = lon;
    p.y = lat;

    return p;
  }
};
/* ======================================================================
    projCode/mill.js
   ====================================================================== */

/*******************************************************************************
NAME                    MILLER CYLINDRICAL 

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Miller Cylindrical projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE            
----------              ----           
T. Mittan		March, 1993

This function was adapted from the Lambert Azimuthal Equal Area projection
code (FORTRAN) in the General Cartographic Transformation Package software
which is available from the U.S. Geological Survey National Mapping Division.
 
ALGORITHM REFERENCES

1.  "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.

2.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

3.  "Software Documentation for GCTP General Cartographic Transformation
    Package", U.S. Geological Survey National Mapping Division, May 1982.
*******************************************************************************/

Proj4js.Proj.mill = {

  /* Initialize the Miller Cylindrical projection
    -------------------------------------------*/
  init: function init() {
    //no-op
  },

  /* Miller Cylindrical forward equations--mapping lat,long to x,y
    ------------------------------------------------------------*/
  forward: function forward(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/
    var dlon = Proj4js.common.adjust_lon(lon - this.long0);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Proj4js.common.PI / 4.0 + lat / 2.5)) * 1.25;

    p.x = x;
    p.y = y;
    return p;
  }, //millFwd()

  /* Miller Cylindrical inverse equations--mapping x,y to lat/long
    ------------------------------------------------------------*/
  inverse: function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;

    var lon = Proj4js.common.adjust_lon(this.long0 + p.x / this.a);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Proj4js.common.PI / 4.0);

    p.x = lon;
    p.y = lat;
    return p;
  } //millInv()
};
/* ======================================================================
    projCode/gnom.js
   ====================================================================== */

/*****************************************************************************
NAME                             GNOMONIC

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Gnomonic Projection.
                Implementation based on the existing sterea and ortho
                implementations.

PROGRAMMER              DATE
----------              ----
Richard Marsden         November 2009

ALGORITHM REFERENCES

1.  Snyder, John P., "Flattening the Earth - Two Thousand Years of Map 
    Projections", University of Chicago Press 1993

2.  Wolfram Mathworld "Gnomonic Projection"
    http://mathworld.wolfram.com/GnomonicProjection.html
    Accessed: 12th November 2009
******************************************************************************/

Proj4js.Proj.gnom = {

  /* Initialize the Gnomonic projection
    -------------------------------------*/
  init: function init(def) {

    /* Place parameters in static storage for common use
      -------------------------------------------------*/
    this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
  },

  /* Gnomonic forward equations--mapping lat,long to x,y
    ---------------------------------------------------*/
  forward: function forward(p) {
    var sinphi, cosphi; /* sin and cos value				*/
    var dlon; /* delta longitude value			*/
    var coslon; /* cos of longitude				*/
    var ksp; /* scale factor					*/
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/
    dlon = Proj4js.common.adjust_lon(lon - this.long0);

    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);

    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1.0;
    if (g > 0 || Math.abs(g) <= Proj4js.common.EPSLN) {
      x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
      y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
      Proj4js.reportError("orthoFwdPointError");

      // Point is in the opposing hemisphere and is unprojectable
      // We still need to return a reasonable point, so we project 
      // to infinity, on a bearing 
      // equivalent to the northern hemisphere equivalent
      // This is a reasonable approximation for short shapes and lines that 
      // straddle the horizon.

      x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
      y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
  },

  inverse: function inverse(p) {
    var rh; /* Rho */
    var z; /* angle */
    var sinc, cosc;
    var c;
    var lon, lat;

    /* Inverse equations
      -----------------*/
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;

    p.x /= this.k0;
    p.y /= this.k0;

    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
      c = Math.atan2(rh, this.rc);
      sinc = Math.sin(c);
      cosc = Math.cos(c);

      lat = Proj4js.common.asinz(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
      lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
      lon = Proj4js.common.adjust_lon(this.long0 + lon);
    } else {
      lat = this.phic0;
      lon = 0.0;
    }

    p.x = lon;
    p.y = lat;
    return p;
  }
};

/* ======================================================================
    projCode/sinu.js
   ====================================================================== */

/*******************************************************************************
NAME                  		SINUSOIDAL

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Sinusoidal projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE            
----------              ----           
D. Steinwand, EROS      May, 1991     

This function was adapted from the Sinusoidal projection code (FORTRAN) in the 
General Cartographic Transformation Package software which is available from 
the U.S. Geological Survey National Mapping Division.
 
ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  "Software Documentation for GCTP General Cartographic Transformation
    Package", U.S. Geological Survey National Mapping Division, May 1982.
*******************************************************************************/

Proj4js.Proj.sinu = {

  /* Initialize the Sinusoidal projection
    ------------------------------------*/
  init: function init() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/

    if (!this.sphere) {
      this.en = Proj4js.common.pj_enfn(this.es);
    } else {
      this.n = 1.;
      this.m = 0.;
      this.es = 0;
      this.C_y = Math.sqrt((this.m + 1.) / this.n);
      this.C_x = this.C_y / (this.m + 1.);
    }
  },

  /* Sinusoidal forward equations--mapping lat,long to x,y
  -----------------------------------------------------*/
  forward: function forward(p) {
    var x, y, delta_lon;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    -----------------*/
    lon = Proj4js.common.adjust_lon(lon - this.long0);

    if (this.sphere) {
      if (!this.m) {
        lat = this.n != 1. ? Math.asin(this.n * Math.sin(lat)) : lat;
      } else {
        var k = this.n * Math.sin(lat);
        for (var i = Proj4js.common.MAX_ITER; i; --i) {
          var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
          lat -= V;
          if (Math.abs(V) < Proj4js.common.EPSLN) break;
        }
      }
      x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
      y = this.a * this.C_y * lat;
    } else {

      var s = Math.sin(lat);
      var c = Math.cos(lat);
      y = this.a * Proj4js.common.pj_mlfn(lat, s, c, this.en);
      x = this.a * lon * c / Math.sqrt(1. - this.es * s * s);
    }

    p.x = x;
    p.y = y;
    return p;
  },

  inverse: function inverse(p) {
    var lat, temp, lon;

    /* Inverse equations
      -----------------*/
    p.x -= this.x0;
    p.y -= this.y0;
    lat = p.y / this.a;

    if (this.sphere) {

      p.y /= this.C_y;
      lat = this.m ? Math.asin((this.m * p.y + Math.sin(p.y)) / this.n) : this.n != 1. ? Math.asin(Math.sin(p.y) / this.n) : p.y;
      lon = p.x / (this.C_x * (this.m + Math.cos(p.y)));
    } else {
      lat = Proj4js.common.pj_inv_mlfn(p.y / this.a, this.es, this.en);
      var s = Math.abs(lat);
      if (s < Proj4js.common.HALF_PI) {
        s = Math.sin(lat);
        temp = this.long0 + p.x * Math.sqrt(1. - this.es * s * s) / (this.a * Math.cos(lat));
        //temp = this.long0 + p.x / (this.a * Math.cos(lat));
        lon = Proj4js.common.adjust_lon(temp);
      } else if (s - Proj4js.common.EPSLN < Proj4js.common.HALF_PI) {
        lon = this.long0;
      }
    }

    p.x = lon;
    p.y = lat;
    return p;
  }
};

/* ======================================================================
    projCode/vandg.js
   ====================================================================== */

/*******************************************************************************
NAME                    VAN DER GRINTEN 

PURPOSE:	Transforms input Easting and Northing to longitude and
        latitude for the Van der Grinten projection.  The
        Easting and Northing must be in meters.  The longitude
        and latitude values will be returned in radians.

PROGRAMMER              DATE            
----------              ----           
T. Mittan		March, 1993

This function was adapted from the Van Der Grinten projection code
(FORTRAN) in the General Cartographic Transformation Package software
which is available from the U.S. Geological Survey National Mapping Division.
 
ALGORITHM REFERENCES

1.  "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.

2.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

3.  "Software Documentation for GCTP General Cartographic Transformation
    Package", U.S. Geological Survey National Mapping Division, May 1982.
*******************************************************************************/

Proj4js.Proj.vandg = {

  /* Initialize the Van Der Grinten projection
    ----------------------------------------*/
  init: function init() {
    this.R = 6370997.0; //Radius of earth
  },

  forward: function forward(p) {

    var lon = p.x;
    var lat = p.y;

    /* Forward equations
    -----------------*/
    var dlon = Proj4js.common.adjust_lon(lon - this.long0);
    var x, y;

    if (Math.abs(lat) <= Proj4js.common.EPSLN) {
      x = this.x0 + this.R * dlon;
      y = this.y0;
    }
    var theta = Proj4js.common.asinz(2.0 * Math.abs(lat / Proj4js.common.PI));
    if (Math.abs(dlon) <= Proj4js.common.EPSLN || Math.abs(Math.abs(lat) - Proj4js.common.HALF_PI) <= Proj4js.common.EPSLN) {
      x = this.x0;
      if (lat >= 0) {
        y = this.y0 + Proj4js.common.PI * this.R * Math.tan(.5 * theta);
      } else {
        y = this.y0 + Proj4js.common.PI * this.R * -Math.tan(.5 * theta);
      }
      //  return(OK);
    }
    var al = .5 * Math.abs(Proj4js.common.PI / dlon - dlon / Proj4js.common.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);

    var g = costh / (sinth + costh - 1.0);
    var gsq = g * g;
    var m = g * (2.0 / sinth - 1.0);
    var msq = m * m;
    var con = Proj4js.common.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) {
      con = -con;
    }
    x = this.x0 + con;
    con = Math.abs(con / (Proj4js.common.PI * this.R));
    if (lat >= 0) {
      y = this.y0 + Proj4js.common.PI * this.R * Math.sqrt(1.0 - con * con - 2.0 * al * con);
    } else {
      y = this.y0 - Proj4js.common.PI * this.R * Math.sqrt(1.0 - con * con - 2.0 * al * con);
    }
    p.x = x;
    p.y = y;
    return p;
  },

  /* Van Der Grinten inverse equations--mapping x,y to lat/long
    ---------------------------------------------------------*/
  inverse: function inverse(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var al, asq;
    var a1;
    var m1;
    var con;
    var th1;
    var d;

    /* inverse equations
    -----------------*/
    p.x -= this.x0;
    p.y -= this.y0;
    con = Proj4js.common.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1.0 + xys);
    c2 = c1 - 2.0 * yy * yy + xx * xx;
    c3 = -2.0 * c1 + 1.0 + 2.0 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2.0 * c2 * c2 * c2 / c3 / c3 / c3 - 9.0 * c1 * c2 / c3 / c3) / 27.0;
    a1 = (c1 - c2 * c2 / 3.0 / c3) / c3;
    m1 = 2.0 * Math.sqrt(-a1 / 3.0);
    con = 3.0 * d / a1 / m1;
    if (Math.abs(con) > 1.0) {
      if (con >= 0.0) {
        con = 1.0;
      } else {
        con = -1.0;
      }
    }
    th1 = Math.acos(con) / 3.0;
    if (p.y >= 0) {
      lat = (-m1 * Math.cos(th1 + Proj4js.common.PI / 3.0) - c2 / 3.0 / c3) * Proj4js.common.PI;
    } else {
      lat = -(-m1 * Math.cos(th1 + Proj4js.common.PI / 3.0) - c2 / 3.0 / c3) * Proj4js.common.PI;
    }

    if (Math.abs(xx) < Proj4js.common.EPSLN) {
      lon = this.long0;
    }
    lon = Proj4js.common.adjust_lon(this.long0 + Proj4js.common.PI * (xys - 1.0 + Math.sqrt(1.0 + 2.0 * (xx * xx - yy * yy) + xys * xys)) / 2.0 / xx);

    p.x = lon;
    p.y = lat;
    return p;
  }
};
/* ======================================================================
    projCode/cea.js
   ====================================================================== */

/*******************************************************************************
NAME                    LAMBERT CYLINDRICAL EQUAL AREA

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Lambert Cylindrical Equal Area projection.
                This class of projection includes the Behrmann and 
                Gall-Peters Projections.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE            
----------              ----
R. Marsden              August 2009
Winwaed Software Tech LLC, http://www.winwaed.com

This function was adapted from the Miller Cylindrical Projection in the Proj4JS
library.

Note: This implementation assumes a Spherical Earth. The (commented) code 
has been included for the ellipsoidal forward transform, but derivation of 
the ellispoidal inverse transform is beyond me. Note that most of the 
Proj4JS implementations do NOT currently support ellipsoidal figures. 
Therefore this is not seen as a problem - especially this lack of support 
is explicitly stated here.
 
ALGORITHM REFERENCES

1.  "Cartographic Projection Procedures for the UNIX Environment - 
     A User's Manual" by Gerald I. Evenden, USGS Open File Report 90-284
    and Release 4 Interim Reports (2003)

2.  Snyder, John P., "Flattening the Earth - Two Thousand Years of Map 
    Projections", Univ. Chicago Press, 1993
*******************************************************************************/

Proj4js.Proj.cea = {

  /* Initialize the Cylindrical Equal Area projection
    -------------------------------------------*/
  init: function init() {
    //no-op
  },

  /* Cylindrical Equal Area forward equations--mapping lat,long to x,y
    ------------------------------------------------------------*/
  forward: function forward(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/
    var dlon = Proj4js.common.adjust_lon(lon - this.long0);
    var x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
    var y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    /* Elliptical Forward Transform
       Not implemented due to a lack of a matchign inverse function
     {
       var Sin_Lat = Math.sin(lat);
       var Rn = this.a * (Math.sqrt(1.0e0 - this.es * Sin_Lat * Sin_Lat ));
       x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
       y = this.y0 + Rn * Math.sin(lat) / Math.cos(this.lat_ts);
     }
    */

    p.x = x;
    p.y = y;
    return p;
  }, //ceaFwd()

  /* Cylindrical Equal Area inverse equations--mapping x,y to lat/long
    ------------------------------------------------------------*/
  inverse: function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;

    var lon = Proj4js.common.adjust_lon(this.long0 + p.x / this.a / Math.cos(this.lat_ts));

    var lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));

    p.x = lon;
    p.y = lat;
    return p;
  } //ceaInv()
};
/* ======================================================================
    projCode/eqc.js
   ====================================================================== */

/* similar to equi.js FIXME proj4 uses eqc */
Proj4js.Proj.eqc = {
  init: function init() {

    if (!this.x0) this.x0 = 0;
    if (!this.y0) this.y0 = 0;
    if (!this.lat0) this.lat0 = 0;
    if (!this.long0) this.long0 = 0;
    if (!this.lat_ts) this.lat_ts = 0;
    if (!this.title) this.title = "Equidistant Cylindrical (Plate Carre)";

    this.rc = Math.cos(this.lat_ts);
  },

  // forward equations--mapping lat,long to x,y
  // -----------------------------------------------------------------
  forward: function forward(p) {

    var lon = p.x;
    var lat = p.y;

    var dlon = Proj4js.common.adjust_lon(lon - this.long0);
    var dlat = Proj4js.common.adjust_lat(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
  },

  // inverse equations--mapping x,y to lat/long
  // -----------------------------------------------------------------
  inverse: function inverse(p) {

    var x = p.x;
    var y = p.y;

    p.x = Proj4js.common.adjust_lon(this.long0 + (x - this.x0) / (this.a * this.rc));
    p.y = Proj4js.common.adjust_lat(this.lat0 + (y - this.y0) / this.a);
    return p;
  }

};
/* ======================================================================
    projCode/cass.js
   ====================================================================== */

/*******************************************************************************
NAME                            CASSINI

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Cassini projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.
    Ported from PROJ.4.


ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
*******************************************************************************/

//Proj4js.defs["EPSG:28191"] = "+proj=cass +lat_0=31.73409694444445 +lon_0=35.21208055555556 +x_0=170251.555 +y_0=126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.722,94.7824,340.894,-8.001,-4.42,-11.821,1 +units=m +no_defs";

// Initialize the Cassini projection
// -----------------------------------------------------------------

Proj4js.Proj.cass = {
  init: function init() {
    if (!this.sphere) {
      this.en = Proj4js.common.pj_enfn(this.es);
      this.m0 = Proj4js.common.pj_mlfn(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
  },

  C1: .16666666666666666666,
  C2: .00833333333333333333,
  C3: .04166666666666666666,
  C4: .33333333333333333333,
  C5: .06666666666666666666,

  /* Cassini forward equations--mapping lat,long to x,y
    -----------------------------------------------------------------------*/
  forward: function forward(p) {

    /* Forward equations
      -----------------*/
    var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = Proj4js.common.adjust_lon(lam - this.long0);

    if (this.sphere) {
      x = Math.asin(Math.cos(phi) * Math.sin(lam));
      y = Math.atan2(Math.tan(phi), Math.cos(lam)) - this.phi0;
    } else {
      //ellipsoid
      this.n = Math.sin(phi);
      this.c = Math.cos(phi);
      y = Proj4js.common.pj_mlfn(phi, this.n, this.c, this.en);
      this.n = 1. / Math.sqrt(1. - this.es * this.n * this.n);
      this.tn = Math.tan(phi);
      this.t = this.tn * this.tn;
      this.a1 = lam * this.c;
      this.c *= this.es * this.c / (1 - this.es);
      this.a2 = this.a1 * this.a1;
      x = this.n * this.a1 * (1. - this.a2 * this.t * (this.C1 - (8. - this.t + 8. * this.c) * this.a2 * this.C2));
      y -= this.m0 - this.n * this.tn * this.a2 * (.5 + (5. - this.t + 6. * this.c) * this.a2 * this.C3);
    }

    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
  }, //cassFwd()

  /* Inverse equations
    -----------------*/
  inverse: function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;

    if (this.sphere) {
      this.dd = y + this.lat0;
      phi = Math.asin(Math.sin(this.dd) * Math.cos(x));
      lam = Math.atan2(Math.tan(x), Math.cos(this.dd));
    } else {
      /* ellipsoid */
      var ph1 = Proj4js.common.pj_inv_mlfn(this.m0 + y, this.es, this.en);
      this.tn = Math.tan(ph1);
      this.t = this.tn * this.tn;
      this.n = Math.sin(ph1);
      this.r = 1. / (1. - this.es * this.n * this.n);
      this.n = Math.sqrt(this.r);
      this.r *= (1. - this.es) * this.n;
      this.dd = x / this.n;
      this.d2 = this.dd * this.dd;
      phi = ph1 - this.n * this.tn / this.r * this.d2 * (.5 - (1. + 3. * this.t) * this.d2 * this.C3);
      lam = this.dd * (1. + this.t * this.d2 * (-this.C4 + (1. + 3. * this.t) * this.d2 * this.C5)) / Math.cos(ph1);
    }
    p.x = Proj4js.common.adjust_lon(this.long0 + lam);
    p.y = phi;
    return p;
  } //cassInv()

  /* ======================================================================
      projCode/gauss.js
     ====================================================================== */

};Proj4js.Proj.gauss = {

  init: function init() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1.0 - this.es) / (1.0 - this.es * sphi * sphi);
    this.C = Math.sqrt(1.0 + this.es * cphi * cphi / (1.0 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + Proj4js.common.FORTPI) / (Math.pow(Math.tan(0.5 * this.lat0 + Proj4js.common.FORTPI), this.C) * Proj4js.common.srat(this.e * sphi, this.ratexp));
  },

  forward: function forward(p) {
    var lon = p.x;
    var lat = p.y;

    p.y = 2.0 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + Proj4js.common.FORTPI), this.C) * Proj4js.common.srat(this.e * Math.sin(lat), this.ratexp)) - Proj4js.common.HALF_PI;
    p.x = this.C * lon;
    return p;
  },

  inverse: function inverse(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + Proj4js.common.FORTPI) / this.K, 1. / this.C);
    for (var i = Proj4js.common.MAX_ITER; i > 0; --i) {
      lat = 2.0 * Math.atan(num * Proj4js.common.srat(this.e * Math.sin(p.y), -0.5 * this.e)) - Proj4js.common.HALF_PI;
      if (Math.abs(lat - p.y) < DEL_TOL) break;
      p.y = lat;
    }
    /* convergence failed */
    if (!i) {
      Proj4js.reportError("gauss:inverse:convergence failed");
      return null;
    }
    p.x = lon;
    p.y = lat;
    return p;
  }
};

/* ======================================================================
    projCode/omerc.js
   ====================================================================== */

/*******************************************************************************
NAME                       OBLIQUE MERCATOR (HOTINE) 

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Oblique Mercator projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE
----------              ----
T. Mittan		Mar, 1993

ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.
*******************************************************************************/

Proj4js.Proj.omerc = {

  /* Initialize the Oblique Mercator  projection
    ------------------------------------------*/
  init: function init() {
    if (!this.mode) this.mode = 0;
    if (!this.lon1) {
      this.lon1 = 0;this.mode = 1;
    }
    if (!this.lon2) this.lon2 = 0;
    if (!this.lat2) this.lat2 = 0;

    /* Place parameters in static storage for common use
      -------------------------------------------------*/
    var temp = this.b / this.a;
    var es = 1.0 - Math.pow(temp, 2);
    var e = Math.sqrt(es);

    this.sin_p20 = Math.sin(this.lat0);
    this.cos_p20 = Math.cos(this.lat0);

    this.con = 1.0 - this.es * this.sin_p20 * this.sin_p20;
    this.com = Math.sqrt(1.0 - es);
    this.bl = Math.sqrt(1.0 + this.es * Math.pow(this.cos_p20, 4.0) / (1.0 - es));
    this.al = this.a * this.bl * this.k0 * this.com / this.con;
    if (Math.abs(this.lat0) < Proj4js.common.EPSLN) {
      this.ts = 1.0;
      this.d = 1.0;
      this.el = 1.0;
    } else {
      this.ts = Proj4js.common.tsfnz(this.e, this.lat0, this.sin_p20);
      this.con = Math.sqrt(this.con);
      this.d = this.bl * this.com / (this.cos_p20 * this.con);
      if (this.d * this.d - 1.0 > 0.0) {
        if (this.lat0 >= 0.0) {
          this.f = this.d + Math.sqrt(this.d * this.d - 1.0);
        } else {
          this.f = this.d - Math.sqrt(this.d * this.d - 1.0);
        }
      } else {
        this.f = this.d;
      }
      this.el = this.f * Math.pow(this.ts, this.bl);
    }

    //this.longc=52.60353916666667;

    if (this.mode != 0) {
      this.g = .5 * (this.f - 1.0 / this.f);
      this.gama = Proj4js.common.asinz(Math.sin(this.alpha) / this.d);
      this.longc = this.longc - Proj4js.common.asinz(this.g * Math.tan(this.gama)) / this.bl;

      /* Report parameters common to format B
      -------------------------------------*/
      //genrpt(azimuth * R2D,"Azimuth of Central Line:    ");
      //cenlon(lon_origin);
      // cenlat(lat_origin);

      this.con = Math.abs(this.lat0);
      if (this.con > Proj4js.common.EPSLN && Math.abs(this.con - Proj4js.common.HALF_PI) > Proj4js.common.EPSLN) {
        this.singam = Math.sin(this.gama);
        this.cosgam = Math.cos(this.gama);

        this.sinaz = Math.sin(this.alpha);
        this.cosaz = Math.cos(this.alpha);

        if (this.lat0 >= 0) {
          this.u = this.al / this.bl * Math.atan(Math.sqrt(this.d * this.d - 1.0) / this.cosaz);
        } else {
          this.u = -(this.al / this.bl) * Math.atan(Math.sqrt(this.d * this.d - 1.0) / this.cosaz);
        }
      } else {
        Proj4js.reportError("omerc:Init:DataError");
      }
    } else {
      this.sinphi = Math.sin(this.at1);
      this.ts1 = Proj4js.common.tsfnz(this.e, this.lat1, this.sinphi);
      this.sinphi = Math.sin(this.lat2);
      this.ts2 = Proj4js.common.tsfnz(this.e, this.lat2, this.sinphi);
      this.h = Math.pow(this.ts1, this.bl);
      this.l = Math.pow(this.ts2, this.bl);
      this.f = this.el / this.h;
      this.g = .5 * (this.f - 1.0 / this.f);
      this.j = (this.el * this.el - this.l * this.h) / (this.el * this.el + this.l * this.h);
      this.p = (this.l - this.h) / (this.l + this.h);
      this.dlon = this.lon1 - this.lon2;
      if (this.dlon < -Proj4js.common.PI) this.lon2 = this.lon2 - 2.0 * Proj4js.common.PI;
      if (this.dlon > Proj4js.common.PI) this.lon2 = this.lon2 + 2.0 * Proj4js.common.PI;
      this.dlon = this.lon1 - this.lon2;
      this.longc = .5 * (this.lon1 + this.lon2) - Math.atan(this.j * Math.tan(.5 * this.bl * this.dlon) / this.p) / this.bl;
      this.dlon = Proj4js.common.adjust_lon(this.lon1 - this.longc);
      this.gama = Math.atan(Math.sin(this.bl * this.dlon) / this.g);
      this.alpha = Proj4js.common.asinz(this.d * Math.sin(this.gama));

      /* Report parameters common to format A
      -------------------------------------*/

      if (Math.abs(this.lat1 - this.lat2) <= Proj4js.common.EPSLN) {
        Proj4js.reportError("omercInitDataError");
        //return(202);
      } else {
        this.con = Math.abs(this.lat1);
      }
      if (this.con <= Proj4js.common.EPSLN || Math.abs(this.con - Proj4js.common.HALF_PI) <= Proj4js.common.EPSLN) {
        Proj4js.reportError("omercInitDataError");
        //return(202);
      } else {
        if (Math.abs(Math.abs(this.lat0) - Proj4js.common.HALF_PI) <= Proj4js.common.EPSLN) {
          Proj4js.reportError("omercInitDataError");
          //return(202);
        }
      }

      this.singam = Math.sin(this.gam);
      this.cosgam = Math.cos(this.gam);

      this.sinaz = Math.sin(this.alpha);
      this.cosaz = Math.cos(this.alpha);

      if (this.lat0 >= 0) {
        this.u = this.al / this.bl * Math.atan(Math.sqrt(this.d * this.d - 1.0) / this.cosaz);
      } else {
        this.u = -(this.al / this.bl) * Math.atan(Math.sqrt(this.d * this.d - 1.0) / this.cosaz);
      }
    }
  },

  /* Oblique Mercator forward equations--mapping lat,long to x,y
    ----------------------------------------------------------*/
  forward: function forward(p) {
    var theta; /* angle					*/
    var sin_phi, cos_phi; /* sin and cos value				*/
    var b; /* temporary values				*/
    var c, t, tq; /* temporary values				*/
    var con, n, ml; /* cone constant, small m			*/
    var q, us, vl;
    var ul, vs;
    var s;
    var dlon;
    var ts1;

    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/
    sin_phi = Math.sin(lat);
    dlon = Proj4js.common.adjust_lon(lon - this.longc);
    vl = Math.sin(this.bl * dlon);
    if (Math.abs(Math.abs(lat) - Proj4js.common.HALF_PI) > Proj4js.common.EPSLN) {
      ts1 = Proj4js.common.tsfnz(this.e, lat, sin_phi);
      q = this.el / Math.pow(ts1, this.bl);
      s = .5 * (q - 1.0 / q);
      t = .5 * (q + 1.0 / q);
      ul = (s * this.singam - vl * this.cosgam) / t;
      con = Math.cos(this.bl * dlon);
      if (Math.abs(con) < .0000001) {
        us = this.al * this.bl * dlon;
      } else {
        us = this.al * Math.atan((s * this.cosgam + vl * this.singam) / con) / this.bl;
        if (con < 0) us = us + Proj4js.common.PI * this.al / this.bl;
      }
    } else {
      if (lat >= 0) {
        ul = this.singam;
      } else {
        ul = -this.singam;
      }
      us = this.al * lat / this.bl;
    }
    if (Math.abs(Math.abs(ul) - 1.0) <= Proj4js.common.EPSLN) {
      //alert("Point projects into infinity","omer-for");
      Proj4js.reportError("omercFwdInfinity");
      //return(205);
    }
    vs = .5 * this.al * Math.log((1.0 - ul) / (1.0 + ul)) / this.bl;
    us = us - this.u;
    var x = this.x0 + vs * this.cosaz + us * this.sinaz;
    var y = this.y0 + us * this.cosaz - vs * this.sinaz;

    p.x = x;
    p.y = y;
    return p;
  },

  inverse: function inverse(p) {
    var delta_lon; /* Delta longitude (Given longitude - center 	*/
    var theta; /* angle					*/
    var delta_theta; /* adjusted longitude				*/
    var sin_phi, cos_phi; /* sin and cos value				*/
    var b; /* temporary values				*/
    var c, t, tq; /* temporary values				*/
    var con, n, ml; /* cone constant, small m			*/
    var vs, us, q, s, ts1;
    var vl, ul, bs;
    var lon, lat;
    var flag;

    /* Inverse equations
      -----------------*/
    p.x -= this.x0;
    p.y -= this.y0;
    flag = 0;
    vs = p.x * this.cosaz - p.y * this.sinaz;
    us = p.y * this.cosaz + p.x * this.sinaz;
    us = us + this.u;
    q = Math.exp(-this.bl * vs / this.al);
    s = .5 * (q - 1.0 / q);
    t = .5 * (q + 1.0 / q);
    vl = Math.sin(this.bl * us / this.al);
    ul = (vl * this.cosgam + s * this.singam) / t;
    if (Math.abs(Math.abs(ul) - 1.0) <= Proj4js.common.EPSLN) {
      lon = this.longc;
      if (ul >= 0.0) {
        lat = Proj4js.common.HALF_PI;
      } else {
        lat = -Proj4js.common.HALF_PI;
      }
    } else {
      con = 1.0 / this.bl;
      ts1 = Math.pow(this.el / Math.sqrt((1.0 + ul) / (1.0 - ul)), con);
      lat = Proj4js.common.phi2z(this.e, ts1);
      //if (flag != 0)
      //return(flag);
      //~ con = Math.cos(this.bl * us /al);
      theta = this.longc - Math.atan2(s * this.cosgam - vl * this.singam, con) / this.bl;
      lon = Proj4js.common.adjust_lon(theta);
    }
    p.x = lon;
    p.y = lat;
    return p;
  }
};
/* ======================================================================
    projCode/lcc.js
   ====================================================================== */

/*******************************************************************************
NAME                            LAMBERT CONFORMAL CONIC

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Lambert Conformal Conic projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.


ALGORITHM REFERENCES

1.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

2.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
*******************************************************************************/

//<2104> +proj=lcc +lat_1=10.16666666666667 +lat_0=10.16666666666667 +lon_0=-71.60561777777777 +k_0=1 +x0=-17044 +x0=-23139.97 +ellps=intl +units=m +no_defs  no_defs

// Initialize the Lambert Conformal conic projection
// -----------------------------------------------------------------

//Proj4js.Proj.lcc = Class.create();
Proj4js.Proj.lcc = {
  init: function init() {

    // array of:  r_maj,r_min,lat1,lat2,c_lon,c_lat,false_east,false_north
    //double c_lat;                   /* center latitude                      */
    //double c_lon;                   /* center longitude                     */
    //double lat1;                    /* first standard parallel              */
    //double lat2;                    /* second standard parallel             */
    //double r_maj;                   /* major axis                           */
    //double r_min;                   /* minor axis                           */
    //double false_east;              /* x offset in meters                   */
    //double false_north;             /* y offset in meters                   */

    if (!this.lat2) {
      this.lat2 = this.lat0;
    } //if lat2 is not defined
    if (!this.k0) this.k0 = 1.0;

    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < Proj4js.common.EPSLN) {
      Proj4js.reportError("lcc:init: Equal Latitudes");
      return;
    }

    var temp = this.b / this.a;
    this.e = Math.sqrt(1.0 - temp * temp);

    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = Proj4js.common.msfnz(this.e, sin1, cos1);
    var ts1 = Proj4js.common.tsfnz(this.e, this.lat1, sin1);

    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = Proj4js.common.msfnz(this.e, sin2, cos2);
    var ts2 = Proj4js.common.tsfnz(this.e, this.lat2, sin2);

    var ts0 = Proj4js.common.tsfnz(this.e, this.lat0, Math.sin(this.lat0));

    if (Math.abs(this.lat1 - this.lat2) > Proj4js.common.EPSLN) {
      this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    } else {
      this.ns = sin1;
    }
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = "Lambert Conformal Conic";
  },

  // Lambert Conformal conic forward equations--mapping lat,long to x,y
  // -----------------------------------------------------------------
  forward: function forward(p) {

    var lon = p.x;
    var lat = p.y;

    // convert to radians
    if (lat <= 90.0 && lat >= -90.0 && lon <= 180.0 && lon >= -180.0) {
      //lon = lon * Proj4js.common.D2R;
      //lat = lat * Proj4js.common.D2R;
    } else {
      Proj4js.reportError("lcc:forward: llInputOutOfRange: " + lon + " : " + lat);
      return null;
    }

    var con = Math.abs(Math.abs(lat) - Proj4js.common.HALF_PI);
    var ts, rh1;
    if (con > Proj4js.common.EPSLN) {
      ts = Proj4js.common.tsfnz(this.e, lat, Math.sin(lat));
      rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
      con = lat * this.ns;
      if (con <= 0) {
        Proj4js.reportError("lcc:forward: No Projection");
        return null;
      }
      rh1 = 0;
    }
    var theta = this.ns * Proj4js.common.adjust_lon(lon - this.long0);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;

    return p;
  },

  // Lambert Conformal Conic inverse equations--mapping x,y to lat/long
  // -----------------------------------------------------------------
  inverse: function inverse(p) {

    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
      rh1 = Math.sqrt(x * x + y * y);
      con = 1.0;
    } else {
      rh1 = -Math.sqrt(x * x + y * y);
      con = -1.0;
    }
    var theta = 0.0;
    if (rh1 != 0) {
      theta = Math.atan2(con * x, con * y);
    }
    if (rh1 != 0 || this.ns > 0.0) {
      con = 1.0 / this.ns;
      ts = Math.pow(rh1 / (this.a * this.f0), con);
      lat = Proj4js.common.phi2z(this.e, ts);
      if (lat == -9999) return null;
    } else {
      lat = -Proj4js.common.HALF_PI;
    }
    lon = Proj4js.common.adjust_lon(theta / this.ns + this.long0);

    p.x = lon;
    p.y = lat;
    return p;
  }
};

/* ======================================================================
    projCode/laea.js
   ====================================================================== */

/*******************************************************************************
NAME                  LAMBERT AZIMUTHAL EQUAL-AREA
 
PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the Lambert Azimuthal Equal-Area projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE            
----------              ----           
D. Steinwand, EROS      March, 1991   

This function was adapted from the Lambert Azimuthal Equal Area projection
code (FORTRAN) in the General Cartographic Transformation Package software
which is available from the U.S. Geological Survey National Mapping Division.
 
ALGORITHM REFERENCES

1.  "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.

2.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.

3.  "Software Documentation for GCTP General Cartographic Transformation
    Package", U.S. Geological Survey National Mapping Division, May 1982.
*******************************************************************************/

Proj4js.Proj.laea = {
  S_POLE: 1,
  N_POLE: 2,
  EQUIT: 3,
  OBLIQ: 4,

  /* Initialize the Lambert Azimuthal Equal Area projection
    ------------------------------------------------------*/
  init: function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - Proj4js.common.HALF_PI) < Proj4js.common.EPSLN) {
      this.mode = this.lat0 < 0. ? this.S_POLE : this.N_POLE;
    } else if (Math.abs(t) < Proj4js.common.EPSLN) {
      this.mode = this.EQUIT;
    } else {
      this.mode = this.OBLIQ;
    }
    if (this.es > 0) {
      var sinphi;

      this.qp = Proj4js.common.qsfnz(this.e, 1.0);
      this.mmf = .5 / (1. - this.es);
      this.apa = this.authset(this.es);
      switch (this.mode) {
        case this.N_POLE:
        case this.S_POLE:
          this.dd = 1.;
          break;
        case this.EQUIT:
          this.rq = Math.sqrt(.5 * this.qp);
          this.dd = 1. / this.rq;
          this.xmf = 1.;
          this.ymf = .5 * this.qp;
          break;
        case this.OBLIQ:
          this.rq = Math.sqrt(.5 * this.qp);
          sinphi = Math.sin(this.lat0);
          this.sinb1 = Proj4js.common.qsfnz(this.e, sinphi) / this.qp;
          this.cosb1 = Math.sqrt(1. - this.sinb1 * this.sinb1);
          this.dd = Math.cos(this.lat0) / (Math.sqrt(1. - this.es * sinphi * sinphi) * this.rq * this.cosb1);
          this.ymf = (this.xmf = this.rq) / this.dd;
          this.xmf *= this.dd;
          break;
      }
    } else {
      if (this.mode == this.OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
      }
    }
  },

  /* Lambert Azimuthal Equal Area forward equations--mapping lat,long to x,y
    -----------------------------------------------------------------------*/
  forward: function forward(p) {

    /* Forward equations
      -----------------*/
    var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = Proj4js.common.adjust_lon(lam - this.long0);

    if (this.sphere) {
      var coslam, cosphi, sinphi;

      sinphi = Math.sin(phi);
      cosphi = Math.cos(phi);
      coslam = Math.cos(lam);
      switch (this.mode) {
        case this.OBLIQ:
        case this.EQUIT:
          y = this.mode == this.EQUIT ? 1. + cosphi * coslam : 1. + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
          if (y <= Proj4js.common.EPSLN) {
            Proj4js.reportError("laea:fwd:y less than eps");
            return null;
          }
          y = Math.sqrt(2. / y);
          x = y * cosphi * Math.sin(lam);
          y *= this.mode == this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
          break;
        case this.N_POLE:
          coslam = -coslam;
        case this.S_POLE:
          if (Math.abs(phi + this.phi0) < Proj4js.common.EPSLN) {
            Proj4js.reportError("laea:fwd:phi < eps");
            return null;
          }
          y = Proj4js.common.FORTPI - phi * .5;
          y = 2. * (this.mode == this.S_POLE ? Math.cos(y) : Math.sin(y));
          x = y * Math.sin(lam);
          y *= coslam;
          break;
      }
    } else {
      var coslam,
          sinlam,
          sinphi,
          q,
          sinb = 0.0,
          cosb = 0.0,
          b = 0.0;

      coslam = Math.cos(lam);
      sinlam = Math.sin(lam);
      sinphi = Math.sin(phi);
      q = Proj4js.common.qsfnz(this.e, sinphi);
      if (this.mode == this.OBLIQ || this.mode == this.EQUIT) {
        sinb = q / this.qp;
        cosb = Math.sqrt(1. - sinb * sinb);
      }
      switch (this.mode) {
        case this.OBLIQ:
          b = 1. + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
          break;
        case this.EQUIT:
          b = 1. + cosb * coslam;
          break;
        case this.N_POLE:
          b = Proj4js.common.HALF_PI + phi;
          q = this.qp - q;
          break;
        case this.S_POLE:
          b = phi - Proj4js.common.HALF_PI;
          q = this.qp + q;
          break;
      }
      if (Math.abs(b) < Proj4js.common.EPSLN) {
        Proj4js.reportError("laea:fwd:b < eps");
        return null;
      }
      switch (this.mode) {
        case this.OBLIQ:
        case this.EQUIT:
          b = Math.sqrt(2. / b);
          if (this.mode == this.OBLIQ) {
            y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
          } else {
            y = (b = Math.sqrt(2. / (1. + cosb * coslam))) * sinb * this.ymf;
          }
          x = this.xmf * b * cosb * sinlam;
          break;
        case this.N_POLE:
        case this.S_POLE:
          if (q >= 0.) {
            x = (b = Math.sqrt(q)) * sinlam;
            y = coslam * (this.mode == this.S_POLE ? b : -b);
          } else {
            x = y = 0.;
          }
          break;
      }
    }

    //v 1.0
    /*
    var sin_lat=Math.sin(lat);
    var cos_lat=Math.cos(lat);
          var sin_delta_lon=Math.sin(delta_lon);
    var cos_delta_lon=Math.cos(delta_lon);
          var g =this.sin_lat_o * sin_lat +this.cos_lat_o * cos_lat * cos_delta_lon;
    if (g == -1.0) {
      Proj4js.reportError("laea:fwd:Point projects to a circle of radius "+ 2.0 * R);
      return null;
    }
    var ksp = this.a * Math.sqrt(2.0 / (1.0 + g));
    var x = ksp * cos_lat * sin_delta_lon + this.x0;
    var y = ksp * (this.cos_lat_o * sin_lat - this.sin_lat_o * cos_lat * cos_delta_lon) + this.y0;
    */
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
  }, //lamazFwd()

  /* Inverse equations
    -----------------*/
  inverse: function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi;

    if (this.sphere) {
      var cosz = 0.0,
          rh,
          sinz = 0.0;

      rh = Math.sqrt(x * x + y * y);
      phi = rh * .5;
      if (phi > 1.) {
        Proj4js.reportError("laea:Inv:DataError");
        return null;
      }
      phi = 2. * Math.asin(phi);
      if (this.mode == this.OBLIQ || this.mode == this.EQUIT) {
        sinz = Math.sin(phi);
        cosz = Math.cos(phi);
      }
      switch (this.mode) {
        case this.EQUIT:
          phi = Math.abs(rh) <= Proj4js.common.EPSLN ? 0. : Math.asin(y * sinz / rh);
          x *= sinz;
          y = cosz * rh;
          break;
        case this.OBLIQ:
          phi = Math.abs(rh) <= Proj4js.common.EPSLN ? this.phi0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
          x *= sinz * this.cosph0;
          y = (cosz - Math.sin(phi) * this.sinph0) * rh;
          break;
        case this.N_POLE:
          y = -y;
          phi = Proj4js.common.HALF_PI - phi;
          break;
        case this.S_POLE:
          phi -= Proj4js.common.HALF_PI;
          break;
      }
      lam = y == 0. && (this.mode == this.EQUIT || this.mode == this.OBLIQ) ? 0. : Math.atan2(x, y);
    } else {
      var cCe,
          sCe,
          q,
          rho,
          ab = 0.0;

      switch (this.mode) {
        case this.EQUIT:
        case this.OBLIQ:
          x /= this.dd;
          y *= this.dd;
          rho = Math.sqrt(x * x + y * y);
          if (rho < Proj4js.common.EPSLN) {
            p.x = 0.;
            p.y = this.phi0;
            return p;
          }
          sCe = 2. * Math.asin(.5 * rho / this.rq);
          cCe = Math.cos(sCe);
          x *= sCe = Math.sin(sCe);
          if (this.mode == this.OBLIQ) {
            ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
            q = this.qp * ab;
            y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
          } else {
            ab = y * sCe / rho;
            q = this.qp * ab;
            y = rho * cCe;
          }
          break;
        case this.N_POLE:
          y = -y;
        case this.S_POLE:
          q = x * x + y * y;
          if (!q) {
            p.x = 0.;
            p.y = this.phi0;
            return p;
          }
          /*
          q = this.qp - q;
          */
          ab = 1. - q / this.qp;
          if (this.mode == this.S_POLE) {
            ab = -ab;
          }
          break;
      }
      lam = Math.atan2(x, y);
      phi = this.authlat(Math.asin(ab), this.apa);
    }

    /*
    var Rh = Math.Math.sqrt(p.x *p.x +p.y * p.y);
    var temp = Rh / (2.0 * this.a);
          if (temp > 1) {
      Proj4js.reportError("laea:Inv:DataError");
      return null;
    }
          var z = 2.0 * Proj4js.common.asinz(temp);
    var sin_z=Math.sin(z);
    var cos_z=Math.cos(z);
          var lon =this.long0;
    if (Math.abs(Rh) > Proj4js.common.EPSLN) {
       var lat = Proj4js.common.asinz(this.sin_lat_o * cos_z +this. cos_lat_o * sin_z *p.y / Rh);
       var temp =Math.abs(this.lat0) - Proj4js.common.HALF_PI;
       if (Math.abs(temp) > Proj4js.common.EPSLN) {
          temp = cos_z -this.sin_lat_o * Math.sin(lat);
          if(temp!=0.0) lon=Proj4js.common.adjust_lon(this.long0+Math.atan2(p.x*sin_z*this.cos_lat_o,temp*Rh));
       } else if (this.lat0 < 0.0) {
          lon = Proj4js.common.adjust_lon(this.long0 - Math.atan2(-p.x,p.y));
       } else {
          lon = Proj4js.common.adjust_lon(this.long0 + Math.atan2(p.x, -p.y));
       }
    } else {
      lat = this.lat0;
    }
    */
    //return(OK);
    p.x = Proj4js.common.adjust_lon(this.long0 + lam);
    p.y = phi;
    return p;
  }, //lamazInv()

  /* determine latitude from authalic latitude */
  P00: .33333333333333333333,
  P01: .17222222222222222222,
  P02: .10257936507936507936,
  P10: .06388888888888888888,
  P11: .06640211640211640211,
  P20: .01641501294219154443,

  authset: function authset(es) {
    var t;
    var APA = new Array();
    APA[0] = es * this.P00;
    t = es * es;
    APA[0] += t * this.P01;
    APA[1] = t * this.P10;
    t *= es;
    APA[0] += t * this.P02;
    APA[1] += t * this.P11;
    APA[2] = t * this.P20;
    return APA;
  },

  authlat: function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
  }

};

/* ======================================================================
    projCode/aeqd.js
   ====================================================================== */

Proj4js.Proj.aeqd = {

  init: function init() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
  },

  forward: function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var ksp;

    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = Proj4js.common.adjust_lon(lon - this.long0);
    var coslon = Math.cos(dlon);
    var g = this.sin_p12 * sinphi + this.cos_p12 * cosphi * coslon;
    if (Math.abs(Math.abs(g) - 1.0) < Proj4js.common.EPSLN) {
      ksp = 1.0;
      if (g < 0.0) {
        Proj4js.reportError("aeqd:Fwd:PointError");
        return;
      }
    } else {
      var z = Math.acos(g);
      ksp = z / Math.sin(z);
    }
    p.x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon);
    p.y = this.y0 + this.a * ksp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * coslon);
    return p;
  },

  inverse: function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;

    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (rh > 2.0 * Proj4js.common.HALF_PI * this.a) {
      Proj4js.reportError("aeqdInvDataError");
      return;
    }
    var z = rh / this.a;

    var sinz = Math.sin(z);
    var cosz = Math.cos(z);

    var lon = this.long0;
    var lat;
    if (Math.abs(rh) <= Proj4js.common.EPSLN) {
      lat = this.lat0;
    } else {
      lat = Proj4js.common.asinz(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
      var con = Math.abs(this.lat0) - Proj4js.common.HALF_PI;
      if (Math.abs(con) <= Proj4js.common.EPSLN) {
        if (this.lat0 >= 0.0) {
          lon = Proj4js.common.adjust_lon(this.long0 + Math.atan2(p.x, -p.y));
        } else {
          lon = Proj4js.common.adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
        }
      } else {
        con = cosz - this.sin_p12 * Math.sin(lat);
        if (Math.abs(con) < Proj4js.common.EPSLN && Math.abs(p.x) < Proj4js.common.EPSLN) {
          //no-op, just keep the lon value as is
        } else {
          var temp = Math.atan2(p.x * sinz * this.cos_p12, con * rh);
          lon = Proj4js.common.adjust_lon(this.long0 + Math.atan2(p.x * sinz * this.cos_p12, con * rh));
        }
      }
    }

    p.x = lon;
    p.y = lat;
    return p;
  }
};
/* ======================================================================
    projCode/moll.js
   ====================================================================== */

/*******************************************************************************
NAME                            MOLLWEIDE

PURPOSE:	Transforms input longitude and latitude to Easting and
        Northing for the MOllweide projection.  The
        longitude and latitude must be in radians.  The Easting
        and Northing values will be returned in meters.

PROGRAMMER              DATE
----------              ----
D. Steinwand, EROS      May, 1991;  Updated Sept, 1992; Updated Feb, 1993
S. Nelson, EDC		Jun, 2993;	Made corrections in precision and
                    number of iterations.

ALGORITHM REFERENCES

1.  Snyder, John P. and Voxland, Philip M., "An Album of Map Projections",
    U.S. Geological Survey Professional Paper 1453 , United State Government
    Printing Office, Washington D.C., 1989.

2.  Snyder, John P., "Map Projections--A Working Manual", U.S. Geological
    Survey Professional Paper 1395 (Supersedes USGS Bulletin 1532), United
    State Government Printing Office, Washington D.C., 1987.
*******************************************************************************/

Proj4js.Proj.moll = {

  /* Initialize the Mollweide projection
    ------------------------------------*/
  init: function init() {
    //no-op
  },

  /* Mollweide forward equations--mapping lat,long to x,y
    ----------------------------------------------------*/
  forward: function forward(p) {

    /* Forward equations
      -----------------*/
    var lon = p.x;
    var lat = p.y;

    var delta_lon = Proj4js.common.adjust_lon(lon - this.long0);
    var theta = lat;
    var con = Proj4js.common.PI * Math.sin(lat);

    /* Iterate using the Newton-Raphson method to find theta
      -----------------------------------------------------*/
    for (var i = 0; true; i++) {
      var delta_theta = -(theta + Math.sin(theta) - con) / (1.0 + Math.cos(theta));
      theta += delta_theta;
      if (Math.abs(delta_theta) < Proj4js.common.EPSLN) break;
      if (i >= 50) {
        Proj4js.reportError("moll:Fwd:IterationError");
        //return(241);
      }
    }
    theta /= 2.0;

    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       --------------------------------------------------------------------------*/
    if (Proj4js.common.PI / 2 - Math.abs(lat) < Proj4js.common.EPSLN) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;

    p.x = x;
    p.y = y;
    return p;
  },

  inverse: function inverse(p) {
    var theta;
    var arg;

    /* Inverse equations
      -----------------*/
    p.x -= this.x0;
    //~ p.y -= this.y0;
    var arg = p.y / (1.4142135623731 * this.a);

    /* Because of division by zero problems, 'arg' can not be 1.0.  Therefore
       a number very close to one is used instead.
       -------------------------------------------------------------------*/
    if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    var theta = Math.asin(arg);
    var lon = Proj4js.common.adjust_lon(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)));
    if (lon < -Proj4js.common.PI) lon = -Proj4js.common.PI;
    if (lon > Proj4js.common.PI) lon = Proj4js.common.PI;
    arg = (2.0 * theta + Math.sin(2.0 * theta)) / Proj4js.common.PI;
    if (Math.abs(arg) > 1.0) arg = 1.0;
    var lat = Math.asin(arg);
    //return(OK);

    p.x = lon;
    p.y = lat;
    return p;
  }
};

window.Proj4js = Proj4js;

/* harmony default export */ __webpack_exports__["a"] = (Proj4js);

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_es6_promise__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_leaflet__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_leaflet_draw__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_leaflet_draw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_leaflet_draw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_leaflet_easybutton__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_leaflet_easybutton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_leaflet_easybutton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_leaflet_fullscreen__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_leaflet_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_leaflet_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_proj4_dist_proj4_src_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_proj4_dist_proj4_src_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_proj4_dist_proj4_src_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_polyfill__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_webrtc_adapter__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_webrtc_adapter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_webrtc_adapter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_store__ = __webpack_require__(495);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















__WEBPACK_IMPORTED_MODULE_5_es6_promise___default.a.polyfill();

delete __WEBPACK_IMPORTED_MODULE_7_leaflet___default.a.Icon.Default.prototype._getIconUrl;

__WEBPACK_IMPORTED_MODULE_7_leaflet___default.a.Icon.Default.mergeOptions({
  iconRetinaUrl: __webpack_require__(505),
  iconUrl: __webpack_require__(506),
  shadowUrl: __webpack_require__(507)
});

window.proj4 = __WEBPACK_IMPORTED_MODULE_11_proj4_dist_proj4_src_js__["default"];
window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.$ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window['moment'] = __WEBPACK_IMPORTED_MODULE_6_moment___default.a;
window['L'] = __WEBPACK_IMPORTED_MODULE_7_leaflet___default.a;
window.MotionUI = __webpack_require__(503);

// Values 
window['apikey'] = '';
window['user'] = '';
window['url'] = '';
window['version'] = '';
window['selectedDate'] = null;

__webpack_require__(493);
__webpack_require__(238);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(504);
var VueCookie = __webpack_require__(508);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(VueCookie);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function (request, next) {
  request.credentials = true;
  request.headers.set('Authorization', 'Basic ' + btoa('auth:' + window['apikey']));
  next();
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.credentials = true;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.xhr = {
  withCredentials: true
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.emulateHTTP = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.crossOrigin = true;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['Access-Control-Allow-Origin'] = '*';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['Content-Type'] = 'application/json';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['Accept'] = 'application/json';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_14__store_store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

$(document).foundation();

__WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale('da');

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__ = __webpack_require__(52);



var getOrientedImage = __webpack_require__(883);

var formUploadHandler = {
    data: function data() {
        return {
            base64: ''
        };
    },

    methods: {
        doremoveUpload: function doremoveUpload(uploadId) {

            console.log("UPLOADID removing", uploadId, this.localImages);

            var _this = this;

            _this.localImages = _this.localImages.filter(function (ul) {
                return ul.id != uploadId;
            });
            console.log("UploadId", uploadId);
            //_this.$emit('removeImagePopup', uploadId);

            __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].removeItem("MTTempImages", uploadId).then(function (result) {
                console.log("Image removed as well");
            });
        },
        process: function process(arrayB) {
            var dv = new DataView(new ArrayBuffer(arrayB.toString()));
            var offset = 0,
                recess = 0;
            var pieces = [];
            var i = 0;
            if (dv.getUint16(offset) == 0xffd8) {
                offset += 2;
                var app1 = dv.getUint16(offset);
                offset += 2;
                while (offset < dv.byteLength) {
                    if (app1 == 0xffe1) {

                        pieces[i] = { recess: recess, offset: offset - 2 };
                        recess = offset + dv.getUint16(offset);
                        i++;
                    } else if (app1 == 0xffda) {
                        break;
                    }
                    offset += dv.getUint16(offset);
                    var app1 = dv.getUint16(offset);
                    offset += 2;
                }
                if (pieces.length > 0) {
                    var newPieces = [];
                    pieces.forEach(function (v) {
                        newPieces.push(arrayB.slice(v.recess, v.offset));
                    }, this);
                    newPieces.push(arrayB.slice(recess));
                    return new Blob(newPieces, { type: 'image/jpeg' });
                }
            }
        },
        gotUpload: function gotUpload(event) {
            var _this = this;

            var file = '';
            var res = '';
            var fullres = '';
            var fullimg = '';

            console.log("gotUpload : event", event);

            if (event.target.files.length == 1 && event.target.files[0].type.indexOf("image/") == 0) {

                var reader = new FileReader();

                reader.onload = function (theFile) {

                    var imageId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["b" /* mongoObjectId */])();
                    var customerId;

                    var randomNamePart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["b" /* mongoObjectId */])();

                    var numberInIndexedDB = 1;
                    __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].iterate('MTTempImages', function (value, key, iterationNumber) {
                        console.log('value.projectId == _this.filteredResult.id', value.projectId == _this.filteredResult.id);
                        if (value.projectId == _this.filteredResult.id) {
                            numberInIndexedDB += 1;
                        }
                    });

                    var customer = JSON.parse(_this.$cookie.get('user'));

                    __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].getItem("MTUsers", "users").then(function (result) {

                        customerId = customer.id;
                        file = event.target.files[0];

                        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            getOrientedImage(file, function (err, canvas) {
                                if (!err) {
                                    canvas.toBlob(function (blob) {
                                        resolve(blob);
                                    }, 'image/jpeg', 1);
                                }
                            });
                        });
                    }).then(function (orientedImageBlob) {
                        new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            var arrayBuffer;
                            var fileReader = new FileReader();
                            fileReader.onload = function () {
                                var arrayBf = fileReader.result;
                                console.log("arrayBf", arrayBf);

                                //resolve(_this.process(this.result));
                                resolve(this.result);
                            };
                            fileReader.readAsArrayBuffer(orientedImageBlob);
                        }).then(function (orientedImageArrayBuffer) {
                            //Create thumbnail
                            fullres = orientedImageArrayBuffer;
                            return _this.createThumbnail(orientedImageArrayBuffer, event.target.files[0].type);
                        }).then(function (result) {
                            res = result;
                            return _this.createThumbnail(fullres, event.target.files[0].type, 800, 1);
                        }).then(function (result) {
                            fullimg = result;
                            console.log("result", result);
                            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                var readerFull = new window.FileReader();

                                readerFull.readAsDataURL(new Blob([new Uint8Array(result)]));
                                readerFull.onloadend = function () {
                                    var base64data = readerFull.result;
                                    resolve(base64data);
                                };
                            });
                        }).then(function (base64) {
                            console.log("base64 after", base64.length);
                            _this.base64 = base64;
                            var imageObj = {
                                "id": imageId,
                                "thumb": res,
                                "data": fullimg,
                                "base64": _this.base64,
                                "mongoObjectId": __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["b" /* mongoObjectId */])(),
                                "type": file.type,
                                "state": "saved",
                                "fileName": _this.filteredResult.maalernummer + '_' + numberInIndexedDB + '.jpg',
                                "filePath": "CustomerData\\" + customerId + "\\Projects\\" + _this.filteredResult.id,
                                "projectId": _this.filteredResult.id
                            };
                            console.log('imageObj', imageObj);

                            _this.localImages.push(imageObj);
                            return __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].setItem("MTTempImages", imageId, imageObj);
                        }).then(function (result) {
                            var uploadObj = {
                                "uploadId": __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["b" /* mongoObjectId */])(),
                                "fileName": _this.filteredResult.maalernummer + '_' + numberInIndexedDB + '.jpg',
                                "filePath": "CustomerData\\" + customerId + "\\Projects\\" + _this.filteredResult.id,
                                "createdDateTime": new Date().toISOString(),
                                "caption": "",
                                "tags": [],
                                "imageId": imageId
                            };
                            console.log('uploadObj', uploadObj);
                            _this.$store.dispatch('updateNotification', 1);
                            _this.$emit('uploadObj', uploadObj);

                            console.log("localImages", _this.localImages);

                            event.target.value = "";
                        });
                    });
                };
                reader.readAsArrayBuffer(event.target.files[0]);
            }
        },
        gotScreenshot: function gotScreenshot(base64Image) {
            var _this = this;

            var file = this.dataURLtoFile(base64Image, 'Screenshot');
            var res = '';
            var fullres = '';
            var fullimg = '';

            var reader = new FileReader();

            reader.onload = function (theFile) {

                var imageId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["b" /* mongoObjectId */])();
                var customerId;

                var randomNamePart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["b" /* mongoObjectId */])();

                var numberInIndexedDB = 1;
                __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].iterate('MTTempImages', function (value, key, iterationNumber) {
                    console.log('value.projectId == _this.filteredResult.id', value.projectId == _this.filteredResult.id);
                    if (value.projectId == _this.filteredResult.id) {
                        numberInIndexedDB += 1;
                    }
                });

                var customer = JSON.parse(_this.$cookie.get('user'));

                __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].getItem("MTUsers", "users").then(function (result) {

                    customerId = customer.id;

                    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        getOrientedImage(file, function (err, canvas) {
                            if (!err) {
                                canvas.toBlob(function (blob) {
                                    resolve(blob);
                                }, 'image/jpeg', 1);
                            }
                        });
                    });
                }).then(function (orientedImageBlob) {
                    new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        var arrayBuffer;
                        var fileReader = new FileReader();
                        fileReader.onload = function () {
                            var arrayBf = fileReader.result;
                            console.log("arrayBf", arrayBf);

                            //resolve(_this.process(this.result));
                            resolve(this.result);
                        };
                        fileReader.readAsArrayBuffer(orientedImageBlob);
                    }).then(function (orientedImageArrayBuffer) {
                        //Create thumbnail
                        fullres = orientedImageArrayBuffer;
                        return _this.createThumbnail(orientedImageArrayBuffer, file.type);
                    }).then(function (result) {
                        res = result;
                        return _this.createThumbnail(fullres, file.type, 800, 1);
                    }).then(function (result) {
                        fullimg = result;
                        console.log("result", result);
                        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            var readerFull = new window.FileReader();

                            readerFull.readAsDataURL(new Blob([new Uint8Array(result)]));
                            readerFull.onloadend = function () {
                                var base64data = readerFull.result;
                                resolve(base64data);
                            };
                        });
                    }).then(function (base64) {
                        console.log("base64 after", base64.length);
                        _this.base64 = base64;
                        var imageObj = {
                            "id": imageId,
                            "thumb": res,
                            "data": fullimg,
                            "base64": _this.base64,
                            "mongoObjectId": __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["b" /* mongoObjectId */])(),
                            "type": file.type,
                            "state": "saved",
                            "fileName": _this.filteredResult.maalernummer + '_' + numberInIndexedDB + '.jpg',
                            "filePath": "CustomerData\\" + customerId + "\\Projects\\" + _this.filteredResult.id,
                            "projectId": _this.filteredResult.id
                        };
                        console.log('imageObj', imageObj);

                        _this.localImages.push(imageObj);
                        return __WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["a" /* default */].setItem("MTTempImages", imageId, imageObj);
                    }).then(function (result) {
                        var uploadObj = {
                            "uploadId": __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["b" /* mongoObjectId */])(),
                            "fileName": _this.filteredResult.maalernummer + '_' + numberInIndexedDB + '.jpg',
                            "filePath": "CustomerData\\" + customerId + "\\Projects\\" + _this.filteredResult.id,
                            "createdDateTime": new Date().toISOString(),
                            "caption": "",
                            "tags": [],
                            "imageId": imageId
                        };
                        console.log('uploadObj', uploadObj);
                        _this.$store.dispatch('updateNotification', 1);
                        _this.$emit('uploadObj', uploadObj);

                        console.log("localImages", _this.localImages);

                        // event.target.value = "";
                    });
                });
            };
            reader.readAsArrayBuffer(file);
        },
        dataURLtoFile: function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, { type: mime });
        },
        createThumbnail: function createThumbnail(image, type, width, quality) {
            if (width == undefined) {
                width = 254;
            }

            if (quality == undefined) {
                quality = 0.7;
            }

            var d = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                var dataView = new DataView(image),
                    fullImageBlob = new Blob([dataView], { type: type }),
                    canvas = document.createElement("canvas"),
                    ctx = canvas.getContext('2d'),
                    img = new Image();

                img.onload = function () {

                    var ratio = width / img.width;
                    var newHeight = ratio * img.height;

                    canvas.height = newHeight;
                    canvas.width = width;

                    ctx.drawImage(img, 0, 0, width, newHeight);

                    canvas.toBlob(function (blob) {

                        var fr = new FileReader();

                        fr.onload = function (event) {
                            //fr.result
                            resolve(fr.result);
                        };
                        fr.readAsArrayBuffer(blob);
                    }, 'image/jpeg', quality);
                };
                img.src = URL.createObjectURL(fullImageBlob);
            });

            return d;
        }
    },
    computed: {
        mongoid: function mongoid() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__js_Sync_dal__["b" /* mongoObjectId */])();
        }
    }

};

/* harmony default export */ __webpack_exports__["a"] = (formUploadHandler);

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 889:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clearQueue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function clearQueue(q) {
    var p = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();

    return q.reduce(function (prev, cur) {
        return prev.then(cur);
    }, p);
};

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 893:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 338,
	"./af.js": 338,
	"./ar": 345,
	"./ar-dz": 339,
	"./ar-dz.js": 339,
	"./ar-kw": 340,
	"./ar-kw.js": 340,
	"./ar-ly": 341,
	"./ar-ly.js": 341,
	"./ar-ma": 342,
	"./ar-ma.js": 342,
	"./ar-sa": 343,
	"./ar-sa.js": 343,
	"./ar-tn": 344,
	"./ar-tn.js": 344,
	"./ar.js": 345,
	"./az": 346,
	"./az.js": 346,
	"./be": 347,
	"./be.js": 347,
	"./bg": 348,
	"./bg.js": 348,
	"./bm": 349,
	"./bm.js": 349,
	"./bn": 351,
	"./bn-bd": 350,
	"./bn-bd.js": 350,
	"./bn.js": 351,
	"./bo": 352,
	"./bo.js": 352,
	"./br": 353,
	"./br.js": 353,
	"./bs": 354,
	"./bs.js": 354,
	"./ca": 355,
	"./ca.js": 355,
	"./cs": 356,
	"./cs.js": 356,
	"./cv": 357,
	"./cv.js": 357,
	"./cy": 358,
	"./cy.js": 358,
	"./da": 359,
	"./da.js": 359,
	"./de": 362,
	"./de-at": 360,
	"./de-at.js": 360,
	"./de-ch": 361,
	"./de-ch.js": 361,
	"./de.js": 362,
	"./dv": 363,
	"./dv.js": 363,
	"./el": 364,
	"./el.js": 364,
	"./en-au": 365,
	"./en-au.js": 365,
	"./en-ca": 366,
	"./en-ca.js": 366,
	"./en-gb": 367,
	"./en-gb.js": 367,
	"./en-ie": 368,
	"./en-ie.js": 368,
	"./en-il": 369,
	"./en-il.js": 369,
	"./en-in": 370,
	"./en-in.js": 370,
	"./en-nz": 371,
	"./en-nz.js": 371,
	"./en-sg": 372,
	"./en-sg.js": 372,
	"./eo": 373,
	"./eo.js": 373,
	"./es": 377,
	"./es-do": 374,
	"./es-do.js": 374,
	"./es-mx": 375,
	"./es-mx.js": 375,
	"./es-us": 376,
	"./es-us.js": 376,
	"./es.js": 377,
	"./et": 378,
	"./et.js": 378,
	"./eu": 379,
	"./eu.js": 379,
	"./fa": 380,
	"./fa.js": 380,
	"./fi": 381,
	"./fi.js": 381,
	"./fil": 382,
	"./fil.js": 382,
	"./fo": 383,
	"./fo.js": 383,
	"./fr": 386,
	"./fr-ca": 384,
	"./fr-ca.js": 384,
	"./fr-ch": 385,
	"./fr-ch.js": 385,
	"./fr.js": 386,
	"./fy": 387,
	"./fy.js": 387,
	"./ga": 388,
	"./ga.js": 388,
	"./gd": 389,
	"./gd.js": 389,
	"./gl": 390,
	"./gl.js": 390,
	"./gom-deva": 391,
	"./gom-deva.js": 391,
	"./gom-latn": 392,
	"./gom-latn.js": 392,
	"./gu": 393,
	"./gu.js": 393,
	"./he": 394,
	"./he.js": 394,
	"./hi": 395,
	"./hi.js": 395,
	"./hr": 396,
	"./hr.js": 396,
	"./hu": 397,
	"./hu.js": 397,
	"./hy-am": 398,
	"./hy-am.js": 398,
	"./id": 399,
	"./id.js": 399,
	"./is": 400,
	"./is.js": 400,
	"./it": 402,
	"./it-ch": 401,
	"./it-ch.js": 401,
	"./it.js": 402,
	"./ja": 403,
	"./ja.js": 403,
	"./jv": 404,
	"./jv.js": 404,
	"./ka": 405,
	"./ka.js": 405,
	"./kk": 406,
	"./kk.js": 406,
	"./km": 407,
	"./km.js": 407,
	"./kn": 408,
	"./kn.js": 408,
	"./ko": 409,
	"./ko.js": 409,
	"./ku": 410,
	"./ku.js": 410,
	"./ky": 411,
	"./ky.js": 411,
	"./lb": 412,
	"./lb.js": 412,
	"./lo": 413,
	"./lo.js": 413,
	"./lt": 414,
	"./lt.js": 414,
	"./lv": 415,
	"./lv.js": 415,
	"./me": 416,
	"./me.js": 416,
	"./mi": 417,
	"./mi.js": 417,
	"./mk": 418,
	"./mk.js": 418,
	"./ml": 419,
	"./ml.js": 419,
	"./mn": 420,
	"./mn.js": 420,
	"./mr": 421,
	"./mr.js": 421,
	"./ms": 423,
	"./ms-my": 422,
	"./ms-my.js": 422,
	"./ms.js": 423,
	"./mt": 424,
	"./mt.js": 424,
	"./my": 425,
	"./my.js": 425,
	"./nb": 426,
	"./nb.js": 426,
	"./ne": 427,
	"./ne.js": 427,
	"./nl": 429,
	"./nl-be": 428,
	"./nl-be.js": 428,
	"./nl.js": 429,
	"./nn": 430,
	"./nn.js": 430,
	"./oc-lnc": 431,
	"./oc-lnc.js": 431,
	"./pa-in": 432,
	"./pa-in.js": 432,
	"./pl": 433,
	"./pl.js": 433,
	"./pt": 435,
	"./pt-br": 434,
	"./pt-br.js": 434,
	"./pt.js": 435,
	"./ro": 436,
	"./ro.js": 436,
	"./ru": 437,
	"./ru.js": 437,
	"./sd": 438,
	"./sd.js": 438,
	"./se": 439,
	"./se.js": 439,
	"./si": 440,
	"./si.js": 440,
	"./sk": 441,
	"./sk.js": 441,
	"./sl": 442,
	"./sl.js": 442,
	"./sq": 443,
	"./sq.js": 443,
	"./sr": 445,
	"./sr-cyrl": 444,
	"./sr-cyrl.js": 444,
	"./sr.js": 445,
	"./ss": 446,
	"./ss.js": 446,
	"./sv": 447,
	"./sv.js": 447,
	"./sw": 448,
	"./sw.js": 448,
	"./ta": 449,
	"./ta.js": 449,
	"./te": 450,
	"./te.js": 450,
	"./tet": 451,
	"./tet.js": 451,
	"./tg": 452,
	"./tg.js": 452,
	"./th": 453,
	"./th.js": 453,
	"./tk": 454,
	"./tk.js": 454,
	"./tl-ph": 455,
	"./tl-ph.js": 455,
	"./tlh": 456,
	"./tlh.js": 456,
	"./tr": 457,
	"./tr.js": 457,
	"./tzl": 458,
	"./tzl.js": 458,
	"./tzm": 460,
	"./tzm-latn": 459,
	"./tzm-latn.js": 459,
	"./tzm.js": 460,
	"./ug-cn": 461,
	"./ug-cn.js": 461,
	"./uk": 462,
	"./uk.js": 462,
	"./ur": 463,
	"./ur.js": 463,
	"./uz": 465,
	"./uz-latn": 464,
	"./uz-latn.js": 464,
	"./uz.js": 465,
	"./vi": 466,
	"./vi.js": 466,
	"./x-pseudo": 467,
	"./x-pseudo.js": 467,
	"./yo": 468,
	"./yo.js": 468,
	"./zh-cn": 469,
	"./zh-cn.js": 469,
	"./zh-hk": 470,
	"./zh-hk.js": 470,
	"./zh-mo": 471,
	"./zh-mo.js": 471,
	"./zh-tw": 472,
	"./zh-tw.js": 472
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 915;

/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomError", function() { return CustomError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customErrorFactory", function() { return customErrorFactory; });
function fixProto(target, prototype) {
  var setPrototypeOf = Object.setPrototypeOf;
  setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
}
function fixStack(target, fn) {
  if (fn === void 0) {
    fn = target.constructor;
  }

  var captureStackTrace = Error.captureStackTrace;
  captureStackTrace && captureStackTrace(target, fn);
}

var __extends = undefined && undefined.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } }
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var CustomError = function (_super) {
  __extends(CustomError, _super);

  function CustomError(message) {
    var _newTarget = this.constructor;

    var _this = _super.call(this, message) || this;

    Object.defineProperty(_this, 'name', {
      value: _newTarget.name,
      enumerable: false,
      configurable: true
    });
    fixProto(_this, _newTarget.prototype);
    fixStack(_this);
    return _this;
  }

  return CustomError;
}(Error);

var __spreadArrays = undefined && undefined.__spreadArrays || function () {
  var arguments$1 = arguments;

  for (var s = 0, i = 0, il = arguments.length; i < il; i++) { s += arguments$1[i].length; }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) { for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) { r[k] = a[j]; } }

  return r;
};
function customErrorFactory(fn, parent) {
  if (parent === void 0) {
    parent = Error;
  }

  function CustomError() {
    var arguments$1 = arguments;

    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments$1[_i];
    }

    if (!(this instanceof CustomError)) { return new (CustomError.bind.apply(CustomError, __spreadArrays([void 0], args)))(); }
    parent.apply(this, args);
    Object.defineProperty(this, 'name', {
      value: fn.name || parent.name,
      enumerable: false,
      configurable: true
    });
    fn.apply(this, args);
    fixStack(this, CustomError);
  }

  return Object.defineProperties(CustomError, {
    prototype: {
      value: Object.create(parent.prototype, {
        constructor: {
          value: CustomError,
          writable: true,
          configurable: true
        }
      })
    }
  });
}


//# sourceMappingURL=custom-error.mjs.map


/***/ }),

/***/ 984:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQuMzk0IDI0LjM5NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQuMzk0IDI0LjM5NDsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+DQo8Zz4NCgk8ZyBpZD0iYjgwX2Zvb2QiPg0KCQk8Y2lyY2xlIGN4PSIxMi4xOTciIGN5PSIxMi4xOTciIHI9IjEyLjE5NyIgZmlsbD0iIzQyNDI0MiIvPg0KCTwvZz4NCgk8ZyBpZD0iQ2FwYV8xXzgyXyI+DQoJPC9nPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQuMzk0IDI0LjM5NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQuMzk0IDI0LjM5NDsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+DQo8Zz4NCgk8ZyBpZD0iYjgwX2Zvb2QiPg0KCQk8Y2lyY2xlIGN4PSIxMi4xOTciIGN5PSIxMi4xOTciIHI9IjEyLjE5NyIgZmlsbD0iIzJlY2M3MSIvPg0KCTwvZz4NCgk8ZyBpZD0iQ2FwYV8xXzgyXyI+DQoJPC9nPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 986:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8AAAAMcAQMAAACl5F6MAAAABlBMVEW8vsDn6OnyCdevAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEbUlEQVR4AezBMQEAAADCoPVP7WsIoAcAAAAAAAAAAAAAAAAAAAAAAIydO0iOk4eCAGyVXNEuukF0FB1NHE1H0RG0ZEHRf5A99WYMk1T+Kvolw+vVjBf+CkMLoRCFWQkuqCquB3QOOQKrCpwBKJ1i6Jxk/EzTubaArgAHQOeyjhu8aMEafUrYolLjLRMfLrpw5cMYadeBnTLcrwN7ZXi+DhyuCi8GG/xy8Gyw3SRe7n7cLzfnajah5z87keFJ//lYf0WAAq+vv+rDX+fir+zpr2Xqr95qrle/ywr9OxX+/nF19fGRmR/yrzCJCudRqNHiNDHhIlquTBgCF2aX3V2BwYT9nUYdNoNojnqjiKJ56q0xiRaok4EsWqQO2EW0RJ3wQbTMvDc6iFaYswEvkx5Hnf8E0Tx1xhcfj3gh1lhOLHVWnx8vLvBq/FAnYpGBhwEElVfjhyETjVjj5bFanATpLrHIcpDkIstpJRdZLmRykaW63CLLMZKLLGeVXGS5jvlFluZKq8k1lnGMXGMZuck1lnsVu8ZydybXWOYj5BrLDIxcY5lz8mrML/JupPIC02osf3tyjeVqY9dYikys8QlTAUIsFovFYrFYLJaIP8hq8D4GG2ywwQYbbLDBBhtssMEGG2ywwQYb3N9+G/ePwQYbbLDBBhtssMEGG5yhA3ugqcARmFXgDKwqcAGgAsu+J1zYy94UXDjIRxosH+crwUm2euHCWX43Fy7YciUYI9N1YIeRavDpsMdIM9jgs+BOh4PBavA3ras6aMFRC06TEpyrLsy/H5emBKOrwvxZpsOsA3ssOk8SQQ9edZ4WI6DzfJwU4Ym/FCE7ofFXfQoJlnUugRsHdl9GTKBzlxRF6vzVW9kngr5eLTB5hT6MUhPgLfdDRhwQCQ79TQXe756tAWcp10XgIuMYF8aWxoedLtz5sB/wzIeDLrzw4QiRqHBSgOvnwLWFCrc7eCLCbnwrXFh2ZMdHKhEOyx3ciHBch8OHE2TtCZ0IZ0wCz1S4jhGTDhc0ecN9IcLja/qEVwIswqwC+/H3zfgMDw7j95cbPBFg+YEKnIaGWyoNzpvmcEujws0rwGX7LnCnwWOgDLhlZsFuaJEP+zFCC7yw4DCAhFtWFhwHl/lwwpeowRMJzlpw+QpXEgwl2O3gxoH9Du4cOOzgmQNHLTjt4OXF4byDVw5csAsHhhLssM/EgD32qQw4aMER+zQtuDPgpAVn7DMz4IJ9FgYMJdgdwSsB9jgKAQ5acDyEJy24ng8nLTgfwu18uBzC/XwYSrA7hmfCeyCHWU6Hw18Gr4R3fY5zOpy04PwEngj/KfYw9WwYSrB7BjfCW4qH6a8Kh2fwTHgF9jDLyXDSgvMzeKW8UX6Uk2Eowe45PL0m7J/D9VQ4aMG/isH/JwYbbLDBBhtssMEGG2ywtz3K/2tvDmQAAAAABvlbn+NbCSQWi8VisVgsFovFYrFYLBYvAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEHVJjR5bJLd8AAAAASUVORK5CYII="

/***/ }),

/***/ 987:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lyngbyTaarbæk-logo.e5dbb24.png";

/***/ }),

/***/ 989:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MjAgMTc3Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2JhMTIyMzt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPm5pcmFzX2xvZ29fbmV3PC90aXRsZT48cGF0aCBpZD0ibmlyYXMiIGNsYXNzPSJjbHMtMSIgZD0iTTc5LjgyLDEyNi43NSwzNy41NCw4Mi40Nkg2djgzLjIxSDMxLjVsMi42OC01MC4zMyw0OS42Niw1MC4zM2gyNC44M1Y4Mi40Nkg4Mi41Wk0xMzMuNSw4Mi40NkgxNjF2ODMuMjFIMTMzLjVabTE0NS42MiwyNC44M2MtMS4zNC0yMS40Ny0yNC44My0yNS41LTQzLjYyLTI2LjE3LTE1LjQzLDAtNTEsMS4zNC01MSwxLjM0djgzLjIxaDI0LjgzbDQtNjYuNDNzMTAuMDctLjY3LDE2Ljc4LS42N2MxMC43NCwwLDE4LjEyLDQsMTguNzksMTAuNzRzLTIsMTQuNzYtMjYuMTcsMTQuNzZ2MTMuNDJsMjYuODQsMjguODZoMjguODZMMjU3LDEzNi4xNGMuNjctLjY3LDIzLjQ5LTYuNzEsMjIuMTQtMjguODZtOTYtMjQuODNIMzM0LjE1cy00LDYtMTcuNDUsMzIuODhjLTE4LjEyLTE0Ljc2LTIyLjgyLTM0LjIyLTI0LjE2LTQzLjYyaC0uNjd2MzUuNTdhNTguMjUsNTguMjUsMCwwLDAsMTUuNDMsMjguMThDMjk1LjIzLDE2MC4zLDI5My4yMSwxNjUsMjkzLjIxLDE2NWgyNi44NGw4LjcyLTE2LjExaDBhODguOCw4OC44LDAsMCwwLDI2LjE3LDQuN1YxMzAuNzdhNTUuNTIsNTUuNTIsMCwwLDEtMTQuNzYtMi42OGwxMy40Mi0yNC4xNiwzNC44OSw2MS43NGgyNi44NFM0MTIsMTU3LjYxLDM5NC41NCwxMjJjLTE1LjQzLTMzLjU1LTE5LjQ2LTM5LjU5LTE5LjQ2LTM5LjU5bTkzLjI4LDI4Ljg2Yy04LjcyLS42Ny0xMy40Mi0yLjY4LTEzLjQyLTYuNzEsMC01LjM3LDYuNzEtNy4zOCwyMC44LTcuMzhzMzIuODgsMi42OCwzMi44OCwyLjY4VjgwLjQ0YTMxMS41NCwzMTEuNTQsMCwwLDAtNDIuMjgtMmMtNy4zOCwwLTQyLjk1LDAtNDIuOTUsMjguMTgsMCwyNi44NCwzNC44OSwyNy41MSw0OS42NiwyOC4xOCw1LjM3LDAsMTEuNDEsMS4zNCwxMS40MSw1LjM3LjY3LDYuNzEtMTAuMDcsNy4zOC0yNi4xNyw3LjM4YTE0Mi4yOCwxNDIuMjgsMCwwLDEtMzEuNTQtNHYyMC44UzQ0OC45LDE2Nyw0NjUuNjcsMTY3YzcuMzgsMCw0OSwxLjM0LDQ4LjMyLTI4LjE4LjY3LTI5LjUzLTMyLjg4LTI2Ljg0LTQ1LjYzLTI3LjUxTTMxMCw3NC40YzMuMzYtMTguMTIsMjEuNDctMzcuNTgsNDUuNjMtMzguOTJWMTBDMzIwLjczLDE0LDMwNy4zLDQ0LjIxLDMwOCw2MS42NWMuNjcsNCwuNjcsOC43MiwyLDEyLjc1WiIvPjwvc3ZnPg=="

/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/novafos.fce0aaa.jpg";

/***/ }),

/***/ 991:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQuMzk0IDI0LjM5NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQuMzk0IDI0LjM5NDsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+DQo8Zz4NCgk8ZyBpZD0iYjgwX2Zvb2QiPg0KCQk8Y2lyY2xlIGN4PSIxMi4xOTciIGN5PSIxMi4xOTciIHI9IjEyLjE5NyIgZmlsbD0iI2U3NGMzYyIvPg0KCTwvZz4NCgk8ZyBpZD0iQ2FwYV8xXzgyXyI+DQoJPC9nPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 992:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 993:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1011),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(890)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1008),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(891)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1009),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(892)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1012),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(893)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1013),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1007),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[564]);


// WEBPACK FOOTER //
// static/js/app.12222c3d26dfd06665ef.js